
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1912"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1912"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = "function" === typeof Symbol && Symbol.for, $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$n ? Symbol.for("react.element") : 60103, $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$n ? Symbol.for("react.portal") : 60106, $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$n ? Symbol.for("react.fragment") : 60107, $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$n ? Symbol.for("react.strict_mode") : 60108, $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$n ? Symbol.for("react.profiler") : 60114, $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$n ? Symbol.for("react.provider") : 60109, $1c29a66706a62afd$var$w = $1c29a66706a62afd$var$n ? Symbol.for("react.context") : 60110, $1c29a66706a62afd$var$x = $1c29a66706a62afd$var$n ? Symbol.for("react.forward_ref") : 60112, $1c29a66706a62afd$var$y = $1c29a66706a62afd$var$n ? Symbol.for("react.suspense") : 60113, $1c29a66706a62afd$var$z = $1c29a66706a62afd$var$n ? Symbol.for("react.memo") : 60115, $1c29a66706a62afd$var$A = $1c29a66706a62afd$var$n ? Symbol.for("react.lazy") : 60116, $1c29a66706a62afd$var$B = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$E = {};
function $1c29a66706a62afd$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$E;
    this.updater = c || $1c29a66706a62afd$var$D;
}
$1c29a66706a62afd$var$F.prototype.isReactComponent = {};
$1c29a66706a62afd$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$G() {}
$1c29a66706a62afd$var$G.prototype = $1c29a66706a62afd$var$F.prototype;
function $1c29a66706a62afd$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$E;
    this.updater = c || $1c29a66706a62afd$var$D;
}
var $1c29a66706a62afd$var$I = $1c29a66706a62afd$var$H.prototype = new $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$I.constructor = $1c29a66706a62afd$var$H;
$8coUR($1c29a66706a62afd$var$I, $1c29a66706a62afd$var$F.prototype);
$1c29a66706a62afd$var$I.isPureReactComponent = !0;
var $1c29a66706a62afd$var$J = {
    current: null
}, $1c29a66706a62afd$var$K = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$1c29a66706a62afd$var$K.call(b, e) && !$1c29a66706a62afd$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $1c29a66706a62afd$var$J.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$p;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g, $1c29a66706a62afd$var$Q = [];
function $1c29a66706a62afd$var$R(a, b, c, e) {
    if ($1c29a66706a62afd$var$Q.length) {
        var d = $1c29a66706a62afd$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $1c29a66706a62afd$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $1c29a66706a62afd$var$Q.length && $1c29a66706a62afd$var$Q.push(a);
}
function $1c29a66706a62afd$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$p:
                case $1c29a66706a62afd$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $1c29a66706a62afd$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $1c29a66706a62afd$var$U(d, k);
        g += $1c29a66706a62afd$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $1c29a66706a62afd$var$B && a[$1c29a66706a62afd$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $1c29a66706a62afd$var$U(d, k++), g += $1c29a66706a62afd$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($1c29a66706a62afd$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $1c29a66706a62afd$var$V(a, b, c) {
    return null == a ? 0 : $1c29a66706a62afd$var$T(a, "", b, c);
}
function $1c29a66706a62afd$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape(a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $1c29a66706a62afd$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $1c29a66706a62afd$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($1c29a66706a62afd$var$O(a) && (a = $1c29a66706a62afd$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + c)), e.push(a));
}
function $1c29a66706a62afd$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($1c29a66706a62afd$var$P, "$&/") + "/");
    b = $1c29a66706a62afd$var$R(b, g, e, d);
    $1c29a66706a62afd$var$V(a, $1c29a66706a62afd$var$aa, b);
    $1c29a66706a62afd$var$S(b);
}
var $1c29a66706a62afd$var$Y = {
    current: null
};
function $1c29a66706a62afd$var$Z() {
    var a = $1c29a66706a62afd$var$Y.current;
    if (null === a) throw Error($1c29a66706a62afd$var$C(321));
    return a;
}
var $1c29a66706a62afd$var$ba = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $1c29a66706a62afd$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $1c29a66706a62afd$var$R(null, null, b, c);
        $1c29a66706a62afd$var$V(a, $1c29a66706a62afd$var$W, b);
        $1c29a66706a62afd$var$S(b);
    },
    count: function(a) {
        return $1c29a66706a62afd$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $1c29a66706a62afd$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error($1c29a66706a62afd$var$C(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$F;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$u;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$H;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$t;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$y;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$ba;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$C(267, a));
    var e = $8coUR({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $1c29a66706a62afd$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$1c29a66706a62afd$var$K.call(b, h) && !$1c29a66706a62afd$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$Z().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$Z().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$Z().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$Z().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$Z().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $fO90s.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $fO90s.unstable_UserBlockingPriority, ed = $fO90s.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$8coUR(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $8coUR(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $8coUR({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $8coUR({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $fO90s.unstable_runWithPriority, Jf = $fO90s.unstable_scheduleCallback, Kf = $fO90s.unstable_cancelCallback, Lf = $fO90s.unstable_requestPaint, Mf = $fO90s.unstable_now, Nf = $fO90s.unstable_getCurrentPriorityLevel, Of = $fO90s.unstable_ImmediatePriority, Pf = $fO90s.unstable_UserBlockingPriority, Qf = $fO90s.unstable_NormalPriority, Rf = $fO90s.unstable_LowPriority, Sf = $fO90s.unstable_IdlePriority, Tf = {}, Uf = $fO90s.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $8coUR({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $acw62.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $8coUR({}, f, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $8coUR({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($8coUR({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k, $bcb017604639e9d7$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$p = null, $bcb017604639e9d7$var$q = null, $bcb017604639e9d7$var$t = function() {
        if (null !== $bcb017604639e9d7$var$p) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$p(!0, a);
            $bcb017604639e9d7$var$p = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$t, 0), b;
        }
    }, $bcb017604639e9d7$var$u = Date.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return Date.now() - $bcb017604639e9d7$var$u;
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$p ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$p = a, setTimeout($bcb017604639e9d7$var$t, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$q = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$q);
    };
    $bcb017604639e9d7$var$k = function() {
        return !1;
    };
    $bcb017604639e9d7$var$l = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$w = window.performance, $bcb017604639e9d7$var$x = window.Date, $bcb017604639e9d7$var$y = window.setTimeout, $bcb017604639e9d7$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $bcb017604639e9d7$var$w && "function" === typeof $bcb017604639e9d7$var$w.now) $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$w.now();
    };
    else {
        var $bcb017604639e9d7$var$B = $bcb017604639e9d7$var$x.now();
        $bcb017604639e9d7$export$c4744153514ff05d = function() {
            return $bcb017604639e9d7$var$x.now() - $bcb017604639e9d7$var$B;
        };
    }
    var $bcb017604639e9d7$var$C = !1, $bcb017604639e9d7$var$D = null, $bcb017604639e9d7$var$E = -1, $bcb017604639e9d7$var$F = 5, $bcb017604639e9d7$var$G = 0;
    $bcb017604639e9d7$var$k = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$G;
    };
    $bcb017604639e9d7$var$l = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $bcb017604639e9d7$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$H = new MessageChannel, $bcb017604639e9d7$var$I = $bcb017604639e9d7$var$H.port2;
    $bcb017604639e9d7$var$H.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$D) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$G = a + $bcb017604639e9d7$var$F;
            try {
                $bcb017604639e9d7$var$D(!0, a) ? $bcb017604639e9d7$var$I.postMessage(null) : ($bcb017604639e9d7$var$C = !1, $bcb017604639e9d7$var$D = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$I.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$C = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$D = a;
        $bcb017604639e9d7$var$C || ($bcb017604639e9d7$var$C = !0, $bcb017604639e9d7$var$I.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$E = $bcb017604639e9d7$var$y(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$z($bcb017604639e9d7$var$E);
        $bcb017604639e9d7$var$E = -1;
    };
}
function $bcb017604639e9d7$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$K(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$N = [], $bcb017604639e9d7$var$O = [], $bcb017604639e9d7$var$P = 1, $bcb017604639e9d7$var$Q = null, $bcb017604639e9d7$var$R = 3, $bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$T = !1, $bcb017604639e9d7$var$U = !1;
function $bcb017604639e9d7$var$V(a) {
    for(var b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$M($bcb017604639e9d7$var$O);
        else if (b.startTime <= a) $bcb017604639e9d7$var$M($bcb017604639e9d7$var$O), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$J($bcb017604639e9d7$var$N, b);
        else break;
        b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O);
    }
}
function $bcb017604639e9d7$var$W(a) {
    $bcb017604639e9d7$var$U = !1;
    $bcb017604639e9d7$var$V(a);
    if (!$bcb017604639e9d7$var$T) {
        if (null !== $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N)) $bcb017604639e9d7$var$T = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$X);
        else {
            var b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$W, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$X(a, b) {
    $bcb017604639e9d7$var$T = !1;
    $bcb017604639e9d7$var$U && ($bcb017604639e9d7$var$U = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$S = !0;
    var c = $bcb017604639e9d7$var$R;
    try {
        $bcb017604639e9d7$var$V(b);
        for($bcb017604639e9d7$var$Q = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N); null !== $bcb017604639e9d7$var$Q && (!($bcb017604639e9d7$var$Q.expirationTime > b) || a && !$bcb017604639e9d7$var$k());){
            var d = $bcb017604639e9d7$var$Q.callback;
            if (null !== d) {
                $bcb017604639e9d7$var$Q.callback = null;
                $bcb017604639e9d7$var$R = $bcb017604639e9d7$var$Q.priorityLevel;
                var e = d($bcb017604639e9d7$var$Q.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$Q.callback = e : $bcb017604639e9d7$var$Q === $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N) && $bcb017604639e9d7$var$M($bcb017604639e9d7$var$N);
                $bcb017604639e9d7$var$V(b);
            } else $bcb017604639e9d7$var$M($bcb017604639e9d7$var$N);
            $bcb017604639e9d7$var$Q = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N);
        }
        if (null !== $bcb017604639e9d7$var$Q) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$Q = null, $bcb017604639e9d7$var$R = c, $bcb017604639e9d7$var$S = !1;
    }
}
function $bcb017604639e9d7$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $bcb017604639e9d7$var$Z = $bcb017604639e9d7$var$l;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$T || $bcb017604639e9d7$var$S || ($bcb017604639e9d7$var$T = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$X));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$R;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$R;
    }
    var c = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$R = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$R = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$Z;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$R = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$R = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $bcb017604639e9d7$var$Y(a);
    } else c = $bcb017604639e9d7$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $bcb017604639e9d7$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $bcb017604639e9d7$var$J($bcb017604639e9d7$var$O, a), null === $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N) && a === $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O) && ($bcb017604639e9d7$var$U ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$U = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$W, e - d))) : (a.sortIndex = c, $bcb017604639e9d7$var$J($bcb017604639e9d7$var$N, a), $bcb017604639e9d7$var$T || $bcb017604639e9d7$var$S || ($bcb017604639e9d7$var$T = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$X)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = function() {
    var a = $bcb017604639e9d7$export$c4744153514ff05d();
    $bcb017604639e9d7$var$V(a);
    var b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N);
    return b !== $bcb017604639e9d7$var$Q && null !== $bcb017604639e9d7$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $bcb017604639e9d7$var$Q.expirationTime || $bcb017604639e9d7$var$k();
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$R;
    return function() {
        var c = $bcb017604639e9d7$var$R;
        $bcb017604639e9d7$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$R = c;
        }
    };
};

});




parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");














window.FontAwesomeKitConfig = {
    "asyncLoading": {
        "enabled": false
    },
    "autoA11y": {
        "enabled": true
    },
    "baseUrl": "https://ka-f.fontawesome.com",
    "baseUrlKit": "https://kit.fontawesome.com",
    "detectConflictsUntil": null,
    "iconUploads": {},
    "id": 76408965,
    "license": "free",
    "method": "css",
    "minify": {
        "enabled": true
    },
    "token": "155de50665",
    "v4FontFaceShim": {
        "enabled": true
    },
    "v4shim": {
        "enabled": true
    },
    "v5FontFaceShim": {
        "enabled": false
    },
    "version": "5.15.4"
};
!function(t) {
    "function" == typeof define && define.amd ? define("kit-loader", t) : t();
}(function() {
    "use strict";
    function t(e) {
        return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t;
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        })(e);
    }
    function e(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = n, t;
    }
    function n(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(t);
            e && (o = o.filter(function(e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })), n.push.apply(n, o);
        }
        return n;
    }
    function o(t) {
        for(var o = 1; o < arguments.length; o++){
            var r = null != arguments[o] ? arguments[o] : {};
            o % 2 ? n(Object(r), !0).forEach(function(n) {
                e(t, n, r[n]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
            });
        }
        return t;
    }
    function r(t, e) {
        return function(t) {
            if (Array.isArray(t)) return t;
        }(t) || function(t, e) {
            if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
            var n = [], o = !0, r = !1, i = void 0;
            try {
                for(var c, a = t[Symbol.iterator](); !(o = (c = a.next()).done) && (n.push(c.value), !e || n.length !== e); o = !0);
            } catch (t) {
                r = !0, i = t;
            } finally{
                try {
                    o || null == a.return || a.return();
                } finally{
                    if (r) throw i;
                }
            }
            return n;
        }(t, e) || function(t, e) {
            if (!t) return;
            if ("string" == typeof t) return i(t, e);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === n && t.constructor && (n = t.constructor.name);
            if ("Map" === n || "Set" === n) return Array.from(t);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return i(t, e);
        }(t, e) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function i(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for(var n = 0, o = new Array(e); n < e; n++)o[n] = t[n];
        return o;
    }
    function c(t, e) {
        var n = e && e.addOn || "", o = e && e.baseFilename || t.license + n, r = e && e.minify ? ".min" : "", i = e && e.fileSuffix || t.method, c = e && e.subdir || t.method;
        return t.baseUrl + "/releases/" + ("latest" === t.version ? "latest" : "v".concat(t.version)) + "/" + c + "/" + o + r + "." + i;
    }
    function a(t) {
        return t.baseUrlKit + "/" + t.token + "/" + t.id + "/kit-upload.css";
    }
    function u(t, e) {
        var n = e || [
            "fa"
        ], o = "." + Array.prototype.join.call(n, ",."), r = t.querySelectorAll(o);
        Array.prototype.forEach.call(r, function(e) {
            var n = e.getAttribute("title");
            e.setAttribute("aria-hidden", "true");
            var o = !e.nextElementSibling || !e.nextElementSibling.classList.contains("sr-only");
            if (n && o) {
                var r = t.createElement("span");
                r.innerHTML = n, r.classList.add("sr-only"), e.parentNode.insertBefore(r, e.nextSibling);
            }
        });
    }
    var f, s = function() {}, d = "undefined" != typeof $parcel$global && void 0 !== $parcel$global.process && "function" == typeof $parcel$global.process.emit, l = "undefined" == typeof setImmediate ? setTimeout : setImmediate, h = [];
    function m() {
        for(var t = 0; t < h.length; t++)h[t][0](h[t][1]);
        h = [], f = !1;
    }
    function p(t, e) {
        h.push([
            t,
            e
        ]), f || (f = !0, l(m, 0));
    }
    function v(t) {
        var e = t.owner, n = e._state, o = e._data, r = t[n], i = t.then;
        if ("function" == typeof r) {
            n = "fulfilled";
            try {
                o = r(o);
            } catch (t) {
                w(i, t);
            }
        }
        y(i, o) || ("fulfilled" === n && b(i, o), "rejected" === n && w(i, o));
    }
    function y(e, n) {
        var o;
        try {
            if (e === n) throw new TypeError("A promises callback cannot return that same promise.");
            if (n && ("function" == typeof n || "object" === t(n))) {
                var r = n.then;
                if ("function" == typeof r) return r.call(n, function(t) {
                    o || (o = !0, n === t ? g(e, t) : b(e, t));
                }, function(t) {
                    o || (o = !0, w(e, t));
                }), !0;
            }
        } catch (t) {
            return o || w(e, t), !0;
        }
        return !1;
    }
    function b(t, e) {
        t !== e && y(t, e) || g(t, e);
    }
    function g(t, e) {
        "pending" === t._state && (t._state = "settled", t._data = e, p(S, t));
    }
    function w(t, e) {
        "pending" === t._state && (t._state = "settled", t._data = e, p(O, t));
    }
    function A(t) {
        t._then = t._then.forEach(v);
    }
    function S(t) {
        t._state = "fulfilled", A(t);
    }
    function O(t) {
        t._state = "rejected", A(t), !t._handled && d && $parcel$global.process.emit("unhandledRejection", t._data, t);
    }
    function j(t) {
        $parcel$global.process.emit("rejectionHandled", t);
    }
    function E(t) {
        if ("function" != typeof t) throw new TypeError("Promise resolver " + t + " is not a function");
        if (this instanceof E == !1) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
        this._then = [], function(t, e) {
            function n(t) {
                w(e, t);
            }
            try {
                t(function(t) {
                    b(e, t);
                }, n);
            } catch (t) {
                n(t);
            }
        }(t, this);
    }
    E.prototype = {
        constructor: E,
        _state: "pending",
        _then: null,
        _data: void 0,
        _handled: !1,
        then: function(t, e) {
            var n = {
                owner: this,
                then: new this.constructor(s),
                fulfilled: t,
                rejected: e
            };
            return !e && !t || this._handled || (this._handled = !0, "rejected" === this._state && d && p(j, this)), "fulfilled" === this._state || "rejected" === this._state ? p(v, n) : this._then.push(n), n.then;
        },
        catch: function(t) {
            return this.then(null, t);
        }
    }, E.all = function(t) {
        if (!Array.isArray(t)) throw new TypeError("You must pass an array to Promise.all().");
        return new E(function(e, n) {
            var o = [], r = 0;
            function i(t) {
                return r++, function(n) {
                    o[t] = n, --r || e(o);
                };
            }
            for(var c, a = 0; a < t.length; a++)(c = t[a]) && "function" == typeof c.then ? c.then(i(a), n) : o[a] = c;
            r || e(o);
        });
    }, E.race = function(t) {
        if (!Array.isArray(t)) throw new TypeError("You must pass an array to Promise.race().");
        return new E(function(e, n) {
            for(var o, r = 0; r < t.length; r++)(o = t[r]) && "function" == typeof o.then ? o.then(e, n) : e(o);
        });
    }, E.resolve = function(e) {
        return e && "object" === t(e) && e.constructor === E ? e : new E(function(t) {
            t(e);
        });
    }, E.reject = function(t) {
        return new E(function(e, n) {
            n(t);
        });
    };
    var _ = "function" == typeof Promise ? Promise : E;
    function F(t, e) {
        var n = e.fetch, o = e.XMLHttpRequest, r = e.token, i = t;
        return "URLSearchParams" in window ? (i = new URL(t)).searchParams.set("token", r) : i = i + "?token=" + encodeURIComponent(r), i = i.toString(), new _(function(t, e) {
            if ("function" == typeof n) n(i, {
                mode: "cors",
                cache: "default"
            }).then(function(t) {
                if (t.ok) return t.text();
                throw new Error("");
            }).then(function(e) {
                t(e);
            }).catch(e);
            else if ("function" == typeof o) {
                var r = new o;
                r.addEventListener("loadend", function() {
                    this.responseText ? t(this.responseText) : e(new Error(""));
                });
                [
                    "abort",
                    "error",
                    "timeout"
                ].map(function(t) {
                    r.addEventListener(t, function() {
                        e(new Error(""));
                    });
                }), r.open("GET", i), r.send();
            } else e(new Error(""));
        });
    }
    function P(t, e, n) {
        var o = t;
        return [
            [
                /(url\("?)\.\.\/\.\.\/\.\./g,
                function(t, n) {
                    return "".concat(n).concat(e);
                }
            ],
            [
                /(url\("?)\.\.\/webfonts/g,
                function(t, o) {
                    return "".concat(o).concat(e, "/releases/v").concat(n, "/webfonts");
                }
            ],
            [
                /(url\("?)https:\/\/kit-free([^.])*\.fontawesome\.com/g,
                function(t, n) {
                    return "".concat(n).concat(e);
                }
            ]
        ].forEach(function(t) {
            var e = r(t, 2), n = e[0], i = e[1];
            o = o.replace(n, i);
        }), o;
    }
    function C(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function() {}, r = e.document || r, i = u.bind(u, r, [
            "fa",
            "fab",
            "fas",
            "far",
            "fal",
            "fad",
            "fak"
        ]), f = Object.keys(t.iconUploads || {}).length > 0;
        t.autoA11y.enabled && n(i);
        var s = [
            {
                id: "fa-main",
                addOn: void 0
            }
        ];
        t.v4shim && t.v4shim.enabled && s.push({
            id: "fa-v4-shims",
            addOn: "-v4-shims"
        }), t.v5FontFaceShim && t.v5FontFaceShim.enabled && s.push({
            id: "fa-v5-font-face",
            addOn: "-v5-font-face"
        }), t.v4FontFaceShim && t.v4FontFaceShim.enabled && s.push({
            id: "fa-v4-font-face",
            addOn: "-v4-font-face"
        }), f && s.push({
            id: "fa-kit-upload",
            customCss: !0
        });
        var d = s.map(function(n) {
            return new _(function(r, i) {
                F(n.customCss ? a(t) : c(t, {
                    addOn: n.addOn,
                    minify: t.minify.enabled
                }), e).then(function(i) {
                    r(U(i, o(o({}, e), {}, {
                        baseUrl: t.baseUrl,
                        version: t.version,
                        id: n.id,
                        contentFilter: function(t, e) {
                            return P(t, e.baseUrl, e.version);
                        }
                    })));
                }).catch(i);
            });
        });
        return _.all(d);
    }
    function U(t, e) {
        var n = e.contentFilter || function(t, e) {
            return t;
        }, o = document.createElement("style"), r = document.createTextNode(n(t, e));
        return o.appendChild(r), o.media = "all", e.id && o.setAttribute("id", e.id), e && e.detectingConflicts && e.detectionIgnoreAttr && o.setAttributeNode(document.createAttribute(e.detectionIgnoreAttr)), o;
    }
    function k(t, e) {
        e.autoA11y = t.autoA11y.enabled, "pro" === t.license && (e.autoFetchSvg = !0, e.fetchSvgFrom = t.baseUrl + "/releases/" + ("latest" === t.version ? "latest" : "v".concat(t.version)) + "/svgs", e.fetchUploadedSvgFrom = t.uploadsUrl);
        var n = [];
        return t.v4shim.enabled && n.push(new _(function(n, r) {
            F(c(t, {
                addOn: "-v4-shims",
                minify: t.minify.enabled
            }), e).then(function(t) {
                n(I(t, o(o({}, e), {}, {
                    id: "fa-v4-shims"
                })));
            }).catch(r);
        })), n.push(new _(function(n, r) {
            F(c(t, {
                minify: t.minify.enabled
            }), e).then(function(t) {
                var r = I(t, o(o({}, e), {}, {
                    id: "fa-main"
                }));
                n(function(t, e) {
                    var n = e && void 0 !== e.autoFetchSvg ? e.autoFetchSvg : void 0, o = e && void 0 !== e.autoA11y ? e.autoA11y : void 0;
                    void 0 !== o && t.setAttribute("data-auto-a11y", o ? "true" : "false");
                    n && (t.setAttributeNode(document.createAttribute("data-auto-fetch-svg")), t.setAttribute("data-fetch-svg-from", e.fetchSvgFrom), t.setAttribute("data-fetch-uploaded-svg-from", e.fetchUploadedSvgFrom));
                    return t;
                }(r, e));
            }).catch(r);
        })), _.all(n);
    }
    function I(t, e) {
        var n = document.createElement("SCRIPT"), o = document.createTextNode(t);
        return n.appendChild(o), n.referrerPolicy = "strict-origin", e.id && n.setAttribute("id", e.id), e && e.detectingConflicts && e.detectionIgnoreAttr && n.setAttributeNode(document.createAttribute(e.detectionIgnoreAttr)), n;
    }
    function L(t) {
        var e, n = [], o = document, r = o.documentElement.doScroll, i = (r ? /^loaded|^c/ : /^loaded|^i|^c/).test(o.readyState);
        i || o.addEventListener("DOMContentLoaded", e = function() {
            for(o.removeEventListener("DOMContentLoaded", e), i = 1; e = n.shift();)e();
        }), i ? setTimeout(t, 0) : n.push(t);
    }
    function T(t) {
        "undefined" != typeof MutationObserver && new MutationObserver(t).observe(document, {
            childList: !0,
            subtree: !0
        });
    }
    try {
        if (window.FontAwesomeKitConfig) {
            var x = window.FontAwesomeKitConfig, M = {
                detectingConflicts: x.detectConflictsUntil && new Date <= new Date(x.detectConflictsUntil),
                detectionIgnoreAttr: "data-fa-detection-ignore",
                fetch: window.fetch,
                token: x.token,
                XMLHttpRequest: window.XMLHttpRequest,
                document: document
            }, D = document.currentScript, N = D ? D.parentElement : document.head;
            (function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return "js" === t.method ? k(t, e) : "css" === t.method ? C(t, e, function(t) {
                    L(t), T(t);
                }) : void 0;
            })(x, M).then(function(t) {
                t.map(function(t) {
                    try {
                        N.insertBefore(t, D ? D.nextSibling : null);
                    } catch (e) {
                        N.appendChild(t);
                    }
                }), M.detectingConflicts && D && L(function() {
                    D.setAttributeNode(document.createAttribute(M.detectionIgnoreAttr));
                    var t = function(t, e) {
                        var n = document.createElement("script");
                        return e && e.detectionIgnoreAttr && n.setAttributeNode(document.createAttribute(e.detectionIgnoreAttr)), n.src = c(t, {
                            baseFilename: "conflict-detection",
                            fileSuffix: "js",
                            subdir: "js",
                            minify: t.minify.enabled
                        }), n;
                    }(x, M);
                    document.body.appendChild(t);
                });
            }).catch(function(t) {
                console.error("".concat("Font Awesome Kit:", " ").concat(t));
            });
        }
    } catch (t) {
        console.error("".concat("Font Awesome Kit:", " ").concat(t));
    }
});



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $7149fcc68faf2e72$exports = {};
$7149fcc68faf2e72$exports = {
    "email": "kei18 [at] ieee.org / okumura.k [at] aist.go.jp\n",
    "name": {
        "familyName": {
            "en": "Okumura",
            "ja": "\u5965\u6751"
        },
        "firstName": {
            "en": "Keisuke",
            "ja": "\u572D\u7950"
        }
    },
    "pageDescription": "Researcher in AI and robotics, planning. Interested in controlling multiple moving agents.\n",
    "pageKeywords": "keisuke, okumura, kei18, \u5965\u6751, \u572D\u7950, \u5965\u6751\u572D\u7950"
};


var $8f307ee5a3069d8d$exports = {};
$8f307ee5a3069d8d$exports = {
    "selfIntroduction": {
        "en": '<p>Hi there! I study <em>intelligent collective behavior design for swarm agents</em>,\nusing techniques from a variety of fields such as planning, search, learning,\noptimization, robotics, multi-agent systems, and distributed computing.\nCurrently, I am affiliated with <a href="https://www.aist.go.jp/index_en.html">National Institute of Advanced Industrial Science and Technology (AIST), Japan</a> as a researcher.\nI received my Ph.D. from <a href="https://www.titech.ac.jp/">Tokyo Institute of Technology</a> in 2023, under the supervision of Prof. <a href="https://www.coord.c.titech.ac.jp/m/defago/">Xavier D\xe9fago</a> and then did a postdoc scholar at <a href="https://www.cam.ac.uk/">the University of Cambridge, UK</a>, working with Prof. <a href="https://www.proroklab.org">Amanda Prorok</a>.\n<p>The research outcomes have been pushed the boundaries of scalable multi-agent multi-robot systems. They have been used to win <a href="https://www.leagueofrobotrunners.org/">the international logistics automation competition sponsored by Amazon Robotics</a> (several times), and have been actually deployed in several warehouse companies, both without my involvement.\nIn other words, my algorithms are controlling countless robots right now.\nResearch collaborations are welcome!</p>\n',
        "ja": '<p>\u79FB\u52D5\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7FA4\u3092\u5927\u898F\u6A21\u306B\u5236\u5FA1\u3059\u308B\u3053\u3068\u306B\u8208\u5473\u304C\u3042\u308A,\n\u30D7\u30E9\u30F3\u30CB\u30F3\u30B0, \u63A2\u7D22, \u6700\u9069\u5316, \u5B66\u7FD2, \u30ED\u30DC\u30C6\u30A3\u30AF\u30B9, \u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u30B7\u30B9\u30C6\u30E0, \u5206\u6563\u30B3\u30F3\u30D4\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0\u306A\u3069\u306E\u77E5\u898B\u3092\u53D6\u308A\u5165\u308C\u3066\u7814\u7A76\u3092\u9032\u3081\u3066\u3044\u307E\u3059.\n\u73FE\u5728, <a href="https://www.aist.go.jp/">\u7523\u696D\u6280\u8853\u7DCF\u5408\u7814\u7A76\u6240 (AIST)</a>\u30FB<a href="https://www.airc.aist.go.jp/">\u4EBA\u5DE5\u77E5\u80FD\u7814\u7A76\u30BB\u30F3\u30BF\u30FC (AIRC)</a> \u306E\u7814\u7A76\u54E1\u3067\u3059.\n2023\u5E743\u6708\u306B\u535A\u58EB(\u5DE5\u5B66)\u3092<a href="https://www.titech.ac.jp/">\u6771\u4EAC\u5DE5\u696D\u5927\u5B66</a> \u60C5\u5831\u7406\u5DE5\u5B66\u9662\u3088\u308A\u53D6\u5F97\u3057 (\u6307\u5C0E\u6559\u54E1: <a href="https://www.coord.c.titech.ac.jp/m/defago/">D\xe9fago Xavier</a> \u6559\u6388),\n\u305D\u306E\u5F8C, <a href="https://www.cam.ac.uk/">\u30B1\u30F3\u30D6\u30EA\u30C3\u30B8\u5927\u5B66</a>\u3067\u30DD\u30B9\u30C9\u30AF\u7814\u7A76\u54E1\u3092\u3057\u3066\u3044\u307E\u3057\u305F (\u30DB\u30B9\u30C8: <a href="https://proroklab.org/">Prorok Amanda</a> \u6559\u6388, JSPS \u6D77\u5916\u5B66\u632F).\n\u7814\u7A76\u6210\u679C\u306F\u30B9\u30B1\u30FC\u30E9\u30D6\u30EB\u306A\u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u30FB\u30DE\u30EB\u30C1\u30ED\u30DC\u30C3\u30C8\u30B7\u30B9\u30C6\u30E0\u306E\u9650\u754C\u3092\u62BC\u3057\u5E83\u3052\u308B\u3082\u306E\u3067, <a href="https://www.leagueofrobotrunners.org/">Amazon Robotics\u30B9\u30DD\u30F3\u30B5\u30FC\u306E\u7269\u6D41\u81EA\u52D5\u5316\u30B3\u30F3\u30DA\u30C6\u30A3\u30B7\u30E7\u30F3</a>\u3067\u306F\u512A\u52DD\u624B\u6CD5\u306B\u4F7F\u7528\u3055\u308C, \u3044\u304F\u3064\u304B\u306E\u7269\u6D41\u5009\u5EAB\u3067\u306F\u5B9F\u969B\u306B\u5C0E\u5165\u3055\u308C\u3066\u3044\u307E\u3059.\n</p>\n<p>\u5171\u540C\u7814\u7A76\u306E\u63D0\u6848\u3084<a href="https://kei18.github.io/recruit">\u30EA\u30B5\u30FC\u30C1\u30A4\u30F3\u30BF\u30FC\u30F3</a>\u306F\u6B53\u8FCE\u3067\u3059. \u4F01\u696D\u3068\u306E\u5171\u540C\u7814\u7A76\u30FB\u6280\u8853\u30B3\u30F3\u30B5\u30EB\u30C6\u30A3\u30F3\u30B0\u3082\u5C55\u958B\u3057\u3066\u3044\u307E\u3059. \u6C17\u8EFD\u306B\u9023\u7D61\u304F\u3060\u3055\u3044.</p>\n'
    },
    "heroTagline": {
        "en": "Multi-Agent & Multi-Robot Researcher, PhD",
        "ja": "Multi-Agent & Multi-Robot Researcher, PhD"
    },
    "cv": "resume",
    "hero": {
        "video": "led-8drones-crf18",
        "mobile": [
            "40robots_1",
            "8drones_led"
        ]
    },
    "links": [
        {
            "title": {
                "ja": "\u52DF\u96C6",
                "en": "Recruitment (JP)"
            },
            "url": "https://kei18.github.io/recruit/"
        },
        {
            "title": {
                "en": "AIST AIRC Team",
                "ja": "AIST AIRC \u30C1\u30FC\u30E0"
            },
            "url": {
                "ja": "https://www.airc.aist.go.jp/cosine/",
                "en": "https://www.airc.aist.go.jp/en/cosine/"
            }
        }
    ],
    "photo": "profile18_compressed",
    "bio": "Keisuke Okumura is a Researcher at the National Institute of Advanced Industrial Science and Technology (AIST), Japan.\nHe received his PhD in Computer Science from the Tokyo Institute of Technology in 2023, and subsequently worked as a Visiting Postdoctoral Scholar at the University of Cambridge until the end of 2025.\nHis research focuses on developing scalable AI methods for collective automation, particularly at the intersection of multi-agent planning, heuristic search, learning, and multi-robot coordination.\nHis honours include the ICAPS 2022 Best Student Paper Award, Tokyo Tech\u2019s Ph.D. Dissertation Award (2024), and Funai Information Technology Award for Young Researchers (2026).\n"
};


var $b6408df0f93d0f1e$exports = {};
$b6408df0f93d0f1e$exports = {
    "highlights": [
        {
            "title": "Published in npj Robotics (Nature Portfolio): Concrete Planning\n",
            "video": "npj-robotics-paper",
            "description": "Our latest work presents a multi-robot navigation framework for aggressive and coupled coordination, validated with 40 real robots.\n",
            "projectPage": "https://proroklab.github.io/agile-mapf/",
            "paperUrl": "https://www.nature.com/articles/s44182-026-00083-2"
        },
        {
            "title": "Project LaCAM\n",
            "description": "Develop a quick, scalable, and reliable solution for multi-agent pathfinding (MAPF).\n",
            "img": "pathfinding-10k",
            "projectPage": "https://kei18.github.io/lacam-project/"
        }
    ],
    "introTalks": [
        {
            "title": "From Scalable MAPF to Capable Multi-Robot Coordination (Autonomy Talks at MIT, 2026)\n",
            "img": "https://img.youtube.com/vi/xI84VltsVRw/hqdefault.jpg",
            "description": "Beginner-friendly introduction to large-scale multi-agent multi-robot coordination. 1 hour.\n",
            "youtube": "https://www.youtube.com/watch?v=xI84VltsVRw"
        },
        {
            "title": "Upgrading Multi-Agent Pathfinding for the Real World (EurMAPF-25)\n",
            "img": "https://img.youtube.com/vi/XeZTyUS8ZF0/hqdefault.jpg",
            "description": "Deeper introduction to MAPF research directions and practical deployment.\n1 hour.\n",
            "youtube": "https://www.youtube.com/watch?v=XeZTyUS8ZF0",
            "speakerdeck": "https://speakerdeck.com/kei18/eurmapf-25-upgrading-mapf"
        }
    ],
    "future": [
        {
            "year": 2026,
            "month": 11,
            "name": {
                "en": "CoRL-26 in Austin \uD83C\uDDFA\uD83C\uDDF8",
                "ja": "CoRL-26 @\u30AA\u30FC\u30B9\u30C6\u30A3\u30F3\u306B\u53C2\u52A0\u4E88\u5B9A\u3067\u3059"
            },
            "url": "https://www.corl.org/"
        }
    ],
    "activities": [
        {
            "month": 10,
            "name": {
                "en": "IROS-26 tutorial on MAPF is now available on YouTube",
                "ja": "IROS-26 \u3067\u884C\u3063\u305F MAPF \u306E\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB\u304C YouTube \u3067\u516C\u958B\u3055\u308C\u307E\u3057\u305F"
            },
            "url": "https://www.youtube.com/watch?v=EkfmFfDh9N0",
            "year": 2026
        },
        {
            "month": 10,
            "name": {
                "en": "Our paper \"Denoising Multi-Robot Trajectories\" has been published at IEEE T-RO!\n",
                "ja": '\u8AD6\u6587 "Denoising Multi-Robot Trajectories" \u304C IEEE T-RO \u306B\u63B2\u8F09\u3055\u308C\u307E\u3057\u305F!\n'
            },
            "year": 2026,
            "url": "https://ieeexplore.ieee.org/document/11731799"
        },
        {
            "year": 2026,
            "month": 10,
            "name": {
                "en": "Tutorial at IROS-26 in Pittsburgh \uD83C\uDDFA\uD83C\uDDF8 about MAPF with real-robots",
                "ja": "IROS-26 @\u30D4\u30C3\u30C4\u30D0\u30FC\u30B0\u3067 MAPF \u306E\u5B9F\u30ED\u30DC\u30C3\u30C8\u5C55\u958B\u306B\u95A2\u3059\u308B\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://sites.google.com/view/iros-26-mapf-tutorial/home"
        },
        {
            "month": 9,
            "name": {
                "en": "Visited MIT, Amazon Robotics, and Boston Dynamics \uD83C\uDDFA\uD83C\uDDF8 Cool discussions!\n",
                "ja": "MIT, Amazon Robotics, Boston Dynamics@\u30DC\u30B9\u30C8\u30F3\u3092\u8A2A\u554F\u3057\u307E\u3057\u305F\n"
            },
            "year": 2026
        },
        {
            "month": 9,
            "name": {
                "en": "Talk at Osaka University (Online)\n",
                "ja": "\u5927\u962A\u5927\u5B66MMDS AI\u30FB\u30C7\u30FC\u30BF\u5229\u6D3B\u7528\u7814\u7A76\u4F1A\u3067\u30AA\u30F3\u30E9\u30A4\u30F3\u8B1B\u6F14\u3092\u884C\u3044\u307E\u3057\u305F\n"
            },
            "year": 2026,
            "url": "https://www-mmds.sigmath.es.osaka-u.ac.jp/structure/activity/ai_data.php?id=117"
        },
        {
            "month": 9,
            "name": {
                "en": "A paper on multi-robot imitation learning got accepted to CoRL-26!\n",
                "ja": "\u30DE\u30EB\u30C1\u30ED\u30DC\u30C3\u30C8\u5B66\u7FD2\u306B\u95A2\u3059\u308B\u8AD6\u6587\u304C CoRL-26 \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F!\n"
            },
            "url": "https://www.corl.org/",
            "year": 2026
        },
        {
            "month": 8,
            "name": {
                "en": "Visited Cambridge \uD83C\uDDEC\uD83C\uDDE7\n",
                "ja": "\u30B1\u30F3\u30D6\u30EA\u30C3\u30B8\u5927\u3092\u8A2A\u554F\u3057\u307E\u3057\u305F\n"
            },
            "year": 2026
        },
        {
            "month": 8,
            "name": {
                "en": "Visited the IMRC lab at TU Berlin \uD83C\uDDE9\uD83C\uDDEA\n",
                "ja": "IMRC Lab, TU Berlin \u3092\u8A2A\u554F\u3057\u307E\u3057\u305F\n"
            },
            "year": 2026,
            "url": "https://imrclab.github.io/"
        },
        {
            "month": 8,
            "name": {
                "en": "IJCAI-26 in Bremen \uD83C\uDDE9\uD83C\uDDEA\n",
                "ja": "IJCAI-26 @\u30D6\u30EC\u30FC\u30E1\u30F3\u306B\u53C2\u52A0\u3057\u307E\u3057\u305F\n"
            },
            "year": 2026,
            "url": "https://2026.ijcai.org/"
        },
        {
            "month": 8,
            "name": {
                "en": "SoCS-26 in Bremerhaven \uD83C\uDDE9\uD83C\uDDEA\n",
                "ja": "SoCS-26 @\u30D6\u30EC\u30FC\u30DE\u30FC\u30CF\u30FC\u30D5\u30A7\u30F3\u306B\u53C2\u52A0\u3057\u307E\u3057\u305F\n"
            },
            "year": 2026,
            "url": "https://socs26.search-conference.org/home"
        },
        {
            "month": 8,
            "name": {
                "en": "We got the SoCS 2026 Best Student Paper Award for Lifelong LaCAM \uD83C\uDFC6",
                "ja": "Lifelong LaCAM \u306E\u8AD6\u6587\u306B\u95A2\u3057\u3066 The SoCS 2026 Best Student Paper Award\u3092\u53D7\u8CDE\u3057\u307E\u3057\u305F \uD83C\uDFC6"
            },
            "url": "https://socs26.search-conference.org/",
            "year": 2026
        },
        {
            "month": 6,
            "name": {
                "en": "ICAPS-26 in Dublin \uD83C\uDDEE\uD83C\uDDEA\n",
                "ja": "ICAPS-26@\u30C0\u30D6\u30EA\u30F3\u306B\u53C2\u52A0\u3057\u307E\u3057\u305F\n"
            },
            "year": 2026,
            "url": "https://icaps26.icaps-conference.org/"
        },
        {
            "month": 6,
            "name": {
                "en": "Online talk at AI Robotics Lab, Sogang University \uD83C\uDDF0\uD83C\uDDF7\n",
                "ja": "AI Robotics Lab, Sogang University \uD83C\uDDF0\uD83C\uDDF7 \u3067\u30AA\u30F3\u30E9\u30A4\u30F3\u8B1B\u6F14\u3092\u3057\u307E\u3057\u305F\n"
            },
            "url": "https://airobotics.sogang.ac.kr/",
            "year": 2026
        },
        {
            "name": {
                "en": "JSAI-26 in Takasaki \uD83C\uDDEF\uD83C\uDDF5\n",
                "ja": "JSAI2026@\u9AD8\u5D0E\u306B\u53C2\u52A0\u3057, \u30AA\u30FC\u30AC\u30CA\u30A4\u30BA\u30C9\u30BB\u30C3\u30B7\u30E7\u30F3\u306E\u958B\u50AC, \u5C55\u793A\u7B49\u3092\u884C\u3044\u307E\u3057\u305F\n"
            },
            "url": "https://www.ai-gakkai.or.jp/jsai2026/os/#os-1",
            "month": 6,
            "year": 2026
        },
        {
            "month": 5,
            "name": {
                "en": "Two papers (TAPF and LLLG) got accepted to SoCS-26!\n",
                "ja": "MAPF\u306B\u95A2\u3059\u308B\u8AD6\u65872\u5831 (TAPF, LLLG) \u304C SoCS-26 \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F!\n"
            },
            "url": "https://socs26.search-conference.org/home",
            "year": 2026
        },
        {
            "month": 5,
            "name": {
                "en": "A paper on MAPF tailored to warehouse setups has been accepted to IJCAI-26!\n",
                "ja": "\u5009\u5EAB\u74B0\u5883\u306B\u304A\u3051\u308B MAPF \u306E\u8AD6\u6587\u304C IJCAI-26 \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F!\n"
            },
            "url": "https://2026.ijcai.org/",
            "year": 2026
        },
        {
            "month": 4,
            "name": {
                "en": "Online talk at IDM Lab, USC/UCI \uD83C\uDDFA\uD83C\uDDF8\n",
                "ja": "IDM Lab@USC/UCI \u306E\u30BB\u30DF\u30CA\u30FC\u3067\u8B1B\u6F14\u3092\u3057\u307E\u3057\u305F\n"
            },
            "year": 2026
        },
        {
            "month": 4,
            "name": {
                "en": "Online talk at Hitotsubashi University \uD83C\uDDEF\uD83C\uDDF5\n",
                "ja": "\u4E00\u6A4B\u5927\u5B66\u5927\u5B66\u9662\u30BD\u30FC\u30B7\u30E3\u30EB\u30FB\u30C7\u30FC\u30BF\u30B5\u30A4\u30A8\u30F3\u30B9\u7814\u7A76\u79D1\u3067\u8B1B\u6F14\u3092\u3057\u307E\u3057\u305F\n"
            },
            "year": 2026,
            "url": "https://www.sds.hit-u.ac.jp/3940/"
        },
        {
            "month": 4,
            "name": {
                "en": "Our npj Robotics paper is featured on the journal homepage as a hero image\n",
                "ja": "Concrete Planning \u306E\u8AD6\u6587\u304C npj Robotics (Nature Portfolio) \u306E\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u3067\u30D2\u30FC\u30ED\u30FC\u30A4\u30E1\u30FC\u30B8\u3068\u3057\u3066\u7D39\u4ECB\u3055\u308C\u3066\u3044\u307E\u3059\n"
            },
            "year": 2026,
            "url": "https://www.nature.com/npjrobot/"
        },
        {
            "month": 3,
            "name": {
                "en": "Our npj Robotics paper is featured in IEEE Spectrum Video Friday\n",
                "ja": "npj Robotics \u306B\u63B2\u8F09\u3055\u308C\u305F\u8AD6\u6587\u304C IEEE Spectrum Video Friday \u306B\u63B2\u8F09\u3055\u308C\u307E\u3057\u305F\n"
            },
            "year": 2026,
            "url": "https://spectrum.ieee.org/roadrunner-bipedal-robot#41kpw6jwxty"
        },
        {
            "month": 3,
            "name": {
                "en": "Our paper \"Concrete multi-agent path planning enabling kinodynamically aggressive maneuvers\" has been published at npj Robotics (Nature Portfolio)!\n",
                "ja": '\u8AD6\u6587 "Concrete multi-agent path planning enabling kinodynamically aggressive maneuvers" \u304C npj Robotics (Nature Portfolio) \u306B\u63B2\u8F09\u3055\u308C\u307E\u3057\u305F!\n'
            },
            "year": 2026,
            "url": "https://www.nature.com/articles/s44182-026-00083-2"
        },
        {
            "month": 3,
            "name": {
                "en": "Online talk at Autonomy Talks at MIT\n",
                "ja": "Autonomy Talks (MIT) \u3067\u30AA\u30F3\u30E9\u30A4\u30F3\u8B1B\u6F14\u3092\u884C\u3044\u307E\u3057\u305F\n"
            },
            "year": 2026,
            "url": "https://www.youtube.com/watch?v=xI84VltsVRw"
        },
        {
            "month": 2,
            "name": {
                "en": "Received the Funai Information Technology Award for Young Researchers!\n",
                "ja": "\u8239\u4E95\u7814\u7A76\u5968\u52B1\u8CDE\u3092\u53D7\u8CDE\u3057\u307E\u3057\u305F\n"
            },
            "url": "https://funaifoundation.jp/news-580.htm",
            "year": 2026
        },
        {
            "month": 2,
            "name": {
                "en": "Two papers (CUMAPF and db-LaCAM) got accepted to ICAPS-26!\n",
                "ja": "MAPF\u306B\u95A2\u3059\u308B\u8AD6\u65872\u5831 (CUMAPF, db-LaCAM) \u304C ICAPS-26 \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F!\n"
            },
            "url": "https://icaps26.icaps-conference.org/",
            "year": 2026
        },
        {
            "month": 1,
            "name": {
                "en": "A paper \"Pairwise is Not Enough: Hypergraph Neural Networks for Multi-Agent Pathfinding\" got accepted to ICLR-26!\n",
                "ja": '\u8AD6\u6587 "Pairwise is Not Enough: Hypergraph Neural Networks for Multi-Agent Pathfinding" \u304C ICLR-26 \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F\n'
            },
            "url": "https://iclr.cc/",
            "year": 2026
        },
        {
            "month": 1,
            "name": {
                "en": "Two papers (db-LaCAM, HMAGAT) + panel discussion at WoMAPF-26, Singapore.\n",
                "ja": "WoMAPF-26@\u30B7\u30F3\u30AC\u30DD\u30FC\u30EB\u3067\u767A\u88682\u5831\u3092\u884C\u3044 (db-LaCAM, HMAGAT)\u3001\u307E\u305F\u30D1\u30CD\u30EA\u30B9\u30C8\u3068\u3057\u3066\u767B\u58C7\u3057\u307E\u3057\u305F\n"
            },
            "year": 2026,
            "url": "https://mapf-workshop.github.io/aaai26/"
        },
        {
            "month": 1,
            "name": {
                "en": "Presented two papers (local guidance, LaGAT) at AAAI-26 in Singapore\n",
                "ja": "\u30B7\u30F3\u30AC\u30DD\u30FC\u30EB\u3067\u958B\u50AC\u3055\u308C\u305FAAAI-26\u306B\u53C2\u52A0\u3057\u3066\u8AD6\u65872\u5831\u3092\u767A\u8868\u3057\u307E\u3057\u305F (local guidance, LaGAT)\n"
            },
            "year": 2026,
            "url": "https://aaai.org/conference/aaai/aaai-26/"
        },
        {
            "month": 12,
            "name": {
                "en": "A paper \"100-Mouse System: Scalable Multi-Robot Testbed with State Management User Interface\" has been published at Journal of Robotics and Mechatronics (JRM)!\n",
                "ja": '\u8AD6\u6587 "100-Mouse System: Scalable Multi-Robot Testbed with State Management User Interface" \u304C Journal of Robotics and Mechatronics (JRM)  \u306B\u63B2\u8F09\u3055\u308C\u307E\u3057\u305F\n'
            },
            "url": "https://www.fujipress.jp/jrm/rb/robot003700061545/",
            "year": 2025
        },
        {
            "month": 12,
            "name": {
                "en": "Moved from Cambridge to Tokyo. What a wonderful time I had in the UK!\n",
                "ja": "\u30B1\u30F3\u30D6\u30EA\u30C3\u30B8\u304B\u3089\u6771\u4EAC\u306B\u5F15\u8D8A\u3057\u307E\u3057\u305F\n"
            },
            "year": 2025
        },
        {
            "month": 12,
            "name": {
                "en": "A preprint paper \"db-LaCAM: Fast and Scalable Multi-Robot Kinodynamic Motion Planning with Discontinuity-Bounded Search and Lightweight MAPF\" is out on arXiv\n",
                "ja": '\u8AD6\u6587 "db-LaCAM: Fast and Scalable Multi-Robot Kinodynamic Motion Planning with Discontinuity-Bounded Search and Lightweight MAPF" \u306E\u30D7\u30EC\u30D7\u30EA\u30F3\u30C8\u3092arXiv\u306B\u516C\u958B\u3057\u307E\u3057\u305F\n'
            },
            "url": "https://arxiv.org/abs/2512.06796",
            "year": 2025
        },
        {
            "month": 11,
            "name": {
                "en": "Two papers on MAPF (GNN x LaCAM, local guidance) got accepted to AAAI-26!\n",
                "ja": "MAPF\u306B\u95A2\u3059\u308B\u8AD6\u65872\u5831 (GNN x LaCAM, local guidance) \u304CAAAI-26\u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F!\n"
            },
            "url": "https://aaai.org/conference/aaai/aaai-26/",
            "year": 2025
        },
        {
            "name": {
                "en": "Featured in Fant\xe1stico, Brazil\u2019s TV show (3:00-), about Prorok Lab research in Cambridge\n",
                "ja": "\u30D6\u30E9\u30B8\u30EB\u306ETV\u30B7\u30E7\u30FCFant\xe1stico\u306B\u30B1\u30F3\u30D6\u30EA\u30C3\u30B8\u5927\u3067\u306E\u7814\u7A76\u304C\u7D39\u4ECB\u3055\u308C\u307E\u3057\u305F (3:00-)\n"
            },
            "url": "https://g1.globo.com/fantastico/video/mentes-digitais-professora-brasileira-lidera-pesquisas-de-inteligencia-coletiva-no-reino-unido-14044982.ghtml",
            "month": 10,
            "year": 2025
        },
        {
            "month": 10,
            "name": {
                "en": "Invited talk at EurMAPF-25 in Bologna, Italy\n",
                "ja": "\u30A4\u30BF\u30EA\u30A2\u30FB\u30DC\u30ED\u30FC\u30CB\u30E3\u3067\u958B\u50AC\u3055\u308C\u308BEurMAPF-25\u3067\u62DB\u5F85\u8B1B\u6F14\u3092\u884C\u3044\u307E\u3057\u305F\n"
            },
            "year": 2025,
            "url": "https://sites.google.com/view/eurmapf25"
        },
        {
            "month": 10,
            "name": {
                "en": "A preprint paper \"Polynomial-time Configuration Generator for Connected Unlabeled Multi-Agent Pathfinding\" is out on arXiv\n",
                "ja": '\u8AD6\u6587 "Polynomial-time Configuration Generator for Connected Unlabeled Multi-Agent Pathfinding" \u306E\u30D7\u30EC\u30D7\u30EA\u30F3\u30C8\u3092arXiv\u306B\u516C\u958B\u3057\u307E\u3057\u305F\n'
            },
            "url": "https://arxiv.org/abs/2510.19567",
            "year": 2025
        },
        {
            "month": 10,
            "name": {
                "en": "A preprint paper \"Local Guidance for Configuration-Based Multi-Agent Pathfinding\" is out on arXiv\n",
                "ja": '\u8AD6\u6587 "Local Guidance for Configuration-Based Multi-Agent Pathfinding" \u306E\u30D7\u30EC\u30D7\u30EA\u30F3\u30C8\u3092arXiv\u306B\u516C\u958B\u3057\u307E\u3057\u305F\n'
            },
            "url": "https://arxiv.org/abs/2510.19072",
            "year": 2025
        },
        {
            "month": 10,
            "name": {
                "en": "A preprint paper \"Graph Attention-Guided Search for Dense Multi-Agent Pathfinding\" is out on arXiv\n",
                "ja": '\u8AD6\u6587 "Graph Attention-Guided Search for Dense Multi-Agent Pathfinding" \u306E\u30D7\u30EC\u30D7\u30EA\u30F3\u30C8\u3092arXiv\u306B\u516C\u958B\u3057\u307E\u3057\u305F\n'
            },
            "url": "https://arxiv.org/abs/2510.17382",
            "year": 2025
        },
        {
            "month": 9,
            "name": {
                "en": "OPTDS-25 in Tokyo: One talk\n",
                "ja": "\u6771\u4EAC\u3067\u958B\u50AC\u3055\u308C\u305FOPTDS-25\u306B\u53C2\u52A0\u3057\u3066\u8B1B\u6F14\u3092\u884C\u3044\u307E\u3057\u305F\n"
            },
            "year": 2025,
            "url": "https://sites.google.com/view/optds2025/"
        },
        {
            "month": 9,
            "name": {
                "en": "Research grant acceptance: JST PRESTO \"Real-World Intelligence Fundamentals\"\n",
                "ja": "JST \u3055\u304D\u304C\u3051\u300C\u5B9F\u4E16\u754C\u77E5\u80FD\u30B7\u30B9\u30C6\u30E0\u306E\u57FA\u76E4\u5275\u51FA\u300D\u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F\n"
            },
            "url": {
                "ja": "https://www.jst.go.jp/kisoken/presto/application/2025/250918/250918.html",
                "en": "https://www.jst.go.jp/kisoken/presto/en/research_area/area2025-3.html"
            },
            "year": 2025
        },
        {
            "month": 8,
            "name": {
                "en": "I really enjoyed SoCS-25 in Glasgow!\n",
                "ja": "\u82F1\u30B0\u30E9\u30B9\u30B4\u30FC\u3067\u958B\u50AC\u3055\u308C\u305FSoCS-25\u306B\u53C2\u52A0\u3057\u3066\u7814\u7A76\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F\n"
            },
            "year": 2025,
            "url": "https://socs25.search-conference.org/home"
        },
        {
            "month": 8,
            "name": {
                "en": "A paper \"Congestion Mitigation Path Planning for Large-Scale Multi-Agent Navigation in Dense Environments\" has been accepted to IEEE RA-L!",
                "ja": '\u8AD6\u6587 "Congestion Mitigation Path Planning for Large-Scale Multi-Agent Navigation in Dense Environments" \u304C IEEE RA-L \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F'
            },
            "url": "https://arxiv.org/abs/2508.05253",
            "year": 2025
        },
        {
            "month": 7,
            "name": {
                "en": "A paper \"ReCoDe: Reinforcement Learning-based Dynamic Constraint Design for Multi-Agent Coordination\" got accepted to CoRL-25!\n",
                "ja": '\u8AD6\u6587"ReCoDe: Reinforcement Learning-based Dynamic Constraint Design for Multi-Agent Coordination" \u304CCoRL-25\u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F\n'
            },
            "url": "https://www.corl.org/",
            "year": 2025
        },
        {
            "month": 7,
            "name": {
                "en": "A preprint paper \"LF: Online Multi-Robot Path Planning Meets Optimal Trajectory Control\" is out on arXiv\n",
                "ja": '\u8AD6\u6587 "LF: Online Multi-Robot Path Planning Meets Optimal Trajectory Control" \u306E\u30D7\u30EC\u30D7\u30EA\u30F3\u30C8\u3092arXiv\u306B\u516C\u958B\u3057\u307E\u3057\u305F\n'
            },
            "url": "https://arxiv.org/abs/2507.11464",
            "year": 2025
        },
        {
            "month": 7,
            "name": {
                "en": "A technical report \"Sanity: An Agile Brushless Quadrotor for Multi-Agent Experiments\" is out on OpenReview\n",
                "ja": '\u30C6\u30AF\u30CB\u30AB\u30EB\u30EC\u30DD\u30FC\u30C8 "Sanity: An Agile Brushless Quadrotor for Multi-Agent Experiments" \u3092\u516C\u958B\u3057\u307E\u3057\u305F\n'
            },
            "url": "https://openreview.net/forum?id=i5dKOANPZZ",
            "year": 2025
        },
        {
            "month": 6,
            "name": {
                "en": "A paper on diffusion denoising for multi-robot trajectory optimisation has been accepted to IROS-25!\n",
                "ja": "\u62E1\u6563\u30E2\u30C7\u30EB\u306E\u30CE\u30A4\u30BA\u9664\u53BB\u3092\u5229\u7528\u3057\u305F\u30DE\u30EB\u30C1\u30ED\u30DC\u30C3\u30C8\u8ECC\u9053\u6700\u9069\u5316\u306E\u8AD6\u6587\u304C IROS-25 \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F!\n"
            },
            "url": "https://www.iros25.org/",
            "year": 2025
        },
        {
            "month": 5,
            "name": {
                "en": "Seminar talk at Behavior in Networks Studies Unit, UTokyo\n",
                "ja": "\u6771\u5927\u4EA4\u901A\u7814\u3067\u30BB\u30DF\u30CA\u30FC\u30C8\u30FC\u30AF\u3092\u884C\u3044\u307E\u3057\u305F.\n"
            },
            "url": "http://www.trip.t.u-tokyo.ac.jp/",
            "year": 2025
        },
        {
            "month": 5,
            "name": {
                "en": "A paper on PIBT tiebreaking has been accepted to SoCS-25! See you in Glasgow this summer\n",
                "ja": "PIBT\u306E\u30BF\u30A4\u30D6\u30EC\u30FC\u30AD\u30F3\u30B0\u6539\u5584\u306B\u3064\u3044\u3066\u306E\u8AD6\u6587\u304CSoCS-25 \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F!\n"
            },
            "url": "https://socs25.search-conference.org/home",
            "year": 2025
        },
        {
            "month": 3,
            "name": {
                "en": "A preprint paper \"D4orm: Multi-Robot Trajectories with Dynamics-aware Diffusion Denoised Deformations\" is out on arXiv.\n",
                "ja": '\u8AD6\u6587 "D4orm: Multi-Robot Trajectories with Dynamics-aware Diffusion Denoised Deformations" \u306E\u30D7\u30EC\u30D7\u30EA\u30F3\u30C8\u3092arXiv\u306B\u516C\u958B\u3057\u307E\u3057\u305F.\n'
            },
            "url": "https://arxiv.org/abs/2503.12204",
            "year": 2025
        },
        {
            "name": {
                "en": "Featured in BBC click (18:00-), about Prorok Lab research in Cambridge, including quadrotor swarm coordination\n",
                "ja": "BBC Click \u306B\u30B1\u30F3\u30D6\u30EA\u30C3\u30B8\u5927\u3067\u306E\u7814\u7A76\u304C\u7D39\u4ECB\u3055\u308C\u307E\u3057\u305F (18:28-)\n"
            },
            "url": "https://www.bbc.co.uk/iplayer/episode/m0029673/click-15032025",
            "month": 3,
            "year": 2025
        },
        {
            "name": {
                "en": "Hosted the 6th international workshop on Multi-Agent Path Finding (WoMAPF) at AAAI-25, with two co-authored presentations.\n",
                "ja": "AAAI-25 \u3067\u7B2C6\u56DE\u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7D4C\u8DEF\u8A08\u753B\u30EF\u30FC\u30AF\u30B7\u30E7\u30C3\u30D7 (WoMAPF) \u3092\u958B\u50AC\u3057\u307E\u3057\u305F. \u5171\u8457\u30922\u4EF6\u767A\u8868\u3057\u307E\u3057\u305F.\n"
            },
            "url": "https://womapf.github.io/aaai-25/",
            "month": 3,
            "year": 2025
        },
        {
            "month": 10,
            "name": {
                "en": "Visited several robotics labs in Zurich, Switzerland. Cool research discussions!\n",
                "ja": "\u30B9\u30A4\u30B9\u30FB\u30C1\u30E5\u30FC\u30EA\u30C3\u30D2\u306B\u6EDE\u5728\u3057\u3066\u30ED\u30DC\u30C3\u30C8\u7CFB\u306E\u7814\u7A76\u5BA4\u3092\u8A2A\u554F\u3057\u307E\u3057\u305F.\n"
            },
            "year": 2024
        },
        {
            "month": 10,
            "name": {
                "en": "Visited Osaka and Tokyo. Thanks for a lot of cool research discussions!\n",
                "ja": "\u5927\u962A\u30FB\u6771\u4EAC\u306B\u6EDE\u5728\u3057\u307E\u3057\u305F.\n"
            },
            "year": 2024
        },
        {
            "month": 10,
            "name": {
                "en": "Organised a workshop on multi-agent/multi-robot planning in Tokyo on 5 October. Thank you for attending!\n",
                "ja": "\u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u30FB\u30DE\u30EB\u30C1\u30ED\u30DC\u30C3\u30C8\u30D7\u30E9\u30F3\u30CB\u30F3\u30B0\u7814\u7A76\u4F1A\u309210\u67085\u65E5\u306B\u6771\u4EAC\u3067\u4E3B\u50AC\u3057\u307E\u3057\u305F. \u53C2\u52A0\u3057\u3066\u3044\u305F\u3060\u304D\u3001\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\uFF01\n"
            },
            "url": "https://sites.google.com/view/multi-agent-robot-planning-24",
            "year": 2024
        },
        {
            "month": 8,
            "name": {
                "en": "A preprint paper \"Pathfinding with Lazy Successor Generation\" is out on arXiv.\n",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Pathfinding with Lazy Successor Generation"\u306E\u30D7\u30EC\u30D7\u30EA\u30F3\u30C8\u3092arXiv\u306B\u516C\u958B\u3057\u307E\u3057\u305F.\n'
            },
            "url": "https://arxiv.org/abs/2408.15443",
            "year": 2024
        },
        {
            "month": 5,
            "name": {
                "en": "Visited Monash University in Melbourne, and University of Technology Sydney. Did a lot of cool research discussions!\n",
                "ja": "\u30AA\u30FC\u30B9\u30C8\u30E9\u30EA\u30A2\u30FB\u30E2\u30CA\u30B7\u30E5\u5927\u5B66\u3068\u30B7\u30C9\u30CB\u30FC\u5DE5\u79D1\u5927\u5B66\u3092\u8A2A\u554F\u3057\u307E\u3057\u305F.\n"
            },
            "year": 2024
        },
        {
            "month": 5,
            "name": {
                "en": "Invited talk at Agents-VIC Autumn Symposium 2024 in Melbourne, Australia\n",
                "ja": "Agents-VIC Autumn Symposium 2024 (\u30AA\u30FC\u30B9\u30C8\u30E9\u30EA\u30A2\u30FB\u30E1\u30EB\u30DC\u30EB\u30F3) \u3067\u62DB\u5F85\u8B1B\u6F14\u3092\u884C\u3044\u307E\u3057\u305F\n"
            },
            "url": "https://sites.google.com/view/agentsvic-autumn2024/home",
            "year": 2024
        },
        {
            "month": 5,
            "name": {
                "en": "One talk (engineering LaCAM*) at AAMAS-24 in Auckland, New Zealand.",
                "ja": "AAMAS-24@\u30CB\u30E5\u30FC\u30B8\u30FC\u30E9\u30F3\u30C9\u30FB\u30AA\u30FC\u30AF\u30E9\u30F3\u30C9\u3067\u7814\u7A76\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://www.aamas2024-conference.auckland.ac.nz/",
            "year": 2024
        },
        {
            "month": 4,
            "name": {
                "en": "Co-authored paper \"A Comprehensive Review on Leveraging Machine Learning for Multi-Agent Path Finding\" has been published at IEEE Access!",
                "ja": '\u5171\u8457\u8AD6\u6587 "A Comprehensive Review on Leveraging Machine Learning for Multi-Agent Path Finding" \u304C IEEE Access \u306B\u63B2\u8F09\u3055\u308C\u307E\u3057\u305F'
            },
            "url": "https://ieeexplore.ieee.org/document/10506521",
            "year": 2024
        },
        {
            "month": 3,
            "year": 2024,
            "name": {
                "en": "Received the Ph.D. Dissertation Award (Seiichi Tejima Research Award) from TokyoTech!\nThanks to many supporters, especially my supervisor Xavier.\n",
                "ja": "\u624B\u5CF6\u7CBE\u4E00\u8A18\u5FF5\u7814\u7A76\u8CDE (\u535A\u58EB\u8AD6\u6587\u8CDE) \u3092\u6771\u5DE5\u5927\u3088\u308A\u53D7\u8CDE\u3057\u307E\u3057\u305F.\n\u535A\u58EB\u8AB2\u7A0B\u3092\u652F\u3048\u3066\u304F\u308C\u305F\u65B9\u3005, \u7279\u306B\u6307\u5C0E\u6559\u54E1\u306EDefago\u5148\u751F\u306B\u6DF1\u304F\u611F\u8B1D\u3057\u307E\u3059.\n"
            },
            "url": "https://www.titech.ac.jp/news/2024/069180"
        },
        {
            "month": 2,
            "name": {
                "en": "Visited idealworks in Munich, Germany",
                "ja": "idealworks (\u30DF\u30E5\u30F3\u30D8\u30F3\u30FB\u30C9\u30A4\u30C4) \u3092\u8A2A\u554F\u3057\u307E\u3057\u305F"
            },
            "url": "https://idealworks.com/en/",
            "year": 2024
        },
        {
            "month": 2,
            "name": {
                "en": "Guest lecture at Carnegie Mellon University",
                "ja": "\u30A2\u30E1\u30EA\u30AB\u30FB\u30AB\u30FC\u30CD\u30AE\u30FC\u30E1\u30ED\u30F3\u5927\u5B66\u3067\u30B2\u30B9\u30C8\u30EC\u30AF\u30C1\u30E3\u30FC\u3092\u3057\u307E\u3057\u305F"
            },
            "url": "https://jiaoyangli.me/teaching/2024-spring-16891",
            "year": 2024
        },
        {
            "month": 1,
            "name": {
                "en": "A feature article for my PhD dissertation has appeared in JSAI (Journal of the Japanese Society for Artificial Intelligence)\n",
                "ja": "\u4EBA\u5DE5\u77E5\u80FD\u5B66\u4F1A\u8A8C\u30FB\u535A\u58EB\u8AD6\u6587\u96C6\u306B\u8A18\u4E8B\u304C\u63B2\u8F09\u3055\u308C\u307E\u3057\u305F\n"
            },
            "url": "https://doi.org/10.11517/jjsai.39.1_50",
            "year": 2024
        },
        {
            "month": 1,
            "name": {
                "en": "Renew blog site\n",
                "ja": "\u30D6\u30ED\u30B0\u3092\u30EA\u30CB\u30E5\u30FC\u30A2\u30EB\u3057\u307E\u3057\u305F\n"
            },
            "url": "https://kei18.github.io/note",
            "year": 2024
        },
        {
            "month": 12,
            "name": {
                "en": "My paper on engineering LaCAM\u2217 for MAPF has been accepted to AAMAS-24!\n",
                "ja": "\u4E3B\u8457\u8AD6\u6587\u304CAAMAS-24 \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F! \u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7D4C\u8DEF\u8A08\u753B\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0LaCAM*\u306E\u62E1\u5F35\u306B\u3064\u3044\u3066\u3067\u3059\u3002\n"
            },
            "url": "https://www.aamas2024-conference.auckland.ac.nz/",
            "year": 2023
        },
        {
            "month": 11,
            "name": {
                "en": "Seminar talk at the University of Cambridge",
                "ja": "\u30B1\u30F3\u30D6\u30EA\u30C3\u30B8\u5927\u5B66\u3067\u8B1B\u6F14\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://www.cst.cam.ac.uk/seminars/list/204508",
            "year": 2023
        },
        {
            "month": 8,
            "name": {
                "en": "Two talks at IJCAI-23 in Macao",
                "ja": "IJCAI-23@\u30DE\u30AB\u30AA\u30672\u4EF6\u306E\u7814\u7A76\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://ijcai-23.org/",
            "year": 2023
        },
        {
            "month": 8,
            "name": {
                "en": "My PhD dissertation is finally out!\n",
                "ja": "\u535A\u58EB\u8AD6\u6587\u304C\u516C\u958B\u3055\u308C\u307E\u3057\u305F\n"
            },
            "url": "https://kei18.github.io/phd-dissertation/",
            "year": 2023
        },
        {
            "month": 8,
            "name": {
                "en": 'A preprint paper "Engineering LaCAM\u2217: Towards Real-Time, Large-Scale, and Near-Optimal Multi-Agent Pathfinding" is out on arXiv.\n',
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Engineering LaCAM\u2217: Towards Real-Time, Large-Scale, and Near-Optimal Multi-Agent Pathfinding"\u306E\u30D7\u30EC\u30D7\u30EA\u30F3\u30C8\u3092arXiv\u306B\u516C\u958B\u3057\u307E\u3057\u305F.\n'
            },
            "url": "https://kei18.github.io/lacam3/",
            "year": 2023
        },
        {
            "month": 6,
            "name": {
                "en": "Invited talk at SSII-23",
                "ja": "\u753B\u50CF\u30BB\u30F3\u30B7\u30F3\u30B0\u30B7\u30F3\u30DD\u30B8\u30A6\u30E0(SSII)\u306E\u30AA\u30FC\u30AC\u30CA\u30A4\u30BA\u30C9\u30BB\u30C3\u30B7\u30E7\u30F3\u300C\u30ED\u30DC\u30C3\u30C8\u5206\u91CE\u306ECV\u6280\u8853\u300D\u3067\u8B1B\u6F14\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://confit.atlas.jp/guide/event/ssii2023/static/organized",
            "year": 2023
        },
        {
            "month": 5,
            "name": {
                "en": "One talk (CTRMs) at ICRA-23 workshop on Multi-Robot Learning",
                "ja": "ICRA-23 workshop on Multi-Robot Learning \u3067 CTRMs \u306E\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://sites.google.com/cam.ac.uk/multirobotlearningworkshopicra/home",
            "year": 2023
        },
        {
            "month": 5,
            "name": {
                "en": "Our paper \"Solving Simultaneous Target Assignment and Path Planning Efficiently with Time-Independent Execution\" has been published at Artificial Intelligence (AIJ)!\n",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Solving Simultaneous Target Assignment and Path Planning Efficiently with Time-Independent Execution" \u304C Artificial Intelligence (AIJ) \u306B\u63B2\u8F09\u3055\u308C\u307E\u3057\u305F\n'
            },
            "url": "https://www.sciencedirect.com/science/article/pii/S0004370223000929",
            "year": 2023
        },
        {
            "month": 5,
            "name": {
                "en": "Starting my research at the University of Cambridge, UK. I will stay here for two years.",
                "ja": "\u30A4\u30AE\u30EA\u30B9\u30FB\u30B1\u30F3\u30D6\u30EA\u30C3\u30B8\u5927\u5B66\u3067\u306E\u7814\u7A76\u6D3B\u52D5\u3092\u958B\u59CB\u3057\u307E\u3057\u305F\u30022\u5E74\u9593\u6EDE\u5728\u4E88\u5B9A\u3067\u3059\u3002"
            },
            "url": "https://www.cst.cam.ac.uk/",
            "year": 2023
        },
        {
            "month": 4,
            "name": {
                "en": "Our two papers \"Quick Multi-Robot Motion Planning by Combining Sampling and Search,\" \"Improving LaCAM for Scalable Eventually Optimal Multi-Agent Pathfinding\" have been accepted to IJCAI-23!\n",
                "ja": '\u4E3B\u8457\u8AD6\u65872\u5831 "Quick Multi-Robot Motion Planning by Combining Sampling and Search," "Improving LaCAM for Scalable Eventually Optimal Multi-Agent Pathfinding" \u304C IJCAI-23 \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F!\n'
            },
            "url": "https://ijcai-23.org/",
            "year": 2023
        },
        {
            "month": 4,
            "name": {
                "en": "Our paper \"Offline Time-Independent Multiagent Path Planning\" has been published at IEEE Transactions on Robotics (T-RO)!",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Offline Time-Independent Multiagent Path Planning" \u304C IEEE Transactions on Robotics (T-RO) \u306B\u63B2\u8F09\u3055\u308C\u307E\u3057\u305F'
            },
            "url": "https://ieeexplore.ieee.org/document/10092929",
            "year": 2023
        },
        {
            "month": 4,
            "name": {
                "en": "Started a new career as a researcher at AIST, Japan",
                "ja": "\u7523\u696D\u6280\u8853\u7DCF\u5408\u7814\u7A76\u6240 \u4EBA\u5DE5\u77E5\u80FD\u7814\u7A76\u30BB\u30F3\u30BF\u30FC\u306E\u7814\u7A76\u54E1\u306B\u7740\u4EFB\u3057\u307E\u3057\u305F"
            },
            "year": 2023,
            "url": {
                "en": "https://www.aist.go.jp/index_en.html",
                "ja": "https://www.aist.go.jp/"
            }
        },
        {
            "month": 3,
            "name": {
                "en": "I finally got my Ph.D. from TokyoTech! Thanks to all who supported me",
                "ja": "\u6771\u4EAC\u5DE5\u696D\u5927\u5B66\u304B\u3089\u535A\u58EB(\u5DE5\u5B66)\u3092\u6388\u4E0E\u3055\u308C\u307E\u3057\u305F! \u652F\u63F4\u3057\u3066\u3044\u305F\u3060\u3044\u305F\u7686\u3055\u307E\u3001\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F"
            },
            "year": 2023
        },
        {
            "month": 3,
            "name": {
                "en": "Visited Kyushu University, Japan. Nice research discussions!",
                "ja": "\u4E5D\u5DDE\u5927\u5B66\u3092\u8A2A\u554F\u3057\u307E\u3057\u305F"
            },
            "year": 2023
        },
        {
            "month": 2,
            "name": {
                "en": "Visited Carnegie Mellon University, USA. Nice research discussions!",
                "ja": "\u30A2\u30E1\u30EA\u30AB\u30FB\u30AB\u30FC\u30CD\u30AE\u30FC\u30E1\u30ED\u30F3\u5927\u5B66\u3092\u8A2A\u554F\u3057\u307E\u3057\u305F"
            },
            "year": 2023
        },
        {
            "month": 2,
            "name": {
                "en": "Two talks at AAAI-23 in Washington DC, USA",
                "ja": "AAAI-23@\u30A2\u30E1\u30EA\u30AB\u30FB\u30EF\u30B7\u30F3\u30C8\u30F3DC\u3067\u7814\u7A76\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://aaai.org/Conferences/AAAI-23/",
            "year": 2023
        },
        {
            "month": 1,
            "name": {
                "en": "PhD defense, entitled \"Planning, Execution, Representation, and Their Integration for Multiple Moving Agents\"\n",
                "ja": '\u535A\u58EB\u8AD6\u6587\u767A\u8868\u4F1A\u3092\u884C\u3044\u307E\u3057\u305F (\u984C\u76EE: "Planning, Execution, Representation, and Their Integration for Multiple Moving Agents")\n'
            },
            "url": "https://educ.titech.ac.jp/cs/event_information/2023/063649.html",
            "year": 2023
        },
        {
            "month": 11,
            "name": {
                "en": "Our two papers \"Fault-Tolerant Offline Multi-Agent Path Planning,\" \"LaCAM: Search-Based Algorithm for Quick Multi-Agent Pathfinding\" have been accepted to AAAI-23!\n",
                "ja": '\u4E3B\u8457\u8AD6\u65872\u5831 "Fault-Tolerant Offline Multi-Agent Path Planning," "LaCAM: Search-Based Algorithm for Quick Multi-Agent Pathfinding" \u304C AAAI-23 \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F!\n'
            },
            "url": "https://aaai.org/Conferences/AAAI-23/",
            "year": 2022
        },
        {
            "month": 9,
            "name": {
                "en": "Received offers of JSPS { Overseas Research, PD } Fellowships",
                "ja": "\u65E5\u672C\u5B66\u8853\u632F\u8208\u4F1A \u6D77\u5916\u7279\u5225\u7814\u7A76\u54E1\u304A\u3088\u3073\u7279\u5225\u7814\u7A76\u54E1PD\u306B\u5185\u5B9A\u3057\u307E\u3057\u305F"
            },
            "url": {
                "en": "https://www.jsps.go.jp/english/e-ab/index.html",
                "ja": "https://www.jsps.go.jp/j-ab/"
            },
            "year": 2022
        },
        {
            "month": 9,
            "name": {
                "en": "Finished research activities at Sorbonne Univ., back to Tokyo from Paris",
                "ja": "\u30BD\u30EB\u30DC\u30F3\u30CC\u5927\u3067\u306E\u6EDE\u5728\u3092\u7D42\u3048\u3066\u30D1\u30EA\u304B\u3089\u6771\u4EAC\u306B\u623B\u308A\u307E\u3057\u305F"
            },
            "year": 2022
        },
        {
            "month": 9,
            "name": {
                "en": "Got a research grant: ACT-X \"AI powered Research Innovation / Creation\"\n",
                "ja": "ACT-X\u300CAI\u6D3B\u7528\u3067\u6311\u3080\u5B66\u554F\u306E\u9769\u65B0\u3068\u5275\u6210\u300D\u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F"
            },
            "url": "https://www.jst.go.jp/kisoken/act-x/application/2022/220920/220920.html",
            "year": 2022
        },
        {
            "month": 9,
            "name": {
                "en": "One talk at MaC-22 in Pisa, Italy",
                "ja": "MaC-22@\u30A4\u30BF\u30EA\u30A2\u30FB\u30D4\u30B5\u3067\u7814\u7A76\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "http://sbrinz.di.unipi.it/peppe/MAC2022/MAC2022.html",
            "year": 2022
        },
        {
            "month": 9,
            "name": {
                "en": "Seminar talk at the VUB AI lab, Belgium",
                "ja": "VUB AI Lab@\u30D9\u30EB\u30AE\u30FC\u30FB\u30D6\u30EA\u30E5\u30C3\u30BB\u30EB\u81EA\u7531\u5927\u5B66\u3092\u8A2A\u554F\u3057\u3066\u30BB\u30DF\u30CA\u30FC\u30C8\u30FC\u30AF\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://ai.vub.ac.be/",
            "year": 2022
        },
        {
            "month": 8,
            "name": {
                "en": "Seminar talk at HyCoDeV Lab at Newcastle University, UK",
                "ja": "HyCoDeV Lab@\u30A4\u30AE\u30EA\u30B9\u30FB\u30CB\u30E5\u30FC\u30AB\u30C3\u30B9\u30EB\u5927\u3092\u8A2A\u554F\u3057\u3066\u30BB\u30DF\u30CA\u30FC\u30C8\u30FC\u30AF\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://hycodev.com/",
            "year": 2022
        },
        {
            "month": 8,
            "name": {
                "en": "Seminar talk at Prorok Lab at the University of Cambridge, UK",
                "ja": "Prorok Lab@\u30A4\u30AE\u30EA\u30B9\u30FB\u30B1\u30F3\u30D6\u30EA\u30C3\u30B8\u5927\u3092\u8A2A\u554F\u3057\u3066\u30BB\u30DF\u30CA\u30FC\u30C8\u30FC\u30AF\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://www.proroklab.org/",
            "year": 2022
        },
        {
            "month": 7,
            "name": {
                "en": "One talk at IJCAI-22 in Vienna, Austria",
                "ja": "IJCAI-22@\u30AA\u30FC\u30B9\u30C8\u30EA\u30A2\u30FB\u30A6\u30A3\u30FC\u30F3\u3067\u4E3B\u8457\u8AD6\u6587\u306E\u7814\u7A76\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://ijcai-22.org/",
            "year": 2022
        },
        {
            "month": 7,
            "name": {
                "en": "Invited talk \"Navigation for a team of agents\" at the 27th CoRe Seminar",
                "ja": "\u300C\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7FA4\u306E\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u300D\u3068\u984C\u3057\u3066\u7D44\u5408\u305B\u9077\u79FB\u30FB\u7B2C27\u56DE\u30BB\u30DF\u30CA\u30FC\u3067\u62DB\u5F85\u8B1B\u6F14\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": {
                "en": "https://core.dais.is.tohoku.ac.jp/en/report/event/detail/---id-125.html",
                "ja": "https://core.dais.is.tohoku.ac.jp/report/event/detail/---id-124.html"
            },
            "year": 2022
        },
        {
            "month": 7,
            "name": {
                "en": "Our paper \"Priority Inheritance with Backtracking for Iterative Multi-agent Path Finding\" has been published at Artificial Intelligence (AIJ)!",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Priority Inheritance with Backtracking for Iterative Multi-agent Path Finding" \u304C Artificial Intelligence (AIJ) \u306B\u63B2\u8F09\u3055\u308C\u307E\u3057\u305F'
            },
            "url": "https://www.sciencedirect.com/science/article/pii/S0004370222000923",
            "year": 2022
        },
        {
            "month": 7,
            "name": {
                "en": "\"Awesome CS-Ja PhD Life\" is out on GitHub!",
                "ja": '"Awesome CS-Ja PhD Life"\u3068\u3044\u3046CS\u535A\u58EB\u8AB2\u7A0B\u306E\u30B5\u30D0\u30A4\u30D6\u306B\u5F79\u7ACB\u3061\u305D\u3046\u306A\u8A18\u4E8B\u30EA\u30B9\u30C8\u3092\u516C\u958B\u3057\u307E\u3057\u305F'
            },
            "url": "https://github.com/Kei18/awesome_cs-ja_phd_life",
            "year": 2022
        },
        {
            "month": 6,
            "name": {
                "en": "One talk at ICAPS-22",
                "ja": "ICAPS-22 \u3067\u4E3B\u8457\u8AD6\u6587\u306E\u7814\u7A76\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "http://icaps22.icaps-conference.org/",
            "year": 2022
        },
        {
            "month": 5,
            "name": {
                "en": "One talk at AAMAS-22",
                "ja": "AAMAS-22 \u3067\u4E3B\u8457\u8AD6\u6587\u306E\u7814\u7A76\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://aamas2022-conference.auckland.ac.nz/",
            "year": 2022
        },
        {
            "month": 5,
            "name": {
                "en": "Surprisingly got the ICAPS 2022 Best Student Paper Award! Many thanks to Xavier and anonymous reviewers who gave me many constructive comments in the submissions.",
                "ja": "The ICAPS 2022 Best Student Paper Award\u3092\u53D7\u8CDE\u3057\u307E\u3057\u305F! Defago\u5148\u751F\u3068\u5EFA\u8A2D\u7684\u306A\u30B3\u30E1\u30F3\u30C8\u3092\u3057\u3066\u3044\u305F\u3060\u3044\u305F\u533F\u540D\u67FB\u8AAD\u8005\u306E\u65B9\u3005\u306B\u611F\u8B1D\u3057\u307E\u3059."
            },
            "url": "https://icaps22.icaps-conference.org/awards.html",
            "year": 2022
        },
        {
            "month": 4,
            "name": {
                "en": "Our paper \"Offline Time-Independent Multi-Agent Path Planning\" has been accepted to IJCAI-22!",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Offline Time-Independent Multi-Agent Path Planning" \u304C IJCAI-22 \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F!'
            },
            "url": "https://ijcai-22.org/",
            "year": 2022
        },
        {
            "month": 3,
            "name": {
                "en": "Starting my research at LIP6, Sorbonne University in Paris",
                "ja": "\u30BD\u30EB\u30DC\u30F3\u30CC\u5927\u5B66(\u30D1\u30EA)\u3067\u306E\u7814\u7A76\u6D3B\u52D5\u3092\u958B\u59CB\u3057\u307E\u3057\u305F"
            },
            "url": "https://www.lip6.fr",
            "year": 2022
        },
        {
            "month": 3,
            "name": {
                "en": "A preprint paper \"Quick Multi-Robot Motion Planning by Combining Sampling and Search\" is out on arXiv.",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Quick Multi-Robot Motion Planning by Combining Sampling and Search" \u306E\u30D7\u30EC\u30D7\u30EA\u30F3\u30C8\u3092arXiv\u306B\u516C\u958B\u3057\u307E\u3057\u305F.'
            },
            "url": "https://kei18.github.io/sssp/",
            "year": 2022
        },
        {
            "month": 2,
            "name": {
                "en": "Our paper \"Solving Simultaneous Target Assignment and Path Planning Efficiently with Time-Independent Execution\" has been accepted to ICAPS-22!",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Solving Simultaneous Target Assignment and Path Planning Efficiently with Time-Independent Execution" \u304C ICAPS-22 \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F!'
            },
            "url": "http://icaps22.icaps-conference.org/",
            "year": 2022
        },
        {
            "month": 2,
            "name": {
                "en": "Start research internship at LIP6, Sorbonne University, supervised by Prof. Sebastien Tixeuil",
                "ja": "LIP6@\u30BD\u30EB\u30DC\u30F3\u30CC\u5927\u5B66, Tixeuil Sebastien \u6559\u6388\u306E\u4E0B\u3067\u30A4\u30F3\u30BF\u30FC\u30F3\u30B7\u30C3\u30D7(\u30EA\u30E2\u30FC\u30C8)\u3092\u59CB\u3081\u307E\u3057\u305F. 3\u6708\u534A\u3070\u304B\u3089\u6EDE\u5728\u4E88\u5B9A\u3067\u3059."
            },
            "url": "https://www.lip6.fr/",
            "year": 2022
        },
        {
            "month": 12,
            "name": {
                "en": "Our paper \"CTRMs: Learning to Construct Cooperative Timed Roadmaps for Multi-agent Path Planning in Continuous Spaces\", the outcome of my internship at OSX, has been accepted to AAMAS-22!",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "CTRMs: Learning to Construct Cooperative Timed Roadmaps for Multi-agent Path Planning in Continuous Spaces" \u304C AAMAS-22 \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F! \u30A4\u30F3\u30BF\u30FC\u30F3@OSX \u3067\u306E\u6210\u679C\u3067\u3059.'
            },
            "url": "https://aamas2022-conference.auckland.ac.nz/",
            "year": 2021
        },
        {
            "month": 11,
            "name": {
                "en": "Received an offer of JSPS Overseas Challenge Program for Young Researchers",
                "ja": "\u65E5\u672C\u5B66\u8853\u632F\u8208\u4F1A \u82E5\u624B\u7814\u7A76\u8005\u6D77\u5916\u6311\u6226\u30D7\u30ED\u30B0\u30E9\u30E0\u306B\u5185\u5B9A\u3057\u307E\u3057\u305F"
            },
            "url": "https://www.jsps.go.jp/j-abc/index.html",
            "year": 2021
        },
        {
            "month": 11,
            "name": {
                "en": "A preprint paper \"Priority Inheritance with Backtracking for Iterative Multi-agent Path Finding\", an extended version of IJCAI-19 for a journal, is out on arXiv.",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Priority Inheritance with Backtracking for Iterative Multi-agent Path Finding" \u306E\u30D7\u30EC\u30D7\u30EA\u30F3\u30C8\u3092arXiv\u306B\u516C\u958B\u3057\u307E\u3057\u305F. IJCAI-19 \u3092\u30B8\u30E3\u30FC\u30CA\u30EB\u7528\u306B\u62E1\u5F35\u3057\u3066\u3044\u307E\u3059'
            },
            "url": "https://kei18.github.io/pibt2/",
            "year": 2021
        },
        {
            "month": 10,
            "name": {
                "en": "Got Nomination Award of the 2021 Microsoft Research Asia Fellowship",
                "ja": "2021 Microsoft Research Asia Fellowship \u306E Nomination Award \u3092\u53D7\u8CDE\u3057\u307E\u3057\u305F"
            },
            "url": "https://www.microsoft.com/en-us/research/lab/microsoft-research-asia/articles/eleven-phd-students-are-awarded-the-2021-microsoft-research-asia-fellowship-award/",
            "year": 2021
        },
        {
            "month": 10,
            "name": {
                "en": "Finish internship at OMRON SINIC X",
                "ja": "OMRON SINIC X \u3067\u306E\u30A4\u30F3\u30BF\u30FC\u30F3\u3092\u7D42\u3048\u307E\u3057\u305F. \u975E\u5E38\u306B\u826F\u3044\u7D4C\u9A13\u3067\u3057\u305F"
            },
            "url": "https://www.omron.com/sinicx/",
            "year": 2021
        },
        {
            "month": 9,
            "name": {
                "en": "One talk at IROS-21",
                "ja": "IROS-21 \u3067\u4E3B\u8457\u8AD6\u6587\u306E\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://www.iros2021.org/",
            "year": 2021
        },
        {
            "month": 9,
            "name": {
                "en": "One talk at WTCS-21. I got an outstanding presentation award!",
                "ja": "WTCS-21 \u3067\u7814\u7A76\u767A\u8868\u3092\u884C\u3044, \u512A\u79C0\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u8CDE\u3092\u53D7\u8CDE\u3057\u307E\u3057\u305F"
            },
            "url": "https://w-tcs.github.io/2021/",
            "year": 2021
        },
        {
            "month": 9,
            "name": {
                "en": "A preprint paper \"Solving Simultaneous Target Assignment and Path Planning Efficiently with Time-Independent Execution\" is out on arXiv",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Solving Simultaneous Target Assignment and Path Planning Efficiently with Time-Independent Execution" \u306E\u30D7\u30EC\u30D7\u30EA\u30F3\u30C8\u3092arXiv\u306B\u516C\u958B\u3057\u307E\u3057\u305F'
            },
            "url": "https://arxiv.org/abs/2109.04264",
            "year": 2021
        },
        {
            "month": 8,
            "name": {
                "en": "Our paper \"Roadside-assisted Cooperative Planning using Future Path Sharing for Autonomous Driving\" has been accepted to VTC2021-Fall!",
                "ja": '\u5171\u8457\u8AD6\u6587 "Roadside-assisted Cooperative Planning using Future Path Sharing for Autonomous Driving" \u304C VTC2021-Fall \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F!'
            },
            "url": "https://events.vtsociety.org/vtc2021-fall/",
            "year": 2021
        },
        {
            "month": 7,
            "name": {
                "en": "Our paper \"Iterative Refinement for Real-Time Multi-Robot Path Planning\" has been accepted to IROS-21!",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Iterative Refinement for Real-Time Multi-Robot Path Planning" \u304C IROS-21 \u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F!'
            },
            "url": "https://www.iros2021.org/",
            "year": 2021
        },
        {
            "month": 6,
            "name": {
                "en": "One talk at JSAI-21",
                "ja": "JSAI-21 \u306B\u3066\u7814\u7A76\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://www.ai-gakkai.or.jp/jsai2021/",
            "year": 2021
        },
        {
            "month": 6,
            "name": {
                "en": "One talk at ICRA-21",
                "ja": "ICRA-21 \u3067\u5171\u8457\u8AD6\u6587\u306E\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://www.ieee-icra.org/",
            "year": 2021
        },
        {
            "month": 5,
            "name": {
                "en": "A preprint paper \"Offline Time-Independent Multi-Agent Path Planning\" is out on arXiv",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Offline Time-Independent Multi-Agent Path Planning" \u306E\u30D7\u30EC\u30D7\u30EA\u30F3\u30C8\u3092arXiv\u306B\u516C\u958B\u3057\u307E\u3057\u305F'
            },
            "url": "https://arxiv.org/abs/2105.07132",
            "year": 2021
        },
        {
            "month": 4,
            "name": {
                "en": "Start research internship at OSX (OMRON SINIC X)",
                "ja": "OSX (OMRON SINIC X) \u3067\u30A4\u30F3\u30BF\u30FC\u30F3\u30B7\u30C3\u30D7\u3092\u59CB\u3081\u307E\u3057\u305F. \u30D7\u30E9\u30F3\u30CB\u30F3\u30B0x\u6A5F\u68B0\u5B66\u7FD2\u306E\u7814\u7A76\u306B\u5F93\u4E8B\u3059\u308B\u4E88\u5B9A\u3067\u3059."
            },
            "url": "https://www.omron.com/sinicx/",
            "year": 2021
        },
        {
            "month": 4,
            "name": {
                "en": "Got an award at the Fixstars Amplify Hackathon",
                "ja": "Fixstars Amplify \u30CF\u30C3\u30AB\u30BD\u30F3\u3067\u300CChamplify\u300D\u304C\u512A\u79C0\u8CDE\u3092\u53D7\u8CDE\u3057\u307E\u3057\u305F"
            },
            "url": "https://amplify.fixstars.com/hackathon00",
            "year": 2021
        },
        {
            "month": 3,
            "name": {
                "en": "One invited talk at the 116th SIG-FPAI",
                "ja": "\u7B2C116\u56DE\u4EBA\u5DE5\u77E5\u80FD\u57FA\u672C\u554F\u984C\u7814\u7A76\u4F1A(SIG-FPAI)\u306B\u3066\u62DB\u5F85\u8B1B\u6F14\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://sig-fpai.org/past/fpai116.html",
            "year": 2021
        },
        {
            "month": 3,
            "name": {
                "en": "One talk at IPSJ-21",
                "ja": "IPSJ-21\u306B\u3066\u7814\u7A76\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://www.ipsj.or.jp/event/taikai/83/",
            "year": 2021
        },
        {
            "month": 3,
            "name": {
                "en": "Our paper \"Active Modular Environment for Robot Navigation\" has been accepted to ICRA-21!",
                "ja": '\u5171\u8457\u8AD6\u6587 "Active Modular Environment for Robot Navigation" \u304CICRA-21\u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F!'
            },
            "url": "http://www.icra2021.org/",
            "year": 2021
        },
        {
            "month": 2,
            "name": {
                "en": "A preprint paper \"Iterative Refinement for Real-Time Multi-Robot Path Planning\" is out on arXiv",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Iterative Refinement for Real-Time Multi-Robot Path Planning" \u306E\u30D7\u30EC\u30D7\u30EA\u30F3\u30C8\u3092arXiv\u306B\u516C\u958B\u3057\u307E\u3057\u305F'
            },
            "url": "https://arxiv.org/abs/2102.12331",
            "year": 2021
        },
        {
            "month": 2,
            "name": {
                "en": "One talk at AAAI-21",
                "ja": "AAAI-21\u3067\u4E3B\u8457\u8AD6\u6587\u306E\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://aaai.org/Conferences/AAAI-21/",
            "year": 2021
        },
        {
            "month": 1,
            "name": {
                "en": "One talk \"winPIBT: Extended Prioritized Algorithm for Iterative Multi-agent Path Finding\" at WoMAPF-20",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "winPIBT: Extended Prioritized Algorithm for Iterative Multi-agent Path Finding"\u3092 WoMAPF-20 \u306B\u3066\u767A\u8868\u3057\u307E\u3057\u305F'
            },
            "url": "http://idm-lab.org/wiki/IJCAI20-MAPF/",
            "year": 2021
        },
        {
            "month": 12,
            "name": {
                "en": "Our paper \"Time-Independent Planning for Multiple Moving Agents\" has been accepted to AAAI-21!",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Time-Independent Planning for Multiple Moving Agents" \u304CAAAI-21\u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F!'
            },
            "url": "https://aaai.org/Conferences/AAAI-21/",
            "year": 2020
        },
        {
            "month": 10,
            "name": {
                "en": "I attended to ICAPS-20 Summer School on Automated Planning & Scheduling",
                "ja": "ICAPS-20 Summer School on Automated Planning & Scheduling\u306B\u53C2\u52A0\u3057\u307E\u3057\u305F"
            },
            "url": {
                "en": "https://icaps20subpages.icaps-conference.org/students/summer-school/",
                "ja": "https://kei18.github.io/posts/20201017_ICAPS-Summer-School.html"
            },
            "year": 2020
        },
        {
            "month": 9,
            "name": {
                "en": "One talk at WTCS-20. I got an outstanding presentation award",
                "ja": "WTCS-20\u3067\u7814\u7A76\u767A\u8868\u3092\u884C\u3044, \u512A\u79C0\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u8CDE\u3092\u53D7\u8CDE\u3057\u307E\u3057\u305F"
            },
            "url": "https://w-tcs.github.io/2020/",
            "year": 2020
        },
        {
            "month": 7,
            "name": {
                "en": "Selected as JASSO Repayment Exemption for Students with Excellent Grades",
                "ja": "\u65E5\u672C\u5B66\u751F\u652F\u63F4\u6A5F\u69CB \u7B2C\u4E00\u7A2E\u5968\u5B66\u91D1 \u5168\u984D\u8FD4\u6E08\u514D\u9664\u304C\u6C7A\u307E\u308A\u307E\u3057\u305F"
            },
            "url": "https://www.jasso.go.jp/shogakukin/taiyochu/gyosekimenjyo/index.html",
            "year": 2020
        },
        {
            "month": 6,
            "name": {
                "en": "An interview article has been published at \"someone vol.51\"",
                "ja": "someone vol.51\u3068\u3044\u3046\u4E2D\u9AD8\u751F\u5411\u3051\u306E\u79D1\u5B66\u518A\u5B50\u306B\u30A4\u30F3\u30BF\u30D3\u30E5\u30FC\u8A18\u4E8B\u304C\u63B2\u8F09\u3055\u308C\u307E\u3057\u305F"
            },
            "url": "https://lne.st/business/publishing/someone/",
            "year": 2020
        },
        {
            "month": 4,
            "name": {
                "en": "Our paper \"Investigating the Hand Ownership Illusion with Two Views Merged in\" has been published at Frontiers in Robotics and AI!",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Investigating the Hand Ownership Illusion with Two Views Merged in" \u304C Frontiers in Robotics and AI \u306B\u63B2\u8F09\u3055\u308C\u307E\u3057\u305F'
            },
            "url": "https://www.frontiersin.org/articles/10.3389/frobt.2020.00049/full",
            "year": 2020
        },
        {
            "month": 4,
            "name": {
                "en": "I got an M.Eng in CS and a graduate minor in physics from the TokyoTech. I also start my Ph.D. course",
                "ja": "\u6771\u4EAC\u5DE5\u696D\u5927\u5B66\u306E\u4FEE\u58EB\u8AB2\u7A0B(\u5DE5\u5B66, \u526F\u5C02\u9580:\u7269\u7406\u5B66)\u3092\u7D42\u4E86\u3057, \u535A\u58EB\u8AB2\u7A0B(\u60C5\u5831\u7406\u5DE5\u5B66\u9662)\u306B\u9032\u5B66\u3057\u307E\u3057\u305F"
            },
            "year": 2020
        },
        {
            "month": 11,
            "name": {
                "en": "One invited talk at WDALFR-19",
                "ja": "WDALFR-19\u306B\u3066\u62DB\u5F85\u8B1B\u6F14\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://sites.google.com/view/wdalfr/the-1st-wdalfr2019",
            "year": 2019
        },
        {
            "month": 9,
            "name": {
                "en": "Received an offer of JSPS Research Fellow DC1",
                "ja": "\u65E5\u672C\u5B66\u8853\u632F\u8208\u4F1A\u7279\u5225\u7814\u7A76\u54E1DC1\u306B\u5185\u5B9A\u3057\u307E\u3057\u305F"
            },
            "url": {
                "en": "https://www.jsps.go.jp/english/e-pd/index.html",
                "ja": "https://www.jsps.go.jp/j-pd/"
            },
            "year": 2019
        },
        {
            "month": 9,
            "name": {
                "en": "One talk at FIT-19",
                "ja": "FIT-19\u306B\u3066\u7814\u7A76\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://www.ipsj.or.jp/event/fit/fit2019/",
            "year": 2019
        },
        {
            "month": 9,
            "name": {
                "en": "One talk at WTCS-19. I got the best research award!",
                "ja": "WTCS-19\u3067\u7814\u7A76\u767A\u8868\u3092\u884C\u3044, \u6700\u512A\u79C0\u8B1B\u6F14\u8CDE\u3092\u53D7\u8CDE\u3057\u307E\u3057\u305F"
            },
            "url": "https://w-tcs.github.io/2019/",
            "year": 2019
        },
        {
            "month": 8,
            "name": {
                "en": "One talk at IJCAI-19",
                "ja": "IJCAI-19\u306B\u3066\u4E3B\u8457\u8AD6\u6587\u306E\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://ijcai19.org/",
            "year": 2019
        },
        {
            "month": 6,
            "name": {
                "en": "Selected as Yoshida Scholarship Foundation Doctor21",
                "ja": "\u5409\u7530\u80B2\u82F1\u4F1A\u30C9\u30AF\u30BF\u30FC21\u306B\u5185\u5B9A\u3057\u307E\u3057\u305F"
            },
            "url": "https://www.ysf.or.jp/scholarship/visitor/internal/doctor21.php",
            "year": 2019
        },
        {
            "month": 6,
            "name": {
                "en": "Our paper \"Priority Inheritance with Backtracking for Iterative Mulit-agent Path Finding\" has been accepted to IJCAI-19!",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Priority Inheritance with Backtracking for Iterative Mulit-agent Path Finding" \u304CIJCAI-19\u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F'
            },
            "url": "https://ijcai19.org/",
            "year": 2019
        },
        {
            "month": 12,
            "name": {
                "en": "One talk at SI-18",
                "ja": "SI-18\u3067\u7814\u7A76\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://www.sice-si.org/conf/si2018/",
            "year": 2018
        },
        {
            "month": 9,
            "name": {
                "en": "One talk at iCAST-18",
                "ja": "iCAST-18\u3067\u7814\u7A76\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "http://www.design.kyushu-u.ac.jp/~icast/",
            "year": 2018
        },
        {
            "month": 8,
            "name": {
                "en": "research internship at NEC Data Science Lab",
                "ja": "NEC\u30C7\u30FC\u30BF\u30B5\u30A4\u30A8\u30F3\u30B9\u7814\u7A76\u6240\u3067\u30A4\u30F3\u30BF\u30FC\u30F3\u30B7\u30C3\u30D7\u3092\u59CB\u3081\u307E\u3057\u305F"
            },
            "year": 2018
        },
        {
            "month": 8,
            "name": {
                "en": "Our paper \"Amoeba Exploration: Coordinated Exploration with Distributed Robots\" has been accepted to iCAST-18!",
                "ja": '\u4E3B\u8457\u8AD6\u6587 "Amoeba Exploration: Coordinated Exploration with Distributed Robots" \u304CiCAST-18\u306B\u63A1\u629E\u3055\u308C\u307E\u3057\u305F'
            },
            "url": "http://www.design.kyushu-u.ac.jp/~icast/",
            "year": 2018
        },
        {
            "month": 6,
            "name": {
                "en": "One talk at IMRF-18",
                "ja": "IMRF-18\u306B\u3066\u7814\u7A76\u767A\u8868\u3092\u884C\u3044\u307E\u3057\u305F"
            },
            "url": "https://imrf.info/wp_imrf/timetable/category/imrf-2018/",
            "year": 2018
        },
        {
            "month": 4,
            "name": {
                "en": "I got an B.Eng in CS from the TokyoTech. I also start my master course",
                "ja": "\u6771\u4EAC\u5DE5\u696D\u5927\u5B66\u306E\u5B66\u58EB\u8AB2\u7A0B(\u5DE5\u5B66)\u3092\u7D42\u4E86\u3057, \u4FEE\u58EB\u8AB2\u7A0B(\u60C5\u5831\u7406\u5DE5\u5B66\u9662)\u306B\u9032\u5B66\u3057\u307E\u3057\u305F"
            },
            "year": 2018
        }
    ]
};


var $f4d3a71b3cce4a77$exports = {};
$f4d3a71b3cce4a77$exports = [
    {
        "affiliation": {
            "en": "National Institute of Advanced Industrial Science and Technology (AIST)",
            "ja": "\u7523\u696D\u6280\u8853\u7DCF\u5408\u7814\u7A76\u6240"
        },
        "link": {
            "en": "https://www.aist.go.jp/index_en.html",
            "ja": "https://www.aist.go.jp/"
        },
        "role": {
            "en": "Researcher",
            "ja": "\u7814\u7A76\u54E1"
        },
        "term": {
            "en": "Apr. 2023 - present",
            "ja": "2023\u5E744\u6708 - \u73FE\u5728"
        },
        "topics": {
            "en": "affiliation: Artificial Intelligence Research Center (AIRC) /\nconcurrent: TICO-AIST Cooperative Research Laboratory for Advanced Logistics\n",
            "ja": "\u6240\u5C5E: \u4EBA\u5DE5\u77E5\u80FD\u7814\u7A76\u30BB\u30F3\u30BF\u30FC \u793E\u4F1A\u77E5\u80FD\u7814\u7A76\u30C1\u30FC\u30E0 /\n\u517C\u52D9: \u8C4A\u7530\u81EA\u52D5\u7E54\u6A5F-\u7523\u7DCF\u7814 \u30A2\u30C9\u30D0\u30F3\u30B9\u30C8\u30FB\u30ED\u30B8\u30B9\u30C6\u30A3\u30AF\u30B9\u9023\u643A\u7814\u7A76\u30E9\u30DC\n"
        },
        "location": "Tokyo, Japan"
    },
    {
        "affiliation": {
            "en": "University of Cambridge",
            "ja": "\u82F1\u30B1\u30F3\u30D6\u30EA\u30C3\u30B8\u5927\u5B66"
        },
        "link": "https://www.cst.cam.ac.uk/",
        "others": {
            "en": "Host : Prof. Amanda Prorok",
            "ja": "\u30DB\u30B9\u30C8 : Prorok Amanda \u6559\u6388"
        },
        "role": {
            "en": "Visiting Postdoc Scholar",
            "ja": "\u5BA2\u54E1\u7814\u7A76\u54E1"
        },
        "term": {
            "en": "May. 2023 - Dec. 2025",
            "ja": "2023\u5E745\u6708 - 2025\u5E7412\u6708"
        },
        "topics": {
            "en": "supported by JSPS Overseas Fellowship\n",
            "ja": "JSPS \u6D77\u5916\u7279\u5225\u7814\u7A76\u54E1\n"
        },
        "location": "Cambridge, UK"
    },
    {
        "affiliation": {
            "en": "Japan Society for the Promotion of Science (JSPS)",
            "ja": "\u65E5\u672C\u5B66\u8853\u632F\u8208\u4F1A"
        },
        "link": {
            "en": "https://www.jsps.go.jp/english/e-pd/index.html",
            "ja": "https://www.jsps.go.jp/j-pd/index.html"
        },
        "role": {
            "en": "Research Fellowship for Young Scientists (DC1)",
            "ja": "\u7279\u5225\u7814\u7A76\u54E1 (DC1)"
        },
        "term": {
            "en": "Apr. 2020 - Mar. 2023",
            "ja": "2020\u5E744\u6708 - 2023\u5E743\u6708"
        },
        "topics": {
            "en": "Topics : Enhanced Cooperation of Moving Agents via an Active Modular Environment\n",
            "ja": "\u7814\u7A76\u30C6\u30FC\u30DE : \u79FB\u52D5\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7FA4\u306E\u5354\u8ABF\u884C\u52D5\u3092\u8A98\u767A\u3059\u308B\u74B0\u5883\u306B\u3088\u308B\u8A08\u7B97\u652F\u63F4\n"
        },
        "location": "Tokyo, Japan"
    },
    {
        "affiliation": {
            "en": "LIP6, Sorbonne University",
            "ja": "LIP6, \u4ECF\u30BD\u30EB\u30DC\u30F3\u30CC\u5927\u5B66"
        },
        "link": "https://www.lip6.fr/",
        "others": {
            "en": "Adviser : Prof. Sebastien Tixeuil",
            "ja": "\u30E1\u30F3\u30BF\u30FC : Tixeuil Sebastien \u6559\u6388"
        },
        "role": {
            "en": "Visiting Scholar",
            "ja": "\u5BA2\u54E1\u7814\u7A76\u54E1"
        },
        "term": {
            "en": "Feb. 2022 - Sep. 2022",
            "ja": "2022\u5E742\u6708 - 2022\u5E749\u6708"
        },
        "topics": {
            "en": "Topics : risk-aware multi-agent planning",
            "ja": "\u7814\u7A76\u30C6\u30FC\u30DE : \u30EA\u30B9\u30AF\u4E0B\u3067\u306E\u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u30D7\u30E9\u30F3\u30CB\u30F3\u30B0"
        },
        "location": "Paris, France"
    },
    {
        "affiliation": {
            "en": "OMRON SINIC X",
            "ja": "\u30AA\u30E0\u30ED\u30F3\u30B5\u30A4\u30CB\u30C3\u30AF\u30A8\u30C3\u30AF\u30B9\u682A\u5F0F\u4F1A\u793E"
        },
        "link": "https://www.omron.com/sinicx/",
        "others": {
            "en": "Adviser : Dr. Ryo Yonetani",
            "ja": "\u30E1\u30F3\u30BF\u30FC : \u7C73\u8C37\u7ADC \u535A\u58EB"
        },
        "role": {
            "en": "Research Internship",
            "ja": "\u7814\u7A76\u30A4\u30F3\u30BF\u30FC\u30F3\u30B7\u30C3\u30D7"
        },
        "term": {
            "en": "Apr. 2021 - Oct. 2021",
            "ja": "2021\u5E744\u6708 - 2021\u5E7410\u6708"
        },
        "topics": {
            "en": "Topics : data-driven multi-agent planning",
            "ja": "\u7814\u7A76\u30C6\u30FC\u30DE : \u30C7\u30FC\u30BF\u99C6\u52D5\u578B\u306E\u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u30D7\u30E9\u30F3\u30CB\u30F3\u30B0"
        },
        "location": "Tokyo, Japan"
    },
    {
        "affiliation": {
            "en": "Miyake Lab, Tokyo Institute of Technology",
            "ja": "\u6771\u4EAC\u5DE5\u696D\u5927\u5B66 \u4E09\u5B85\u7814\u7A76\u5BA4"
        },
        "icon": "tokyo-tech",
        "link": "http://www.myk.dis.titech.ac.jp/",
        "others": {
            "en": "Adviser : Dr. Hiroki Ora",
            "ja": "\u30E1\u30F3\u30BF\u30FC : \u5927\u826F\u5B8F\u6A39 \u535A\u58EB"
        },
        "role": {
            "en": "Research Student",
            "ja": "\u7814\u7A76\u751F"
        },
        "term": {
            "en": "Jun. 2016 - Mar. 2020",
            "ja": "2016\u5E746\u6708 - 2020\u5E743\u6708"
        },
        "topics": {
            "en": "Topics : Cognitive Science, Multimodal Integration, Body Ownership, VR",
            "ja": "\u7814\u7A76\u30C6\u30FC\u30DE : \u8A8D\u77E5\u79D1\u5B66, \u81EA\u5DF1\u8EAB\u4F53\u8A8D\u77E5, \u591A\u611F\u899A\u7D71\u5408, VR"
        },
        "location": "Kanagawa, Japan"
    },
    {
        "affiliation": {
            "en": "NEC Data Science Lab",
            "ja": "NEC \u30C7\u30FC\u30BF\u30B5\u30A4\u30A8\u30F3\u30B9\u7814\u7A76\u6240"
        },
        "icon": "nec",
        "link": {
            "en": "https://www.nec.com/en/global/rd/labs/datascience/index.html",
            "ja": "https://jpn.nec.com/rd/labs/datascience/index.html"
        },
        "others": {
            "en": "Adviser : Mr. Shinji Nakadai",
            "ja": "\u30E1\u30F3\u30BF\u30FC : \u4E2D\u53F0\u614E\u4E8C\u3055\u3093"
        },
        "role": {
            "en": "Research Internship",
            "ja": "\u7814\u7A76\u30A4\u30F3\u30BF\u30FC\u30F3\u30B7\u30C3\u30D7"
        },
        "term": {
            "en": "Aug. 2018 - Sep. 2018",
            "ja": "2018\u5E748\u6708 - 2018\u5E749\u6708"
        },
        "topics": {
            "en": "Topics : Multi-agent System, Combinatorial Auction, Machine Learning",
            "ja": "\u7814\u7A76\u30C6\u30FC\u30DE : \u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u30B7\u30B9\u30C6\u30E0, \u7D44\u5408\u305B\u6700\u9069\u5316, \u6A5F\u68B0\u5B66\u7FD2"
        },
        "location": "Kanagawa, Japan"
    }
];


var $5c662af821f55a2f$exports = {};
$5c662af821f55a2f$exports = [
    {
        "adviser": {
            "link": "https://www.coord.c.titech.ac.jp/m/defago/",
            "name": {
                "en": "Prof. Xavier D\xe9fago",
                "ja": "Xavier D\xe9fago \u6559\u6388"
            }
        },
        "affiliation": {
            "en": "School of Computing, Tokyo Institute of Technology, Japan (currently called Institute of Science Tokyo)",
            "ja": "\u6771\u4EAC\u5DE5\u696D\u5927\u5B66 \u60C5\u5831\u7406\u5DE5\u5B66\u9662 (\u73FE \u6771\u4EAC\u79D1\u5B66\u5927\u5B66)"
        },
        "degree": {
            "en": "Doctor of Engineering in Artificial Intelligence",
            "ja": "\u535A\u58EB (\u5DE5\u5B66)"
        },
        "link": {
            "en": "https://www.titech.ac.jp/english/",
            "ja": "https://www.titech.ac.jp/"
        },
        "term": {
            "en": "Apr. 2020 - Mar. 2023",
            "ja": "2020\u5E744\u6708 - 2023\u5E743\u6708"
        }
    },
    {
        "adviser": {
            "link": "https://www.coord.c.titech.ac.jp/m/defago/",
            "name": {
                "en": "Prof. Xavier D\xe9fago",
                "ja": "Xavier D\xe9fago \u6559\u6388"
            }
        },
        "affiliation": {
            "en": "Graduate Major in Artificial Intelligence, School of Computing, Minor Major in Physics, Tokyo Institute of Technology, Japan",
            "ja": "\u6771\u4EAC\u5DE5\u696D\u5927\u5B66 \u60C5\u5831\u7406\u5DE5\u5B66\u9662 \u77E5\u80FD\u60C5\u5831\u30B3\u30FC\u30B9, \u526F\u5C02\u9580: \u7269\u7406\u5B66\u30B3\u30FC\u30B9"
        },
        "degree": {
            "en": "Master of Engineering",
            "ja": "\u4FEE\u58EB (\u5DE5\u5B66)"
        },
        "link": {
            "en": "https://www.titech.ac.jp/english/",
            "ja": "https://www.titech.ac.jp/"
        },
        "term": {
            "en": "Apr. 2018 - Mar. 2020",
            "ja": "2018\u5E744\u6708 - 2020\u5E743\u6708"
        }
    },
    {
        "adviser": {
            "link": "https://www.coord.c.titech.ac.jp/m/defago/",
            "name": {
                "en": "Prof. Xavier D\xe9fago",
                "ja": "Xavier D\xe9fago \u6559\u6388"
            }
        },
        "affiliation": {
            "en": "Department of Computer Science, Tokyo Institute of Technology, Japan",
            "ja": "\u6771\u4EAC\u5DE5\u696D\u5927\u5B66 \u5DE5\u5B66\u90E8\u60C5\u5831\u5DE5\u5B66\u79D1"
        },
        "degree": {
            "en": "Bachelor of Engineering",
            "ja": "\u5B66\u58EB (\u5DE5\u5B66)"
        },
        "link": {
            "en": "https://www.titech.ac.jp/english/",
            "ja": "https://www.titech.ac.jp/"
        },
        "term": {
            "en": "Apr. 2014 - Mar. 2018",
            "ja": "2014\u5E744\u6708 - 2018\u5E743\u6708"
        }
    }
];


var $ebc05d05124bebbf$exports = {};
$ebc05d05124bebbf$exports = [
    {
        "description": {
            "en": "Systems with physical multiple moving agents will be more and more common,\ne.g., automated warehouse, delivery service with robots, self-driving cars,\netc. Obviously, such systems should be well-coordinated, but in general, coordination/cooperation\nthemselves are ambiguous and intractable, such as societies of ants and bees.\nTherefore, I believe that multiple moving agents have a lot of applications\nthat we cannot imagine right now. My research questions are twofold: 1) explore\nthe potential of multiple moving agents, 2) characterize cooperative behavior\nof moving agents.\n",
            "ja": "\u4EBA\u4F53\u3092\u5FC5\u8981\u3068\u3057\u305F\u4F5C\u696D\u304C\u6A5F\u68B0\u7FA4\u306B\u7F6E\u304D\u63DB\u3048\u3089\u308C\u3066\u3086\u304F\u904E\u6E21\u671F\u306B\u3042\u305F\u3063\u3066,\n\u79FB\u52D5\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7FA4\u3092\u81EA\u7531\u81EA\u5728\u306B\u64CD\u308B\u305F\u3081\u306E\u7814\u7A76\u306F\u9AD8\u5EA6\u306A\u30AA\u30FC\u30C8\u30E1\u30FC\u30B7\u30E7\u30F3\u5316\u306E\u6839\u5E79\u3092\u306A\u3059.\n\u57FA\u5E79\u3068\u306A\u308B\u6280\u8853\u306F, \u7D4C\u8DEF\u8A08\u753B\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u3084\u8A08\u753B\u306E\u5B9F\u884C\u30DD\u30EA\u30B7\u30FC,\n\u30DE\u30EB\u30C1\u30ED\u30DC\u30C3\u30C8\u30B7\u30B9\u30C6\u30E0\u306E\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u7B49\u3067\u3042\u308B.\n\u5206\u6563\u7684\u306A\u74B0\u5883\u3067\u52D5\u304F, \u9069\u5FDC\u7684\u304B\u3064\u30B9\u30B1\u30FC\u30E9\u30D6\u30EB\u306A\u5B9F\u73FE\u65B9\u6CD5\u3092\u8FFD\u6C42\u3057,\n\u5C06\u6765, SF\u306E\u3088\u3046\u306B\u81EA\u5F8B\u30ED\u30DC\u30C3\u30C8\u7FA4\u306B\u5E02\u8857\u3067\u8E8D\u52D5\u3057\u3066\u3082\u3089\u3046\u3053\u3068\u3092\u76EE\u6307\u3059.\n"
        },
        "gif": [
            {
                "src": "mapf",
                "title": {
                    "en": "multi-agent path finding",
                    "ja": "\u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7D4C\u8DEF\u8A08\u753B"
                }
            },
            {
                "src": "reloc",
                "title": {
                    "en": "deadlock-free execution",
                    "ja": "\u30C7\u30C3\u30C9\u30ED\u30C3\u30AF\u30D5\u30EA\u30FC\u306A\u8A08\u753B\u5B9F\u884C"
                }
            },
            {
                "src": "10drones",
                "title": {
                    "en": "drone swarm control",
                    "ja": "\u30C9\u30ED\u30FC\u30F3\u7FA4\u306E\u5236\u5FA1"
                }
            }
        ],
        "title": {
            "en": "Intelligent Collective Behavior Design for Swarm Agents",
            "ja": "\u81EA\u5F8B\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7FA4\u306E\u5236\u5FA1"
        }
    }
];


var $9355e851a7af8fb5$exports = {};
$9355e851a7af8fb5$exports = [
    {
        "description": {
            "en": "collection of articles about PhD life written in Japanese.",
            "ja": "CS\u535A\u58EB\u8AB2\u7A0B\u306E\u30B5\u30D0\u30A4\u30D6\u306B\u5F79\u7ACB\u3061\u305D\u3046\u306A\u8A18\u4E8B\u30EA\u30B9\u30C8."
        },
        "img": "awesome-cs-ja-phd-life",
        "links": [
            {
                "title": "github",
                "url": "https://github.com/Kei18/awesome_cs-ja_phd_life"
            }
        ],
        "month": 7,
        "title": "Awesome CS-Ja PhD Life",
        "year": 2022
    }
];


var $315d147b3a3783e4$exports = {};
$315d147b3a3783e4$exports = {
    "academicAwards": [
        {
            "month": 8,
            "name": {
                "en": "The SoCS 2026 Best Student Paper Award (w/Tomoki Arita)\n",
                "ja": "The SoCS 2026 Best Student Paper Award (\u6176\u61C9\u5927\u30FB\u6709\u7530\u3055\u3093\u3068\u306E\u5171\u8457)\n"
            },
            "url": "https://socs26.search-conference.org/home",
            "year": 2026
        },
        {
            "month": 2,
            "name": {
                "en": "Funai Information Technology Award for Young Researchers",
                "ja": "\u8239\u4E95\u7814\u7A76\u5968\u52B1\u8CDE"
            },
            "url": "https://funaifoundation.jp/news-580.htm",
            "year": 2026
        },
        {
            "month": 3,
            "name": {
                "en": "Ph.D. Dissertation Award (Seiichi Tejima Research Award), Tokyo Institute of Technology",
                "ja": "\u6771\u4EAC\u5DE5\u696D\u5927\u5B66 \u624B\u5CF6\u7CBE\u4E00\u8A18\u5FF5\u7814\u7A76\u8CDE (\u535A\u58EB\u8AD6\u6587\u8CDE)"
            },
            "url": "https://educ.titech.ac.jp/cs/news/2024_05/066030.html",
            "year": 2024
        },
        {
            "month": 5,
            "name": "The ICAPS 2022 Best Student Paper Award",
            "url": "https://icaps22.icaps-conference.org/awards.html",
            "year": 2022
        },
        {
            "month": 10,
            "name": "Nomination Award of the 2021 Microsoft Research Asia Fellowship",
            "url": "https://www.microsoft.com/en-us/research/lab/microsoft-research-asia/articles/eleven-phd-students-are-awarded-the-2021-microsoft-research-asia-fellowship-award/",
            "year": 2021
        }
    ],
    "menteeAwards": [
        {
            "month": 9,
            "name": {
                "en": "Fumimaro Suzuki. The Student Encouragement Award, SMASH26 (Japanese domestic conference)\n",
                "ja": "\u9234\u6728\u53F2\u9EBF. SMASH26 Summer Symposium \u7814\u7A76\u5968\u52B1\u8CDE \\& \u96FB\u5B50\u60C5\u5831\u901A\u4FE1\u5B66\u4F1A \u4EBA\u5DE5\u77E5\u80FD\u3068\u77E5\u8B58\u51E6\u7406\u5C02\u9580\u59D4\u54E1\u4F1A \u7814\u7A76\u5968\u52B1\u8CDE\n"
            },
            "url": "https://sites.google.com/view/sig-macc/smash/smash26-summer-symposium/%E8%A1%A8%E5%BD%B02608",
            "year": 2026
        },
        {
            "month": 8,
            "name": {
                "en": "Tomoki Arita. The SoCS 2026 Best Student Paper Award\n",
                "ja": "\u6709\u7530\u670B\u6A39. The SoCS 2026 Best Student Paper Award\n"
            },
            "year": 2026,
            "url": "https://socs26.search-conference.org/"
        },
        {
            "month": 3,
            "name": {
                "en": "Tsukasa Ueshima. The Student Encouragement Award, IPSJ (Japanese domestic conference)\n",
                "ja": "\u4E0A\u5CF6 \u53F8. \u60C5\u5831\u51E6\u7406\u5B66\u4F1A \u5B66\u751F\u5968\u52B1\u8CDE\n"
            },
            "url": "https://www.ipsj.or.jp/event/taikai/89/award.html",
            "year": 2026
        }
    ],
    "grant": [
        {
            "description": {
                "en": "\"Large-Scale Multi-Robot Coordination via Neuro-Guided Multi-Agent Search\" / 40,000,000 JPY\n",
                "ja": "\u300C\u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u63A2\u7D22\u3068\u6A21\u5023\u5B66\u7FD2\u306B\u3088\u308B\u5927\u898F\u6A21\u30ED\u30DC\u30C3\u30C8\u7FA4\u5354\u8ABF\u300D/ 4,000\u4E07\u5186\n"
            },
            "name": {
                "en": "JST PRESTO \"Real-World Intelligence Fundamentals\" (PI) / Project Number: JPMJPR2513\n",
                "ja": "JST \u3055\u304D\u304C\u3051\u300C\u5B9F\u4E16\u754C\u77E5\u80FD\u30B7\u30B9\u30C6\u30E0\u306E\u57FA\u76E4\u5275\u51FA\u300D(\u4EE3\u8868) / \u8AB2\u984C\u756A\u53F7 JPMJPR2513\n"
            },
            "term": {
                "en": "Oct. 2025 - Mar. 2029",
                "ja": "2025\u5E7410\u6708 - 2029\u5E743\u6708"
            },
            "url": {
                "en": "https://www.jst.go.jp/kisoken/presto/en/research_area/area2025-3.html",
                "ja": "https://www.jst.go.jp/kisoken/presto/research_area/bunya2025-3.html"
            }
        },
        {
            "description": {
                "en": "\"Efficient search for planning problems with huge branching factor\" /\n5,000,000 JPY (maximum)\n",
                "ja": "\u300C\u5DE8\u5927\u306A\u5206\u5C90\u56E0\u5B50\u3092\u3082\u3064\u30D7\u30E9\u30F3\u30CB\u30F3\u30B0\u554F\u984C\u306B\u304A\u3051\u308B\u63A2\u7D22\u300D/ \u6700\u5927500\u4E07\u5186"
            },
            "name": {
                "en": "JSPS Grant-in-Aid for Early-Career Scientists (PI) / Project Number: 25K21289\n",
                "ja": "JSPS \u79D1\u7814\u8CBB \u82E5\u624B\u7814\u7A76 (\u4EE3\u8868) / \u8AB2\u984C\u756A\u53F7 25K21289\n"
            },
            "term": {
                "en": "Apr. 2025 - Mar. 2029",
                "ja": "2025\u5E744\u6708 - 2029\u5E743\u6708"
            },
            "url": "https://www.jst.go.jp/kisoken/act-x/news/2025/250401/2025_accelerationphase.pdf"
        },
        {
            "description": {
                "en": "\"Environment Optimization for Multi-Agent Path Planning\" / 5,000,000 JPY (maximum)\n",
                "ja": "\u300C\u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7D4C\u8DEF\u8A08\u753B\u306E\u305F\u3081\u306E\u74B0\u5883\u6700\u9069\u5316\u300D/ \u6700\u5927500\u4E07\u5186"
            },
            "name": {
                "en": "JST ACT-X, acceleration phase \"AI powered Research Innovation / Creation\" (PI) / Project Number: JPMJAX22A1\n",
                "ja": "JST ACT-X \u52A0\u901F\u30D5\u30A7\u30FC\u30BA\u300CAI\u6D3B\u7528\u3067\u6311\u3080\u5B66\u554F\u306E\u9769\u65B0\u3068\u5275\u6210\u300D(\u4EE3\u8868) / \u8AB2\u984C\u756A\u53F7: JPMJAX22A1\n"
            },
            "term": {
                "en": "Apr. 2025 - Mar. 2026",
                "ja": "2025\u5E744\u6708 - 2026\u5E743\u6708"
            },
            "url": "https://www.jst.go.jp/kisoken/act-x/news/2025/250401/2025_accelerationphase.pdf"
        },
        {
            "description": {
                "en": "\"New Horizons of Multi-Robot Motion Planning by Integrating Sampling, Search, and Learning Techniques\"\n/ approx. 15,000,000 JPY financial support for staying overseas research institute\n",
                "ja": "\u300C\u30B5\u30F3\u30D7\u30EA\u30F3\u30B0\u30FB\u63A2\u7D22\u30FB\u5B66\u7FD2\u306E\u7D71\u5408\u306B\u3088\u308B\u30DE\u30EB\u30C1\u30ED\u30DC\u30C3\u30C8\u30E2\u30FC\u30B7\u30E7\u30F3\u30D7\u30E9\u30F3\u30CB\u30F3\u30B0\u306E\u65B0\u5C55\u958B\u300D/ \u7D041500\u4E07\u5186\u306E\u6EDE\u5728\u8CBB\u30FB\u7814\u7A76\u6D3B\u52D5\u8CBB\n"
            },
            "name": {
                "en": "JSPS Overseas Research Fellowship",
                "ja": "\u65E5\u672C\u5B66\u8853\u632F\u8208\u4F1A \u6D77\u5916\u7279\u5225\u7814\u7A76\u54E1"
            },
            "term": {
                "en": "May. 2023 - Apr. 2025",
                "ja": "2023\u5E745\u6708 - 2025\u5E744\u6708"
            },
            "url": {
                "en": "https://www.jsps.go.jp/english/e-ab/index.html",
                "ja": "https://www.jsps.go.jp/j-ab/"
            }
        },
        {
            "description": {
                "en": "\"Environment Optimization for Multi-Agent Path Planning\" / 6,000,000 JPY (maximum), selection ratio: 89/421=21.1%\n",
                "ja": "\u300C\u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7D4C\u8DEF\u8A08\u753B\u306E\u305F\u3081\u306E\u74B0\u5883\u6700\u9069\u5316\u300D/ \u6700\u5927600\u4E07\u5186, \u63A1\u629E\u7387: 89/421=21.1%"
            },
            "name": {
                "en": "JST ACT-X \"AI powered Research Innovation / Creation\" (PI) / Project Number: JPMJAX22A1\n",
                "ja": "JST ACT-X\u300CAI\u6D3B\u7528\u3067\u6311\u3080\u5B66\u554F\u306E\u9769\u65B0\u3068\u5275\u6210\u300D (\u4EE3\u8868) / \u8AB2\u984C\u756A\u53F7: JPMJAX22A1\n"
            },
            "term": {
                "en": "Oct. 2022 - Mar. 2025",
                "ja": "2022\u5E7410\u6708 - 2025\u5E743\u6708"
            },
            "url": {
                "en": "https://www.jst.go.jp/kisoken/act-x/en/project/111F003/111F003_2022.html",
                "ja": "https://www.jst.go.jp/kisoken/act-x/project/111F003/111F003_2022.html"
            }
        },
        {
            "description": {
                "en": "\"Designing Distributed Algorithms for a Modular Environment Enhancing Cooperative Robots\" / 1,400,000 JPY for staying abroad, selection ratio: 55/111=49.5%\n",
                "ja": "\u300C\u30ED\u30DC\u30C3\u30C8\u7FA4\u306E\u5236\u5FA1\u3092\u884C\u3046\u30E2\u30B8\u30E5\u30FC\u30EB\u578B\u74B0\u5883\u306B\u304A\u3051\u308B\u5206\u6563\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u306E\u958B\u767A \u300D/ 140\u4E07\u5186\u306E\u6D77\u5916\u6EDE\u5728\u8CBB, \u63A1\u629E\u7387: 55/111=49.5%"
            },
            "name": {
                "en": "JSPS Overseas Challenge Program for Young Researchers (PI)",
                "ja": "\u65E5\u672C\u5B66\u8853\u632F\u8208\u4F1A \u82E5\u624B\u7814\u7A76\u8005\u6D77\u5916\u6311\u6226\u30D7\u30ED\u30B0\u30E9\u30E0 (\u4EE3\u8868)"
            },
            "term": {
                "en": "Mar. 2022 - Sep. 2022",
                "ja": "2022\u5E743\u6708 - 2022\u5E749\u6708"
            },
            "url": {
                "en": "https://www.jsps.go.jp/english/e-abc/index.html",
                "ja": "https://www.jsps.go.jp/j-abc/index.html"
            }
        },
        {
            "description": {
                "en": "\"Enhanced Cooperation of Moving Agents via an Active Modular Environment\" /\n200,000 JPY monthly scholarship + 2,800,000 JPY research funding, selection ratio: 721/3711=19.4%\n",
                "ja": "\u300C\u79FB\u52D5\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7FA4\u306E\u5354\u8ABF\u884C\u52D5\u3092\u8A98\u767A\u3059\u308B\u74B0\u5883\u306B\u3088\u308B\u8A08\u7B97\u652F\u63F4 \u300D/ 20\u4E07\u5186/\u6708\u306E\u5968\u5B66\u91D1+\u7814\u7A76\u8CBB280\u4E07\u5186, \u63A1\u629E\u7387: 721/3711=19.4%"
            },
            "name": {
                "en": "JSPS Research Fellowship DC1 / Project Number: 20J23011",
                "ja": "\u65E5\u672C\u5B66\u8853\u632F\u8208\u4F1A \u7279\u5225\u7814\u7A76\u54E1 DC1 / \u8AB2\u984C\u756A\u53F7: 20J23011"
            },
            "term": {
                "en": "Apr. 2020 - Mar. 2023",
                "ja": "2020\u5E744\u6708 - 2023\u5E743\u6708"
            },
            "url": "https://kaken.nii.ac.jp/grant/KAKENHI-PROJECT-20J23011/"
        },
        {
            "description": {
                "en": "200,000 JPY monthly scholarship + 3,500,000 JPY study supports, only 5-6 Ph.D. Candidates in Japan/Year",
                "ja": "20\u4E07\u5186/\u6708\u306E\u751F\u6D3B\u63F4\u52A9\u53CA\u3073\u304A\u3088\u305D350\u4E07\u5186/3\u5E74\u306E\u5B66\u8CBB\u7B49\u306E\u63F4\u52A9, \u63A1\u629E: 5\u4EBA\u7A0B\u5EA6/\u5E74"
            },
            "name": {
                "en": "Yoshida Scholarship Foundation Doctor21",
                "ja": "\u5409\u7530\u80B2\u82F1\u4F1A \u30C9\u30AF\u30BF\u30FC21"
            },
            "term": {
                "en": "Apr. 2020 - Mar. 2023",
                "ja": "2020\u5E744\u6708 - 2023\u5E743\u6708"
            },
            "url": {
                "en": "https://www.ysf.or.jp/scholarship/visitor/internal/doctor21.php",
                "ja": "https://www.ysf.or.jp/scholarship/visitor/internal/doctor21.php"
            }
        },
        {
            "description": {
                "en": "2,112,000 JPY, selection ratio: 1456/21538=6.7%",
                "ja": "211\u4E072\u5343\u5186\u306E\u5B66\u8CBB\u7B49\u306E\u63F4\u52A9/2\u5E74, \u63A1\u629E\u7387: 1456/21538=6.7%"
            },
            "name": {
                "en": "JASSO Repayment Exemption for Students with Excellent Grades",
                "ja": "\u65E5\u672C\u5B66\u751F\u652F\u63F4\u6A5F\u69CB \u7B2C\u4E00\u7A2E\u5968\u5B66\u91D1 \u5168\u984D\u8FD4\u6E08\u514D\u9664"
            },
            "term": {
                "en": "Apr. 2018 - Mar. 2020",
                "ja": "2018\u5E744\u6708 - 2020\u5E743\u6708"
            },
            "url": {
                "en": "https://www.jasso.go.jp/shogakukin/taiyochu/gyosekimenjyo/index.html",
                "ja": "https://www.jasso.go.jp/shogakukin/taiyochu/gyosekimenjyo/index.html"
            }
        }
    ],
    "otherAwards": [
        {
            "month": 9,
            "name": {
                "en": "Outstanding Presentation Award, The 17th Workshop on Theoretical Computer Science (WTCS)",
                "ja": "\u7B2C17\u56DE\u60C5\u5831\u79D1\u5B66\u30EF\u30FC\u30AF\u30B7\u30E7\u30C3\u30D7 \u512A\u79C0\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u8CDE"
            },
            "url": "https://w-tcs.github.io/2021/",
            "year": 2021
        },
        {
            "month": 4,
            "name": {
                "en": "Outstanding Performance Award, Fixstars Amplify Hackathon",
                "ja": "Fixstars Amplify \u30CF\u30C3\u30AB\u30BD\u30F3, \u512A\u79C0\u8CDE"
            },
            "url": "https://amplify.fixstars.com/hackathon00",
            "year": 2021
        },
        {
            "month": 9,
            "name": {
                "en": "Outstanding Presentation Award, The 16th Workshop on Theoretical Computer Science (WTCS)",
                "ja": "\u7B2C16\u56DE\u60C5\u5831\u79D1\u5B66\u30EF\u30FC\u30AF\u30B7\u30E7\u30C3\u30D7 \u512A\u79C0\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u8CDE"
            },
            "url": "https://w-tcs.github.io/2020/",
            "year": 2020
        },
        {
            "month": 9,
            "name": {
                "en": "The Best Research Award, The 15th Workshop on Theoretical Computer Science (WTCS)",
                "ja": "\u7B2C15\u56DE\u60C5\u5831\u79D1\u5B66\u30EF\u30FC\u30AF\u30B7\u30E7\u30C3\u30D7 \u6700\u512A\u79C0\u7814\u7A76\u8CDE"
            },
            "url": "https://w-tcs.github.io/2019/",
            "year": 2019
        },
        {
            "month": 3,
            "name": {
                "en": "The Best Research Award, The 17th Microsymposium on Complex Systems",
                "ja": "\u7B2C17\u56DE\u8907\u96D1\u7CFB\u30DE\u30A4\u30AF\u30ED\u30B7\u30F3\u30DD\u30B8\u30A6\u30E0 \u6700\u512A\u79C0\u7814\u7A76\u8CDE"
            },
            "year": 2018
        },
        {
            "month": 9,
            "name": {
                "en": "The Outstanding Presentation Award, The 13rd Workshop on Theoretical Computer Science (WTCS)",
                "ja": "\u7B2C13\u56DE\u60C5\u5831\u79D1\u5B66\u30EF\u30FC\u30AF\u30B7\u30E7\u30C3\u30D7 \u512A\u79C0\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u8CDE"
            },
            "url": "https://w-tcs.github.io/2017",
            "year": 2017
        },
        {
            "month": 4,
            "name": {
                "en": "Incentive award of director of School of Computing, School of Computing at Tokyo Institute of Technology",
                "ja": "\u5E73\u621028\u5E74\u5EA6 \u60C5\u5831\u7406\u5DE5\u5B66\u9662 \u5B66\u9662\u9577\u5968\u52B1\u8CDE"
            },
            "year": 2017
        },
        {
            "month": 2,
            "name": {
                "en": "TokyoTech Engineering Design Competition: First Prize",
                "ja": "\u7B2C\u4E09\u56DE\u6771\u5DE5\u5927\u30A8\u30F3\u30B8\u30CB\u30A2\u30EA\u30F3\u30B0\u30B3\u30F3\u30DA\u30C6\u30A3\u30B7\u30E7\u30F3: \u512A\u52DD"
            },
            "url": "http://www.eng.titech.ac.jp/~cbe/competition2017/",
            "year": 2017
        },
        {
            "month": 12,
            "name": {
                "en": "MashupAward 2016 Student Division, First Prize",
                "ja": "Mashup Awards 2016 \u5B66\u751F\u90E8\u9580\u6700\u512A\u79C0\u8CDE"
            },
            "url": "https://ma2017.we-are-ma.jp/2016/11/final-student/",
            "year": 2016
        },
        {
            "month": 11,
            "name": {
                "en": "JPHACKS 2016: Best Idea Prize + 6 Other Awards",
                "ja": "JPHACKS 2016: Best Idea\u8CDE+\u4ED66\u8CDE"
            },
            "url": "https://2016.jphacks.com/",
            "year": 2016
        },
        {
            "month": 6,
            "name": {
                "en": "HackU@Tokyo-Tech 2016 sponserd by Yahoo! Japan: TokyoTech Prize",
                "ja": "Hack U \u6771\u4EAC\u5DE5\u696D\u5927\u5B66 2016: \u6771\u4EAC\u5DE5\u696D\u5927\u5B66\u8CDE"
            },
            "url": "https://hacku.yahoo.co.jp/titech2016/",
            "year": 2016
        },
        {
            "month": 5,
            "name": {
                "en": "Microsoft Community Champion, First Place in Domestic Qualify",
                "ja": "Microsoft Community Champion \u56FD\u5185\u4E88\u9078\u4E00\u4F4D\u901A\u904E"
            },
            "year": 2015
        }
    ]
};


var $cec20df2513b66fe$exports = {};
$cec20df2513b66fe$exports = [
    {
        "title": {
            "ja": "\u4F01\u753B\u904B\u55B6",
            "en": "Organiser"
        },
        "contents": [
            {
                "name": "\"Tutorials on Scalable Multi-Robot Planning: From MAPF Algorithms to Real Robotic Systems\" at IROS, 2026. w/Jiaoyang Li, Yulun Zhang, Jingkai Chen, Han Zhang, and Sven Koenig\n",
                "url": "https://sites.google.com/view/iros-26-mapf-tutorial/home"
            },
            {
                "name": {
                    "en": "Organised session \"Search and Planning\" at JSAI, 2026. w/Ryo Kuroiwa\n",
                    "ja": "JSAI2026 \u30AA\u30FC\u30AC\u30CA\u30A4\u30BA\u30C9\u30BB\u30C3\u30B7\u30E7\u30F3\u300C\u63A2\u7D22\u3068\u30D7\u30E9\u30F3\u30CB\u30F3\u30B0\u306E\u57FA\u790E\u3068\u5FDC\u7528\u300D w/Ryo Kuroiwa\n"
                },
                "url": "https://www.ai-gakkai.or.jp/jsai2026/os/"
            },
            {
                "name": "The 6th International Workshop on Multi-Agent Path Finding at AAAI, 2025. w/Zhe Chen, Jingkai Chen, Rishi Veerapaneni, Yue Zhang",
                "url": "https://womapf.github.io/aaai-25/"
            },
            {
                "name": {
                    "en": "Multi-agent and multi-robot planning workshop in Tokyo, 2024. w/Keisuke Otaki\n",
                    "ja": "\u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u30FB\u30DE\u30EB\u30C1\u30ED\u30DC\u30C3\u30C8\u30D7\u30E9\u30F3\u30CB\u30F3\u30B0\u7814\u7A76\u4F1A 2024. w/Keisuke Otaki\n"
                },
                "url": "https://sites.google.com/view/multi-agent-robot-planning-24"
            }
        ]
    },
    {
        "title": {
            "ja": "Area Chair",
            "en": "Area Chair"
        },
        "contents": [
            {
                "name": "2025: MRS\n"
            }
        ]
    },
    {
        "contents": [
            {
                "name": "2027: AAAI (PC)\n"
            },
            {
                "name": "2026: AAAI (PC), ICRA, AAMAS (PC), ICAPS (PC), RA-L, IJCAI (PC), AIJ, NeurIPS, CoRL, T-RO, IJRR\n"
            },
            {
                "name": "2025: AAAI (PC), ICRA, AIJ, RA-L, IJCAI (PC), JAAMAS, RSS, T-RO, JAIR\n"
            },
            {
                "name": "2024: ICRA, AAAI (PC), RA-L, IJCAI (PC), T-IV, Robotics and Autonomous Systems, RSS, JSAI, TPDS, JAIR, CP, AIJ, CoRL, IJRR\n"
            },
            {
                "name": "2023: ICRA, AAAI (PC), WoMAPF (PC), JAAMAS, IJCAI (PC), T-RO, RSS, RA-L, T-ITS, TMECH, CASE, ESA, TCDS, MRS, Robotics and Autonomous Systems, JAIR, T-IV, TPDS\n"
            },
            {
                "name": "2022: RA-L, ICRA, IROS, TCDS, T-ASE, JETAI\n"
            },
            {
                "name": "2021: ICDCN, RA-L, ICRA, IROS\n"
            }
        ],
        "title": {
            "en": "Reviewer / Program Committee",
            "ja": "\u67FB\u8AAD"
        }
    },
    {
        "contents": [
            {
                "name": "Kei18's Note",
                "url": "https://kei18.github.io/note"
            },
            {
                "name": "researchmap",
                "url": {
                    "en": "https://researchmap.jp/Kei18?lang=en",
                    "ja": "https://researchmap.jp/Kei18"
                }
            },
            {
                "name": "YouTube",
                "url": "https://www.youtube.com/@keisuke_okumura"
            },
            {
                "name": "Speaker Deck",
                "url": "https://speakerdeck.com/kei18"
            }
        ],
        "title": {
            "en": "Links, Materials, Slides",
            "ja": "\u30EA\u30F3\u30AF\u30FB\u8CC7\u6599\u30FB\u30B9\u30E9\u30A4\u30C9"
        }
    },
    {
        "contents": [
            {
                "name": "IEEE Spectrum Video Friday (2026)",
                "url": "https://spectrum.ieee.org/roadrunner-bipedal-robot#41kpw6jwxty"
            },
            {
                "name": {
                    "en": "Fant\xe1stico (Oct. 2025)",
                    "ja": "Fant\xe1stico (2025\u5E7410\u6708)"
                },
                "url": "https://g1.globo.com/fantastico/video/mentes-digitais-professora-brasileira-lidera-pesquisas-de-inteligencia-coletiva-no-reino-unido-14044982.ghtml"
            },
            {
                "name": {
                    "en": "BBC Click (Mar. 2025)",
                    "ja": "BBC Click (2025\u5E743\u6708)"
                },
                "url": "https://www.bbc.co.uk/iplayer/episode/m0029673/click-15032025"
            },
            {
                "name": {
                    "ja": "\u30AA\u30E0\u30ED\u30F3\u30FB\u30CB\u30E5\u30FC\u30B9\u30EB\u30FC\u30E0 (2022\u5E744\u6708)",
                    "en": "OMRON News"
                },
                "url": "https://www.omron.com/jp/ja/news/2022/04/c0427.html"
            },
            {
                "name": "\u3042\u306A\u305F\u306E\u3042\u308B\u304F\u4E00\u6B69\u3055\u304D someone vol.51 (2020\u5E746\u6708)",
                "url": "https://lne.st/business/publishing/someone/"
            }
        ],
        "title": {
            "en": "Media",
            "ja": "\u30E1\u30C7\u30A3\u30A2"
        }
    }
];


var $91a18662b9329c89$exports = {};
$91a18662b9329c89$exports = [
    {
        "name": "icon-linkedin",
        "url": "https://www.linkedin.com/in/kei18/"
    },
    {
        "name": "icon-twitter",
        "url": "https://twitter.com/_kei18"
    },
    {
        "name": "icon-youtube",
        "url": "https://www.youtube.com/@keisuke_okumura"
    },
    {
        "name": "icon-github",
        "url": "https://github.com/Kei18"
    },
    {
        "name": "ai-google-scholar-square",
        "url": "https://scholar.google.com/citations?user=4dFSWwMAAAAJ"
    }
];


var $64a59958072aa83b$exports = {};
$64a59958072aa83b$exports = {
    "menu": [
        {
            "id": "news",
            "href": "#news",
            "label": {
                "en": "News",
                "ja": "\u30CB\u30E5\u30FC\u30B9"
            }
        },
        {
            "id": "research",
            "href": "#research",
            "label": {
                "en": "Research",
                "ja": "\u7814\u7A76"
            }
        },
        {
            "id": "career",
            "href": "#career",
            "label": {
                "en": "Career",
                "ja": "\u7D4C\u6B74"
            }
        },
        {
            "id": "education",
            "href": "#education",
            "label": {
                "en": "Education",
                "ja": "\u5B66\u6B74"
            }
        },
        {
            "id": "publication",
            "href": "#publication",
            "label": {
                "en": "Publication",
                "ja": "\u696D\u7E3E"
            }
        },
        {
            "id": "talks",
            "href": "#talks",
            "label": {
                "en": "Talks",
                "ja": "\u8B1B\u6F14"
            }
        },
        {
            "id": "award",
            "href": "#award",
            "label": {
                "en": "Award",
                "ja": "\u53D7\u8CDE\u7B49"
            }
        },
        {
            "id": "creation",
            "href": "#creation",
            "label": {
                "en": "Creation",
                "ja": "\u4F5C\u54C1"
            }
        },
        {
            "id": "others",
            "href": "#others",
            "label": {
                "en": "Others",
                "ja": "\u305D\u306E\u4ED6"
            }
        },
        {
            "id": "contact",
            "href": "#contact",
            "label": {
                "en": "Contact",
                "ja": "\u9023\u7D61\u5148"
            }
        },
        {
            "id": "note",
            "href": "/note",
            "label": {
                "en": "Note",
                "ja": "\u96D1\u8A18"
            },
            "className": "mt-5"
        }
    ]
};


var $a04f692337f4cbf5$exports = {};
$a04f692337f4cbf5$exports = {
    "abbr": {
        "AAAI": "Proceedings of the AAAI Conference on Artificial Intelligence",
        "IJCAI": "Proceedings of the International Joint Conference on Artificial Intelligence",
        "IROS": "Proceedings of the IEEE/RSJ International Conference on Intelligent Robots and Systems",
        "ICRA": "Proceedings of the IEEE International Conference on Robotics and Automation",
        "ICAPS": "Proceedings of the International Conference on Automated Planning and Scheduling",
        "AAMAS": "Proceedings of the International Conference on Autonomous Agents and Multiagent Systems",
        "SoCS": "Proceedings of the International Symposium on Combinatorial Search",
        "CoRL": "Proceedings of the Conference on Robot Learning",
        "VTC": "Proceedings of the IEEE Vehicular Technology Conference",
        "RA-L": "IEEE Robotics and Automation Letters",
        "T-RO": "IEEE Transactions on Robotics",
        "AIJ": "Artificial Intelligence",
        "JRM": "Journal of Robotics and Mechatronics",
        "WoMAPF": "Proceedings of the Workshop on Multi-Agent Path Finding",
        "iCAST": "Proceedings of the International Conference on Awareness Science and Technology",
        "ICLR": "Proceedings of the International Conference on Learning Representations"
    }
};


var $1eea9a6788ff239f$exports = {};
$1eea9a6788ff239f$exports = {
    "publications": [
        {
            "authors": "Fumimaro Suzuki, Keisuke Okumura",
            "month": 10,
            "title": "Map-Distribution Mixture-of-Experts for Multi-Agent Pathfinding",
            "year": 2026,
            "kind": "preprint",
            "pages": "1\u201320",
            "image": "moe",
            "book": "arXiv preprint",
            "paperUrl": "https://arxiv.org/abs/2610.25991"
        },
        {
            "authors": "Rishabh Jain, Akmaral Moldagalieva, Lorenzo Magnino, Michael Amir, Keisuke Okumura, Ajay Shankar, Wolfgang H\xf6nig, Amanda Prorok",
            "month": 10,
            "title": "GAMBIT: Learning to Plan Continuous Multi-Robot Trajectories\n",
            "year": 2026,
            "kind": "preprint",
            "pages": "1\u20139",
            "image": "gambit",
            "book": "arXiv preprint",
            "paperUrl": "https://arxiv.org/abs/2610.06290v1"
        },
        {
            "authors": "Keisuke Okumura",
            "month": 9,
            "title": "Solving Multi-Agent Sokoban via LaCAM",
            "year": 2026,
            "kind": "preprint",
            "pages": "1\u201313",
            "image": "sokoban",
            "book": "arXiv preprint",
            "paperUrl": "https://arxiv.org/abs/2609.39889",
            "projectPage": "https://kei18.github.io/multi-agent-sokoban/"
        },
        {
            "abbr": "T-RO",
            "authors": "Yuhao Zhang, Keisuke Okumura, Ajay Shankar, Amanda Prorok",
            "github": "https://github.com/proroklab/d4orm",
            "image": "denoising",
            "month": 10,
            "others": "IF(25-26)=11.6",
            "paperUrl": "https://arxiv.org/abs/2609.35651",
            "title": "Denoising Multi-Robot Trajectories",
            "youtube": "https://www.youtube.com/watch?v=sK6mr42aXe8",
            "doi": "https://doi.org/10.1109/TRO.2026.3742231",
            "year": 2026,
            "pages": "1-20",
            "kind": "journal"
        },
        {
            "abbr": "CoRL",
            "authors": "Ryusei Matsumoto, Mei Kinjo, Yoko Sasaki, Keisuke Okumura",
            "month": 11,
            "title": "Learning Coordinated Visuomotor Box-Pushing from Solo Demonstrations",
            "year": 2026,
            "kind": "reviewedProceeding",
            "pages": "1\u201311",
            "image": "box-pushing",
            "others": {
                "en": "acceptance rate: 687/2094=33%, in press\n",
                "ja": "\u63A1\u629E\u7387: 687/2094=33%, in press\n"
            },
            "paperUrl": "https://arxiv.org/abs/2610.05677",
            "youtube": "https://www.youtube.com/watch?v=J9KfPI-hJX4"
        },
        {
            "authors": "Takuro Kato, Keisuke Okumura",
            "month": 5,
            "title": "Conveyor Parcel Routing with Order-Contiguous Arrivals",
            "year": 2026,
            "kind": "preprint",
            "pages": "1\u201310",
            "image": "conveyor",
            "book": "arXiv preprint",
            "paperUrl": "https://arxiv.org/abs/2605.13035"
        },
        {
            "authors": "Takahiro Suzuki, Yuma Tamura, Keisuke Okumura",
            "month": 5,
            "title": "Distance-Constrained Unlabeled Multi-Agent Pathfinding",
            "year": 2026,
            "kind": "preprint",
            "pages": "1\u201315",
            "image": "iumapf",
            "book": "arXiv preprint",
            "paperUrl": "https://arxiv.org/abs/2605.11503"
        },
        {
            "abbr": "SoCS",
            "authors": "Tomoki Arita, Keisuke Okumura",
            "image": "lllg",
            "month": 8,
            "title": "Lifelong LaCAM with Local Guidance for Lifelong MAPF",
            "year": 2026,
            "kind": "reviewedProceeding",
            "pages": "2\u201310",
            "github": "https://github.com/allegorywrite/lllg",
            "doi": "https://doi.org/10.1609/socs.v19i1.43067",
            "paperUrl": "https://arxiv.org/abs/2605.16855",
            "others": {
                "en": "acceptance rate: 32/79=44% <br/>\n<span class=\"text-danger\">The SoCS 2026 Best Student Paper Award</span>\n",
                "ja": '\u63A1\u629E\u7387: 32/79=44% <br/>\n<span class="text-danger">The SoCS 2026 Best Student Paper Award</span>\n'
            }
        },
        {
            "abbr": "SoCS",
            "authors": "Yu Kumagai, Keisuke Okumura",
            "image": "tapf",
            "month": 8,
            "title": "Alternating Target\u2013Path Planning for Scalable Multi-Agent Coordination",
            "year": 2026,
            "kind": "reviewedProceeding",
            "github": "https://github.com/Ukuma012/ir-tapf",
            "pages": "112\u2013120",
            "paperUrl": "https://arxiv.org/abs/2605.07744",
            "doi": "https://doi.org/10.1609/socs.v19i1.43079",
            "others": {
                "en": "acceptance rate: 32/79=44%",
                "ja": "\u63A1\u629E\u7387: 32/79=44%"
            }
        },
        {
            "abbr": "IJCAI",
            "authors": "Hiroki Nagai, Keisuke Okumura",
            "image": "mawpf",
            "month": 8,
            "title": "From Gridworlds to Warehouses: Adapting Lightweight One-shot Multi-Agent Pathfinding for AGVs\n",
            "year": 2026,
            "github": "https://github.com/hirokiNagai-39/mawpf",
            "pages": "306\u2013313",
            "others": {
                "en": "acceptance rate: 953/5233=18%",
                "ja": "\u63A1\u629E\u7387: 953/5233=18%"
            },
            "kind": "reviewedProceeding",
            "paperUrl": "https://arxiv.org/abs/2605.15799",
            "doi": "https://doi.org/10.24963/ijcai.2026/35"
        },
        {
            "authors": "Keisuke Okumura, Guang Yang, Zhan Gao, Heedo Woo, Amanda Prorok",
            "book": "npj Robotics",
            "selected": true,
            "month": 3,
            "paperUrl": "https://www.nature.com/articles/s44182-026-00083-2",
            "doi": "https://doi.org/10.1038/s44182-026-00083-2",
            "title": "Concrete multi-agent path planning enabling kinodynamically aggressive maneuvers",
            "year": 2026,
            "kind": "journal",
            "pages": "1-15",
            "image": "agile-mapf",
            "github": "https://github.com/proroklab/agile-mapf",
            "projectPage": "https://proroklab.github.io/agile-mapf/",
            "youtube": "https://www.youtube.com/watch?v=41kPW6JwXtY",
            "others": "Nature Portfolio. Featured in <a href=\"https://spectrum.ieee.org/roadrunner-bipedal-robot#41kpw6jwxty\">IEEE Spectrum Video Friday</a> (2026), <a href=\"https://g1.globo.com/fantastico/video/mentes-digitais-professora-brasileira-lidera-pesquisas-de-inteligencia-coletiva-no-reino-unido-14044982.ghtml\">Fantastico</a> (2025), and <a href=\"https://www.bbc.co.uk/iplayer/episode/m0029673/click-15032025\">BBC Click</a> (2025). Presented at ICAPS-26 Previously Published Papers track.\n<br/>\n<span class=\"text-danger\">Featured on the journal homepage as a hero image</span>\n"
        },
        {
            "abbr": "ICAPS",
            "authors": "Takahiro Suzuki, Keisuke Okumura",
            "image": "cumapf",
            "month": 6,
            "title": "Polynomial-time Configuration Generator for Connected Unlabeled Multi-Agent Pathfinding ",
            "year": 2026,
            "github": "https://github.com/su3taka/CUMAPF-PULL",
            "paperUrl": "https://arxiv.org/abs/2510.19567",
            "pages": "323\u2013331",
            "kind": "reviewedProceeding",
            "doi": "https://doi.org/10.1609/icaps.v36i1.42842",
            "others": {
                "en": "acceptance rate: 90/~400=23%",
                "ja": "\u63A1\u629E\u7387: 90/~400=23%"
            }
        },
        {
            "abbr": "ICAPS",
            "authors": "Akmaral Moldagalieva, Keisuke Okumura, Amanda Prorok, Wolfgang H\xf6nig",
            "image": "db-lacam",
            "month": 6,
            "title": "db-LaCAM: Fast and Scalable Multi-Robot Kinodynamic Motion Planning with Discontinuity-Bounded Search and Lightweight MAPF\n",
            "year": 2026,
            "paperUrl": "https://arxiv.org/abs/2512.06796",
            "pages": "738\u2013746",
            "doi": "https://doi.org/10.1609/icaps.v36i1.42894",
            "others": {
                "en": "acceptance rate: 90/~400=23%",
                "ja": "\u63A1\u629E\u7387: 90/~400=23%"
            },
            "kind": "reviewedProceeding",
            "github": "https://github.com/IMRCLab/db-lacam",
            "youtube": "https://www.youtube.com/watch?v=K7xUFpH7a48"
        },
        {
            "abbr": "ICLR",
            "authors": "Rishabh Jain, Keisuke Okumura, Michael Amir, Pietro Lio, Amanda Prorok",
            "image": "hmagat",
            "month": 4,
            "title": "Pairwise is Not Enough: Hypergraph Neural Networks for Multi-Agent Pathfinding",
            "year": 2026,
            "pages": "1-10",
            "github": "https://github.com/proroklab/hmagat",
            "paperUrl": "https://arxiv.org/abs/2602.06733",
            "others": {
                "en": "acceptance rate: x/~19000=28%",
                "ja": "\u63A1\u629E\u7387: x/~19000=28%"
            },
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "AAAI",
            "authors": "Tomoki Arita, Keisuke Okumura",
            "image": "lg",
            "month": 3,
            "title": "Local Guidance for Configuration-Based Multi-Agent Pathfinding\n",
            "year": 2026,
            "github": "https://github.com/allegorywrite/lg_lacam",
            "paperUrl": "https://arxiv.org/abs/2510.19072",
            "pages": "29296-29304",
            "others": {
                "en": "acceptance rate: 4167/23680=17%\n",
                "ja": "\u63A1\u629E\u7387: 4167/23680=17%\n"
            },
            "kind": "reviewedProceeding",
            "doi": "https://doi.org/10.1609/aaai.v40i35.40169"
        },
        {
            "abbr": "AAAI",
            "selected": true,
            "authors": "Rishabh Jain, Keisuke Okumura, Michael Amir, Amanda Prorok",
            "image": "lagat",
            "month": 3,
            "title": "Graph Attention-Guided Search for Dense Multi-Agent Pathfinding\n",
            "year": 2026,
            "pages": "29504-29512",
            "github": "https://github.com/proroklab/lagat",
            "paperUrl": "https://arxiv.org/abs/2510.17382",
            "others": {
                "en": "acceptance rate: 4167/23680=17%\n",
                "ja": "\u63A1\u629E\u7387: 4167/23680=17%\n"
            },
            "kind": "reviewedProceeding",
            "doi": "https://doi.org/10.1609/aaai.v40i35.40192"
        },
        {
            "abbr": "IROS",
            "authors": "Yuhao Zhang, Keisuke Okumura, Heedo Woo, Ajay Shankar, Amanda Prorok",
            "image": "d4orm",
            "doi": "https://doi.org/10.1109/IROS60139.2025.11246029",
            "month": 10,
            "paperUrl": "https://arxiv.org/abs/2503.12204",
            "title": "D4orm: Multi-Robot Trajectories with Dynamics-aware Diffusion Denoised Deformations\n",
            "year": 2025,
            "pages": "14118-14123",
            "youtube": "https://www.youtube.com/watch?v=WuFuecpZQSY",
            "github": "https://github.com/proroklab/d4orm",
            "others": {
                "en": "acceptance rate: 1991/4306=46%\n",
                "ja": "\u63A1\u629E\u7387: 1991/4306=46%\n"
            },
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "CoRL",
            "authors": "Michael Amir, Guang Yang, Zhan Gao, Keisuke Okumura, Heedo Woo, Amanda Prorok",
            "image": "recode",
            "month": 9,
            "youtube": "https://www.youtube.com/watch?v=SgCE0TFOz2c",
            "paperUrl": "https://arxiv.org/abs/2507.19151",
            "title": "ReCoDe: Reinforcement Learning-based Dynamic Constraint Design for Multi-Agent Coordination\n",
            "year": 2025,
            "pages": "1598--1614",
            "others": {
                "en": "acceptance rate: 264/738=36%\n",
                "ja": "\u63A1\u629E\u7387: 264/738=36%\n"
            },
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "SoCS",
            "authors": "Keisuke Okumura, Hiroki Nagai",
            "image": "dense-pibt",
            "month": 7,
            "paperUrl": "https://arxiv.org/abs/2505.12623",
            "github": "https://github.com/HirokiNagai-39/pibt-tiebreaking",
            "title": "Lightweight and Effective Preference Construction in PIBT for Large-Scale Multi-Agent Pathfinding\n",
            "year": 2025,
            "pages": "110\u2013117",
            "others": {
                "en": "acceptance rate: 22/59=37%\n",
                "ja": "\u63A1\u629E\u7387: 22/59=37%\n"
            },
            "doi": "https://doi.org/10.1609/socs.v18i1.35982",
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "AAMAS",
            "authors": "Keisuke Okumura",
            "image": "lacam3",
            "month": 5,
            "paperUrl": "https://arxiv.org/abs/2308.04292",
            "github": "https://github.com/Kei18/lacam3/",
            "projectPage": "https://kei18.github.io/lacam3/",
            "speakerdeck": "https://speakerdeck.com/kei18/engineering-lacam-star-towards-real-time-large-scale-and-near-optimal-multi-agent-pathfinding",
            "title": "Engineering LaCAM\u2217: Towards Real-Time, Large-Scale, and Near-Optimal Multi-Agent Pathfinding\n",
            "year": 2024,
            "pages": "1501\u20131509",
            "others": {
                "en": "Acceptance Rate: 229/883=25.9%\n",
                "ja": "\u63A1\u629E\u7387: 229/883=25.9%\n"
            },
            "doi": "https://dl.acm.org/doi/10.5555/3635637.3663010",
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "IJCAI",
            "authors": "Keisuke Okumura",
            "github": "https://github.com/Kei18/lacam2/",
            "image": "lacam2",
            "month": 8,
            "paperUrl": "https://arxiv.org/abs/2305.03632",
            "projectPage": "https://kei18.github.io/lacam2",
            "title": "Improving LaCAM for Scalable Eventually Optimal Multi-Agent Pathfinding",
            "year": 2023,
            "pages": "243-251",
            "doi": "https://doi.org/10.24963/ijcai.2023/28",
            "speakerdeck": "https://speakerdeck.com/kei18/improving-lacam-for-scalable-eventually-optimal-multi-agent-pathfinding",
            "others": {
                "en": "Acceptance Rate: x/4566=15%\n",
                "ja": "\u63A1\u629E\u7387: x/4556=15%\n"
            },
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "IJCAI",
            "authors": "Keisuke Okumura, Xavier D\xe9fago",
            "github": "https://github.com/Kei18/sssp/",
            "image": "mrmp",
            "month": 8,
            "doi": "https://doi.org/10.24963/ijcai.2023/29",
            "paperUrl": "https://arxiv.org/abs/2203.00315",
            "projectPage": "https://kei18.github.io/sssp",
            "title": "Quick Multi-Robot Motion Planning by Combining Sampling and Search",
            "youtube": "https://www.youtube.com/watch?v=ZMjrQCKS6Fw",
            "year": 2023,
            "others": {
                "en": "Acceptance Rate: x/4566=15%\n",
                "ja": "\u63A1\u629E\u7387: x/4556=15%\n"
            },
            "pages": "252-261",
            "speakerdeck": "https://speakerdeck.com/kei18/quick-multi-robot-motion-planning-by-combining-sampling-and-search",
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "AAAI",
            "selected": true,
            "authors": "Keisuke Okumura",
            "image": "lacam",
            "doi": "https://doi.org/10.1609/aaai.v37i10.26377",
            "paperUrl": "https://arxiv.org/abs/2211.13432",
            "month": 2,
            "others": {
                "en": "Acceptance Rate: 1721/8777=19.6%\n",
                "ja": "\u63A1\u629E\u7387: 1721/8777=19.6%\n"
            },
            "title": "LaCAM: Search-Based Algorithm for Quick Multi-Agent Pathfinding\n",
            "year": 2023,
            "projectPage": "https://kei18.github.io/lacam",
            "speakerdeck": "https://speakerdeck.com/kei18/lacam-search-based-algorithm-for-quick-multi-agent-pathfinding",
            "github": "https://github.com/Kei18/lacam/",
            "pages": "11655-11662",
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "AAAI",
            "authors": "Keisuke Okumura, Sebastien Tixeuil",
            "doi": "https://doi.org/10.1609/aaai.v37i10.26376",
            "paperUrl": "https://arxiv.org/abs/2211.13908",
            "month": 2,
            "others": {
                "en": "Acceptance Rate: 1721/8777=19.6%\n",
                "ja": "\u63A1\u629E\u7387: 1721/8777=19.6%\n"
            },
            "title": "Fault-Tolerant Offline Multi-Agent Path Planning",
            "image": "mappcf",
            "year": 2023,
            "github": "https://github.com/Kei18/mappcf/",
            "speakerdeck": "https://speakerdeck.com/kei18/fault-tolerant-offline-multi-agent-path-planning",
            "projectPage": "https://kei18.github.io/mappcf",
            "pages": "11647-11654",
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "IJCAI",
            "authors": "Keisuke Okumura, Fran\xe7ois Bonnet, Yasumasa Tamura, Xavier D\xe9fago",
            "doi": "https://doi.org/10.24963/ijcai.2022/645",
            "github": "https://github.com/Kei18/otimapp/",
            "image": "otimapp",
            "month": 7,
            "others": {
                "en": "Acceptance Rate: 679/4535=14.9%\n",
                "ja": "\u63A1\u629E\u7387: 679/4535=14.9%\n"
            },
            "paperUrl": "https://arxiv.org/abs/2105.07132",
            "projectPage": "https://kei18.github.io/otimapp",
            "speakerdeck": "https://speakerdeck.com/kei18/offline-time-independent-multi-agent-path-planning",
            "title": "Offline Time-Independent Multi-Agent Path Planning",
            "youtube": "https://youtu.be/-p59f3epO1M",
            "year": 2022,
            "pages": "4649-4656",
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "ICAPS",
            "pages": "270-278",
            "authors": "Keisuke Okumura, Xavier D\xe9fago",
            "github": "https://github.com/Kei18/tswap/",
            "image": "unlabeled",
            "month": 6,
            "doi": "https://doi.org/10.1609/icaps.v32i1.19810",
            "others": {
                "en": "Acceptance Rate: 85/277=30.6%<br/>\n<span class=\"text-danger\">The ICAPS 2022 Best Student Paper Award</span>\n",
                "ja": '\u63A1\u629E\u7387: 85/277=30.6%<br/>\n<span class="text-danger">The ICAPS 2022 Best Student Paper Award</span>\n'
            },
            "paperUrl": "https://ojs.aaai.org/index.php/ICAPS/article/view/19810",
            "projectPage": "https://kei18.github.io/tswap/",
            "speakerdeck": "https://speakerdeck.com/kei18/solving-simultaneous-target-assignment-and-path-planning-efficiently-with-time-independent-execution",
            "title": "Solving Simultaneous Target Assignment and Path Planning Efficiently with Time-Independent Execution",
            "youtube": "https://youtu.be/NkU8r2u8-1c",
            "year": 2022,
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "AAMAS",
            "pages": "972\u2013981",
            "authors": "Keisuke Okumura, Ryo Yonetani, Mai Nishimura, Asako Kanezaki",
            "blog": {
                "en": "https://medium.com/sinicx/ctrms-learning-to-construct-cooperative-timed-roadmaps-for-multi-agent-path-planning-in-continuous-196e4b75f501",
                "ja": "https://medium.com/sinicx-ja/%E3%83%87%E3%83%BC%E3%82%BF%E9%A7%86%E5%8B%95%E5%9E%8B%E3%83%9E%E3%83%AB%E3%83%81%E3%82%A8%E3%83%BC%E3%82%B8%E3%82%A7%E3%83%B3%E3%83%88%E7%B5%8C%E8%B7%AF%E8%A8%88%E7%94%BB%E3%81%AB%E9%96%A2%E3%81%99%E3%82%8B%E7%A0%94%E7%A9%B6%E3%81%8Caamas-2022%E3%81%AB%E6%8E%A1%E6%8A%9E%E3%81%95%E3%82%8C%E3%81%BE%E3%81%97%E3%81%9F-eb70163060e8"
            },
            "doi": "https://dl.acm.org/doi/10.5555/3535850.3535959",
            "github": "https://github.com/omron-sinicx/ctrm/",
            "image": "ctrm",
            "month": 5,
            "others": {
                "en": "Acceptance Rate: 166/629=26.4%",
                "ja": "\u63A1\u629E\u7387: 166/629=26.4%"
            },
            "paperUrl": "https://arxiv.org/abs/2201.09467",
            "projectPage": "https://omron-sinicx.github.io/ctrm/",
            "speakerdeck": "https://speakerdeck.com/osx/ctrms-learning-to-construct-cooperative-timed-roadmaps-for-multi-agent-path-planning-in-continuous-spaces-aamas-22",
            "title": "CTRMs: Learning to Construct Cooperative Timed Roadmaps for Multi-agent Path Planning in Continuous Spaces\n",
            "year": 2022,
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "IROS",
            "authors": "Keisuke Okumura, Yasumasa Tamura, Xavier D\xe9fago",
            "doi": "https://doi.org/10.1109/IROS51168.2021.9636071",
            "github": "https://github.com/Kei18/mapf-IR/",
            "image": "iterative-refinement",
            "month": 9,
            "others": {
                "en": "Acceptance Rate: x/2801=45%",
                "ja": "\u63A1\u629E\u7387: x/2801=45%"
            },
            "paperUrl": "https://arxiv.org/abs/2102.12331",
            "projectPage": "https://kei18.github.io/mapf-IR/",
            "speakerdeck": "https://speakerdeck.com/kei18/iterative-refinement-for-real-time-multi-robot-path-planning",
            "title": "Iterative Refinement for Real-Time Multi-Robot Path Planning",
            "youtube": "https://youtu.be/A6M2G6mhhxM",
            "year": 2021,
            "pages": "9690-9697",
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "ICRA",
            "authors": "Shota Kameyama, Keisuke Okumura, Yasumasa Tamura, Xavier D\xe9fago",
            "doi": "https://doi.org/10.1109/ICRA48506.2021.9561111",
            "image": "afada",
            "month": 6,
            "others": {
                "en": "Acceptance Rate: 1946/4056=48.0%",
                "ja": "\u63A1\u629E\u7387: 1946/4005=48.0%"
            },
            "paperUrl": "https://arxiv.org/abs/2102.12748",
            "projectPage": "https://dfg-lab.github.io/afada/",
            "speakerdeck": "https://speakerdeck.com/kei18/active-modular-environment-for-robot-navigation",
            "title": "Active Modular Environment for Robot Navigation",
            "vimeo": "https://vimeo.com/516571573",
            "year": 2021,
            "pages": "8636-8642",
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "AAAI",
            "authors": "Keisuke Okumura, Yasumasa Tamura, Xavier D\xe9fago",
            "doi": "https://doi.org/10.1609/aaai.v35i13.17347\n",
            "github": "https://github.com/Kei18/time-independent-planning",
            "image": "time-independent-planning",
            "month": 5,
            "others": {
                "en": "Acceptance Rate: 1692/7911=21.3%",
                "ja": "\u63A1\u629E\u7387: 1692/7911=21.3%"
            },
            "paperUrl": "https://ojs.aaai.org/index.php/AAAI/article/view/17347",
            "projectPage": "https://kei18.github.io/time-independent-planning/",
            "speakerdeck": "https://speakerdeck.com/kei18/time-independent-planning-for-multiple-moving-agents",
            "title": "Time-Independent Planning for Multiple Moving Agents",
            "year": 2021,
            "pages": "11299-11307",
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "IJCAI",
            "authors": "Keisuke Okumura, Manao Machida, Xavier D\xe9fago, Yasumasa Tamura",
            "date": "10-16",
            "doi": "https://doi.org/10.24963/ijcai.2019/76",
            "github": "https://github.com/Kei18/pibt",
            "image": "pibt",
            "month": 8,
            "others": {
                "en": "Acceptance Rate: 850/4752=17.9%",
                "ja": "\u63A1\u629E\u7387: 850/4752=17.9%"
            },
            "pages": "535-542",
            "place": "Macao, China",
            "projectPage": "https://kei18.github.io/pibt",
            "speakerdeck": "https://speakerdeck.com/kei18/priority-inheritance-with-backtracking-for-iterative-multi-agent-path-finding",
            "title": "Priority Inheritance with Backtracking for Iterative Multi-agent Path Finding",
            "year": 2019,
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "iCAST",
            "authors": "Keisuke Okumura, Yasumasa Tamura, Xavier D\xe9fago",
            "date": "10-16",
            "doi": "https://doi.org/10.1109/ICAwST.2018.8517225",
            "image": "amoeba",
            "month": 9,
            "pages": "191-195",
            "place": "Fukuoka, Japan",
            "speakerdeck": "https://speakerdeck.com/kei18/amoeba-exploration-coordinated-exploration-with-distributed-robots",
            "title": "Amoeba Exploration: Coordinated Exploration with Distributed Robots",
            "year": 2018,
            "kind": "reviewedProceeding"
        },
        {
            "abbr": "VTC",
            "authors": "Mai Hirata, Manabu Tsukada, Keisuke Okumura, Yasumasa Tamura, Hideya Ochiai, Xavier D\xe9fago",
            "doi": "https://doi.org/10.1109/VTC2021-Fall52928.2021.9625324",
            "image": "coordinated_path",
            "month": 9,
            "paperUrl": "https://arxiv.org/abs/2108.04629",
            "title": "Roadside-assisted Cooperative Planning using Future Path Sharing for Autonomous Driving",
            "year": 2021,
            "pages": "1-7",
            "kind": "reviewedProceedingMinor"
        },
        {
            "abbr": "WoMAPF",
            "authors": "Keisuke Okumura, Yasumasa Tamura, Xavier D\xe9fago",
            "github": "https://github.com/Kei18/pibt",
            "image": "winpibt",
            "month": 1,
            "paperUrl": "https://arxiv.org/abs/1905.10149",
            "projectPage": "https://kei18.github.io/pibt/",
            "speakerdeck": "https://speakerdeck.com/kei18/winpibt-extended-prioritized-algorithm-for-iterative-multi-agent-path-finding",
            "title": "winPIBT: Extended Prioritized Algorithm for Iterative Multi-agent Path Finding",
            "year": 2021,
            "pages": "1-9",
            "kind": "reviewedWorkshop"
        },
        {
            "abbr": "JRM",
            "authors": "Shota Yamamoto, Ryusei Matsumoto, Yoko Sasaki, Keisuke Okumura",
            "image": "100mouse",
            "month": 12,
            "paperUrl": "https://www.fujipress.jp/jrm/rb/robot003700061545/",
            "title": "100-Mouse System: Scalable Multi-Robot Testbed with State Management User Interface\n",
            "year": 2025,
            "pages": "1545-1556",
            "doi": "https://doi.org/10.20965/jrm.2025.p1545",
            "kind": "journal"
        },
        {
            "abbr": "RA-L",
            "authors": "Takuro Kato, Keisuke Okumura, Yoko Sasaki, Naoya Yokomachi",
            "image": "cmpp",
            "month": 8,
            "paperUrl": "https://arxiv.org/abs/2508.05253",
            "title": "Congestion Mitigation Path Planning for Large-Scale Multi-Agent Navigation in Dense Environments\n",
            "year": 2025,
            "pages": "9742-9749",
            "doi": "https://doi.org/10.1109/LRA.2025.3597871",
            "kind": "journal"
        },
        {
            "pages": "1-20",
            "authors": "Jean-Marc Alkazzi, Keisuke Okumura",
            "book": "IEEE Access",
            "image": "mapf-ml-review",
            "month": 4,
            "doi": "https://doi.org/10.1109/access.2024.3392305",
            "title": "A Comprehensive Review on Leveraging Machine Learning for Multi-Agent Path Finding\n",
            "year": 2024,
            "others": "IF(2022)=3.9 h-index(24)=204\n",
            "kind": "journal"
        },
        {
            "abbr": "AIJ",
            "selected": true,
            "pages": "103946(1-27)",
            "authors": "Keisuke Okumura, Xavier D\xe9fago",
            "github": "https://github.com/Kei18/tswap/",
            "image": "tswap2",
            "month": 5,
            "doi": "https://doi.org/10.1016/j.artint.2023.103946",
            "others": {
                "en": "IF(22-23)=14.4, h-index(22)=161<br/>\n<span class=\"text-danger\">Invited from ICAPS-22 following the Best Student Paper Award</span>\n",
                "ja": "IF(22-23)=14.4, h-index(22)=161, ICAPS-22 \u304B\u3089\u62DB\u5F85\u3055\u308C\u305F\u3082\u306E\n"
            },
            "paperUrl": "https://www.sciencedirect.com/science/article/pii/S0004370223000929",
            "projectPage": "https://kei18.github.io/tswap/",
            "speakerdeck": "https://speakerdeck.com/kei18/solving-simultaneous-target-assignment-and-path-planning-efficiently-with-time-independent-execution",
            "title": "Solving Simultaneous Target Assignment and Path Planning Efficiently with Time-Independent Execution\n",
            "youtube": "https://youtu.be/NkU8r2u8-1c",
            "year": 2023,
            "kind": "journal"
        },
        {
            "abbr": "T-RO",
            "selected": true,
            "authors": "Keisuke Okumura, Fran\xe7ois Bonnet, Yasumasa Tamura, Xavier D\xe9fago",
            "doi": "https://doi.org/10.1109/tro.2023.3258690",
            "github": "https://github.com/Kei18/otimapp/",
            "image": "otimapp2",
            "month": 4,
            "others": {
                "en": "IF(22-23)=7.8, h-index(23)=177, extended from IJCAI-22",
                "ja": "IF(22-23)=7.8, h-index(23)=177, IJCAI-22 \u3092\u62E1\u5F35\u3057\u305F\u3082\u306E"
            },
            "paperUrl": "https://ieeexplore.ieee.org/document/10092929",
            "projectPage": "https://kei18.github.io/otimapp/",
            "title": "Offline Time-Independent Multiagent Path Planning",
            "youtube": "https://youtu.be/-p59f3epO1M",
            "year": 2023,
            "pages": "2720-2737",
            "kind": "journal"
        },
        {
            "abbr": "AIJ",
            "selected": true,
            "authors": "Keisuke Okumura, Manao Machida, Xavier D\xe9fago, Yasumasa Tamura",
            "doi": "https://doi.org/10.1016/j.artint.2022.103752",
            "github": "https://github.com/Kei18/pibt2/",
            "image": "pibt2",
            "month": 6,
            "others": {
                "en": "IF(21-22)=14.05, h-index(22)=155, extended from IJCAI-19",
                "ja": "IF(21-22)=14.05, h-index(22)=155, IJCAI-19 \u3092\u62E1\u5F35\u3057\u305F\u3082\u306E"
            },
            "paperUrl": "https://www.sciencedirect.com/science/article/pii/S0004370222000923",
            "projectPage": "https://kei18.github.io/pibt2/",
            "title": "Priority Inheritance with Backtracking for Iterative Multi-agent Path Finding",
            "youtube": "https://www.youtube.com/watch?v=8Yrwd0t0NEw",
            "year": 2022,
            "pages": "103752(1-22)",
            "kind": "journal"
        },
        {
            "authors": "Keisuke Okumura, Hiroki Ora, Yoshihiro Miyake",
            "book": "Frontiers in Robotics and AI - Virtual Environments",
            "date": 15,
            "doi": "https://doi.org/10.3389/frobt.2020.00049",
            "image": "OHI",
            "month": 4,
            "title": "Investigating the Hand Ownership Illusion With Two Views Merged in",
            "year": 2020,
            "others": "IF(19-20)=2.98",
            "pages": "1-9",
            "kind": "journal"
        },
        {
            "authors": "Ajay Shankar, Keisuke Okumura, Amanda Prorok",
            "book": "arXiv preprint",
            "image": "lf",
            "month": 7,
            "projectPage": "https://proroklab.github.io/lf",
            "paperUrl": "https://arxiv.org/abs/2507.11464",
            "title": "LF: Online Multi-Robot Path Planning Meets Optimal Trajectory Control\n",
            "year": 2025,
            "pages": "1-9",
            "github": "https://github.com/proroklab/lf",
            "kind": "preprint",
            "others": "presented at WoMAPF-25\n"
        },
        {
            "authors": "Heedo Woo, Kazi R. I. Sanim, Keisuke Okumura, Guang Yang, Ajay Shankar, Amanda Prorok",
            "book": "Technical Report",
            "image": "sanity",
            "month": 7,
            "paperUrl": "https://openreview.net/forum?id=i5dKOANPZZ",
            "title": "Sanity: An Agile Brushless Quadrotor for Multi-Agent Experiments\n",
            "year": 2025,
            "pages": "1-5",
            "others": "presented at CoRL-25's Workshop",
            "kind": "preprint"
        },
        {
            "authors": "Keisuke Okumura",
            "book": "arXiv preprint",
            "image": "lacas",
            "month": 8,
            "paperUrl": "https://arxiv.org/abs/2408.15443",
            "title": "Pathfinding with Lazy Successor Generation",
            "year": 2024,
            "pages": "1-14",
            "kind": "preprint"
        },
        {
            "authors": "\u5965\u6751 \u572D\u7950",
            "book": "\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30D3\u30B8\u30E7\u30F3\u6700\u524D\u7DDA Spring 2025",
            "image": "cvbook2025",
            "month": 3,
            "projectPage": "https://www.kyoritsu-pub.co.jp/book/b10123411.html",
            "title": "\u30A4\u30DE\u30C9\u30AD\u30CE\u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7D4C\u8DEF\u8A08\u753B \u2015\u5927\u898F\u6A21\u30AA\u30FC\u30C8\u30E1\u30FC\u30B7\u30E7\u30F3\u3078\u306E\u6311\u6226!\u2015",
            "year": 2025,
            "kind": "book"
        },
        {
            "authors": "Keisuke Okumura",
            "book": "Ph.D. Dissertation, Tokyo Institute of Technology",
            "image": "phd",
            "month": 3,
            "paperUrl": "https://t2r2.star.titech.ac.jp/cgi-bin/publicationinfo.cgi?lv=en&q_publication_content_number=CTT100886180\n",
            "projectPage": "https://kei18.github.io/phd-dissertation",
            "title": "Planning, Execution, Representation, and their Integration for Multiple Moving Agents",
            "year": 2023,
            "pages": "1-278",
            "blog": "https://doi.org/10.11517/jjsai.39.1_50",
            "others": {
                "en": "<span class=\"text-danger\">Ph.D. Dissertation Award (Seiichi Tejima Research Award), Tokyo Institute of Technology</span>\n",
                "ja": '<span class="text-danger">\u6771\u4EAC\u5DE5\u696D\u5927\u5B66 \u624B\u5CF6\u7CBE\u4E00\u8A18\u5FF5\u7814\u7A76\u8CDE (\u535A\u58EB\u8AD6\u6587\u8CDE)</span>\n'
            },
            "kind": "dissertation"
        },
        {
            "title": {
                "en": "JP,2021-106321,A",
                "ja": "\u7BA1\u7406\u30B7\u30B9\u30C6\u30E0\u53CA\u3073\u7BA1\u7406\u65B9\u6CD5 (\u7279\u958B2021-106321)"
            },
            "kind": "patent"
        }
    ]
};


var $ce8d7bb5ce699c2e$exports = {};
$ce8d7bb5ce699c2e$exports = {
    "excludeList": [
        "iCAST",
        "WoMAPF",
        "JRM"
    ]
};


var $57390a5792bca891$exports = {};
$57390a5792bca891$exports = [
    {
        "icon": "google-scholar",
        "name": "Google Scholar",
        "url": "https://scholar.google.com/citations?user=4dFSWwMAAAAJ"
    },
    {
        "icon": "dblp",
        "name": "DBLP",
        "url": "https://dblp.org/pid/234/9130-1.html"
    },
    {
        "icon": "orcid",
        "name": "ORCID",
        "url": "https://orcid.org/0000-0002-9491-7367"
    },
    {
        "icon": "semantic-scholar",
        "name": "Semantic Scholar",
        "url": "https://www.semanticscholar.org/author/Keisuke-Okumura/20433747"
    },
    {
        "icon": "researchgate",
        "name": "Research Gate",
        "url": "https://www.researchgate.net/profile/Keisuke_Okumura"
    },
    {
        "icon": "arxiv",
        "name": "arXiv",
        "url": "https://arxiv.org/search/?query=Keisuke+Okumura&searchtype=author"
    }
];


var $1ca3b90f2b12379e$exports = {};
$1ca3b90f2b12379e$exports = [
    {
        "title": "Unlocking Collective Automation with Lightweight Multi-Agent Pathfinding",
        "year": 2026,
        "month": 9,
        "authors": "Keisuke Okumura",
        "conf": "Seminar Talk, Amazon Robotics",
        "place": {
            "en": "Boston, US \uD83C\uDDFA\uD83C\uDDF8",
            "ja": "\u30A2\u30E1\u30EA\u30AB\u30FB\u30DC\u30B9\u30C8\u30F3"
        },
        "url": "https://www.amazon.jobs/content/en/teams/ftr/amazon-robotics",
        "selected": true
    },
    {
        "title": "The Cutting Edge of Algorithmic Multi-Agent Pathfinding",
        "year": 2026,
        "month": 9,
        "authors": "Keisuke Okumura",
        "conf": "Seminar Talk, Zardini Lab, MIT",
        "place": "Cambridge, US \uD83C\uDDFA\uD83C\uDDF8",
        "url": "https://zardini.mit.edu/"
    },
    {
        "title": {
            "en": "Scalable Multi-Agent Path Finding",
            "ja": "\u30B9\u30B1\u30FC\u30E9\u30D6\u30EB\u306A\u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7D4C\u8DEF\u8A08\u753B"
        },
        "year": 2026,
        "month": 9,
        "authors": "Keisuke Okumura",
        "conf": {
            "en": "Osaka University, MMDS",
            "ja": "\u5927\u962A\u5927\u5B66 MMDS AI\u30FB\u30C7\u30FC\u30BF\u5229\u6D3B\u7528\u7814\u7A76\u4F1A"
        },
        "place": {
            "en": "Online",
            "ja": "\u30AA\u30F3\u30E9\u30A4\u30F3"
        },
        "url": "https://www-mmds.sigmath.es.osaka-u.ac.jp/structure/activity/ai_data.php?id=117"
    },
    {
        "title": "Concrete Multi-Agent Path Planning Enabling Kinodynamically Aggressive Maneuvers",
        "year": 2026,
        "month": 8,
        "authors": "Keisuke Okumura",
        "conf": "Seminar Talk, IMRC Lab, TU Berlin",
        "place": "Berlin, Germany \uD83C\uDDE9\uD83C\uDDEA",
        "url": "https://imrclab.github.io/",
        "talk": "https://www.youtube.com/watch?v=k7ExaSpARtE"
    },
    {
        "title": "Combinatorial Search with Generators to Solve Collective Automation",
        "year": 2026,
        "month": 8,
        "authors": "Keisuke Okumura",
        "conf": "SoCS-26 Master Class",
        "place": "Bremerhaven, Germany \uD83C\uDDE9\uD83C\uDDEA",
        "url": "https://socs26.search-conference.org/talks/master-classes",
        "selected": true
    },
    {
        "title": "Bridging Discrete Planning and Continuous Execution for Multi-Robot Trajectories",
        "year": 2026,
        "month": 6,
        "authors": "Keisuke Okumura",
        "conf": "Seminar Talk, AI Robotics Lab, Sogang University",
        "place": {
            "en": "Online",
            "ja": "\u30AA\u30F3\u30E9\u30A4\u30F3"
        },
        "url": "https://airobotics.sogang.ac.kr/"
    },
    {
        "title": "Solving Collective Automation with Lightweight Multi-Agent Pathfinding",
        "year": 2026,
        "month": 4,
        "authors": "Keisuke Okumura",
        "conf": "Seminar Talk, IDM Lab, USC/UCI",
        "place": {
            "en": "Online",
            "ja": "\u30AA\u30F3\u30E9\u30A4\u30F3"
        },
        "url": "https://idm-lab.org/"
    },
    {
        "title": "From Scalable Multi-Agent Pathfinding to Capable Multi-Robot Coordination",
        "year": 2026,
        "month": 4,
        "authors": "Keisuke Okumura",
        "conf": {
            "en": "Seminar Talk, SDS, Hitotsubashi University",
            "ja": "\u4E00\u6A4B\u5927\u5B66\u5927\u5B66\u9662\u30BD\u30FC\u30B7\u30E3\u30EB\u30FB\u30C7\u30FC\u30BF\u30B5\u30A4\u30A8\u30F3\u30B9\u7814\u7A76\u79D1\u30BB\u30DF\u30CA\u30FC"
        },
        "place": {
            "en": "Online",
            "ja": "\u30AA\u30F3\u30E9\u30A4\u30F3"
        },
        "url": "https://www.sds.hit-u.ac.jp/3940/"
    },
    {
        "title": "From Scalable Multi-Agent Pathfinding to Capable Multi-Robot Coordination",
        "year": 2026,
        "month": 3,
        "authors": "Keisuke Okumura",
        "conf": "Autonomy Talks, Zardini Lab, MIT",
        "selected": true,
        "place": {
            "en": "Online",
            "ja": "\u30AA\u30F3\u30E9\u30A4\u30F3"
        },
        "talk": "https://www.youtube.com/watch?v=xI84VltsVRw",
        "url": "https://zardini.mit.edu/autonomytalks/"
    },
    {
        "title": "Panel Discussion - Aligning Research Direction Between Academia and Industry",
        "year": 2026,
        "month": 1,
        "authors": "Keisuke Okumura",
        "conf": "International Workshop on Multi-Agent Path Finding (WoMAPF)",
        "place": "Singapore \uD83C\uDDF8\uD83C\uDDEC",
        "url": "https://mapf-workshop.github.io/aaai26/"
    },
    {
        "title": "Upgrading Multi-Agent Pathfinding for the Real World",
        "year": 2025,
        "month": 10,
        "authors": "Keisuke Okumura",
        "conf": "European Workshop on Multi-Agent Pathfinding (EurMAPF-25)",
        "place": "Bologna, Italy \uD83C\uDDEE\uD83C\uDDF9",
        "url": "https://sites.google.com/view/eurmapf25",
        "talk": "https://speakerdeck.com/kei18/upgrading-multi-agent-pathfinding-for-the-real-world",
        "speakerdeck": "https://speakerdeck.com/kei18/upgrading-multi-agent-pathfinding-for-the-real-world",
        "selected": true
    },
    {
        "title": "From Scalable Multi-Agent Pathfinding to Capable Multi-Robot Coordination",
        "year": 2025,
        "month": 9,
        "authors": "Keisuke Okumura",
        "conf": "The 9th ISM-ISCT-NII-ZIB-NUS-MODAL Workshop on Optimization and Machine Learning for Data Science and Future Computing (OPTDS-25)",
        "place": "Tokyo, Japan \uD83C\uDDEF\uD83C\uDDF5",
        "url": "https://sites.google.com/view/optds2025/"
    },
    {
        "title": "From Scalable Multi-Agent Pathfinding to Capable Multi-Robot Coordination",
        "year": 2025,
        "month": 5,
        "authors": "Keisuke Okumura",
        "conf": "Seminar talk, Behavior in Networks Studies Unit, the University of Tokyo",
        "place": "Tokyo, Japan \uD83C\uDDEF\uD83C\uDDF5"
    },
    {
        "title": "Combinatorial Search with Generators",
        "year": 2024,
        "month": 5,
        "authors": "Keisuke Okumura",
        "conf": "Seminar talk, Optimisation group, Monash University",
        "place": "Melbourne, Australia \uD83C\uDDE6\uD83C\uDDFA",
        "speakerdeck": "https://speakerdeck.com/kei18/combinatorial-search-with-generators"
    },
    {
        "title": "Pathfinding for 10k agents - 2",
        "year": 2024,
        "month": 5,
        "authors": "Keisuke Okumura",
        "conf": "Agents-VIC Autumn Symposium 2024",
        "place": "Melbourne, Australia \uD83C\uDDE6\uD83C\uDDFA",
        "url": "https://sites.google.com/view/agentsvic-autumn2024/home"
    },
    {
        "title": "Remove Assumptions in Multi-Agent Pathfinding",
        "year": 2024,
        "month": 2,
        "authors": {
            "en": "Keisuke Okumura",
            "ja": "\u5965\u6751 \u572D\u7950"
        },
        "conf": "Guest talk at idealworks",
        "place": "Munich, Germany \uD83C\uDDE9\uD83C\uDDEA",
        "speakerdeck": "https://speakerdeck.com/kei18/remove-assumptions-in-multi-agent-pathfinding"
    },
    {
        "title": "Breaking Tradeoffs: Extremely Scalable Multi-Agent Pathfinding Algorithms\n",
        "year": 2024,
        "month": 2,
        "url": "https://jiaoyangli.me/teaching/2024-spring-16891",
        "authors": {
            "en": "Keisuke Okumura",
            "ja": "\u5965\u6751 \u572D\u7950"
        },
        "conf": "Lectures on \u201CMulti-Robot Planning and Coordination,\u201D Robotics Institute, Carnegie Mellon University\n",
        "place": {
            "en": "Online",
            "ja": "\u30AA\u30F3\u30E9\u30A4\u30F3"
        },
        "speakerdeck": "https://speakerdeck.com/kei18/breaking-tradeoffs-extremely-scalable-multi-agent-pathfinding-algorithms",
        "selected": false
    },
    {
        "title": "Pathfinding for 10k agents",
        "year": 2023,
        "month": 11,
        "selected": true,
        "url": "https://talks.cam.ac.uk/talk/index/204508",
        "talk": "https://www.cl.cam.ac.uk/seminars/wednesday/video/20231101-1500-t204508.html",
        "authors": {
            "en": "Keisuke Okumura",
            "ja": "\u5965\u6751 \u572D\u7950"
        },
        "conf": "Wednesday Seminars, the Department of Computer Science and Technology, University of Cambridge\n",
        "place": "Cambridge, UK \uD83C\uDDEC\uD83C\uDDE7",
        "speakerdeck": "https://speakerdeck.com/kei18/pathfinding-for-10k-agents-5534305f-45e3-4712-9605-ef112be6a7c5"
    },
    {
        "abbr": "SSII",
        "title": {
            "ja": "\u30DE\u30EB\u30C1\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7D4C\u8DEF\u8A08\u753B\u306E\u57FA\u790E\u3068\u6700\u65B0\u52D5\u5411",
            "en": "Introductions to Multi-Agent Path Planning"
        },
        "year": 2023,
        "month": 6,
        "url": "https://confit.atlas.jp/guide/event/ssii2023/static/organized#OS3",
        "authors": {
            "en": "Keisuke Okumura",
            "ja": "\u5965\u6751 \u572D\u7950"
        },
        "conf": {
            "ja": "\u7B2C29\u56DE\u753B\u50CF\u30BB\u30F3\u30B7\u30F3\u30B0\u30B7\u30F3\u30DD\u30B8\u30A6\u30E0",
            "en": "The 29th Symposium on Sensing via Image Information"
        },
        "place": {
            "ja": "\u30AA\u30F3\u30E9\u30A4\u30F3",
            "en": "Online"
        },
        "speakerdeck": "https://speakerdeck.com/ssii/ssii2023-os3-02"
    },
    {
        "title": "Quick Multi-Agent Path Planning",
        "year": 2022,
        "month": 9,
        "authors": "Keisuke Okumura",
        "conf": "Seminar talks at Artificial Intelligence Lab@VUB, HyCoDeV Lab@Newcastle University, Prorok Lab@University of Cambridge",
        "place": {
            "en": "Belgium \uD83C\uDDE7\uD83C\uDDEA / UK \uD83C\uDDEC\uD83C\uDDE7",
            "ja": "\u30D9\u30EB\u30AE\u30FC \uD83C\uDDE7\uD83C\uDDEA / \u30A4\u30AE\u30EA\u30B9 \uD83C\uDDEC\uD83C\uDDE7"
        },
        "speakerdeck": "https://speakerdeck.com/kei18/quick-multi-agent-path-planning"
    },
    {
        "abbr": "CoRe",
        "authors": {
            "en": "Keisuke Okumura",
            "ja": "\u5965\u6751 \u572D\u7950"
        },
        "conf": {
            "en": "The 27th CoRe seminar",
            "ja": "\u7D44\u5408\u305B\u9077\u79FB\u30FB\u7B2C27\u56DE\u30BB\u30DF\u30CA\u30FC"
        },
        "month": 7,
        "place": {
            "en": "Online",
            "ja": "\u30AA\u30F3\u30E9\u30A4\u30F3"
        },
        "speakerdeck": "https://speakerdeck.com/kei18/navigation-for-a-team-of-agents",
        "style": "oral",
        "title": {
            "en": "Navigation for a team of agents",
            "ja": "\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7FA4\u306E\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3"
        },
        "url": {
            "en": "https://core.dais.is.tohoku.ac.jp/en/report/past-event/detail/---id-125.html",
            "ja": "https://core.dais.is.tohoku.ac.jp/report/past-event/detail/---id-124.html"
        },
        "year": 2022
    },
    {
        "abbr": "SIG-FPAI",
        "authors": {
            "en": "Keisuke Okumura",
            "ja": "\u5965\u6751 \u572D\u7950"
        },
        "conf": {
            "en": "Special Interest Group on Fundamental Problems in Artificial Intelligence",
            "ja": "\u4EBA\u5DE5\u77E5\u80FD\u5B66\u4F1A \u7B2C116\u56DE\u4EBA\u5DE5\u77E5\u80FD\u57FA\u672C\u554F\u984C\u7814\u7A76\u4F1A"
        },
        "month": 3,
        "place": {
            "en": "Online",
            "ja": "\u30AA\u30F3\u30E9\u30A4\u30F3"
        },
        "speakerdeck": "https://speakerdeck.com/kei18/on-controlling-swarm-of-moving-agents",
        "style": "oral",
        "title": {
            "en": "On Controlling Swarm of Moving Agents",
            "ja": "\u5927\u898F\u6A21\u306A\u79FB\u52D5\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u7FA4\u306E\u5236\u5FA1"
        },
        "url": "https://sig-fpai.org/past/fpai116.html",
        "year": 2021
    },
    {
        "abbr": "WDALFR",
        "authors": "Keisuke Okumura",
        "conf": "Workshop on Distributed Algorithms for Low-Functional Robots",
        "month": 11,
        "place": "Nagasaki, Japan \uD83C\uDDEF\uD83C\uDDF5",
        "speakerdeck": "https://speakerdeck.com/kei18/cooperative-framework-for-multiple-moving-agents",
        "style": "oral",
        "title": "Cooperative Framework for Multiple Moving Agents",
        "url": "https://sites.google.com/view/wdalfr/the-1st-wdalfr2019",
        "year": 2019
    }
];


const $89618bfaa27a1d5d$export$976783c17ab7505a = (0, (/*@__PURE__*/$parcel$interopDefault($7149fcc68faf2e72$exports)));
const $89618bfaa27a1d5d$export$d641923eb395899e = (0, (/*@__PURE__*/$parcel$interopDefault($8f307ee5a3069d8d$exports)));
const $89618bfaa27a1d5d$export$1eef222eb1d1cc64 = (0, (/*@__PURE__*/$parcel$interopDefault($b6408df0f93d0f1e$exports)));
const $89618bfaa27a1d5d$export$62efb6f08db5a542 = (0, (/*@__PURE__*/$parcel$interopDefault($f4d3a71b3cce4a77$exports)));
const $89618bfaa27a1d5d$export$6e4408f1372a0887 = (0, (/*@__PURE__*/$parcel$interopDefault($5c662af821f55a2f$exports)));
const $89618bfaa27a1d5d$export$c4a8527386f7d00f = (0, (/*@__PURE__*/$parcel$interopDefault($ebc05d05124bebbf$exports)));
const $89618bfaa27a1d5d$export$2d6e27136d82d944 = (0, (/*@__PURE__*/$parcel$interopDefault($9355e851a7af8fb5$exports)));
const $89618bfaa27a1d5d$export$2f1a9429a30437b6 = (0, (/*@__PURE__*/$parcel$interopDefault($315d147b3a3783e4$exports)));
const $89618bfaa27a1d5d$export$a69ae8fa9a769acd = (0, (/*@__PURE__*/$parcel$interopDefault($cec20df2513b66fe$exports)));
const $89618bfaa27a1d5d$export$5408d51283cb8d9e = (0, (/*@__PURE__*/$parcel$interopDefault($91a18662b9329c89$exports)));
const $89618bfaa27a1d5d$export$6f49b4016bfc8d56 = (0, (/*@__PURE__*/$parcel$interopDefault($64a59958072aa83b$exports)));
const $89618bfaa27a1d5d$export$6adadbb4f780deb7 = (0, (/*@__PURE__*/$parcel$interopDefault($a04f692337f4cbf5$exports)));
const $89618bfaa27a1d5d$export$c379b13c1521865e = (0, (/*@__PURE__*/$parcel$interopDefault($1eea9a6788ff239f$exports)));
const $89618bfaa27a1d5d$export$8102da2f15f4fe90 = (0, (/*@__PURE__*/$parcel$interopDefault($ce8d7bb5ce699c2e$exports)));
const $89618bfaa27a1d5d$export$623b44a0e7f71454 = (0, (/*@__PURE__*/$parcel$interopDefault($57390a5792bca891$exports)));
const $89618bfaa27a1d5d$export$9624c2b57a2e6db = (0, (/*@__PURE__*/$parcel$interopDefault($1ca3b90f2b12379e$exports)));



var $acw62 = parcelRequire("acw62");

const $3cdc8a61f42a3ec8$export$4bff874d61454b38 = (0, $89618bfaa27a1d5d$export$976783c17ab7505a).name.firstName.en + " " + (0, $89618bfaa27a1d5d$export$976783c17ab7505a).name.familyName.en;
const $3cdc8a61f42a3ec8$export$12a09de97362d322 = (0, $89618bfaa27a1d5d$export$976783c17ab7505a).name.familyName.ja + " " + (0, $89618bfaa27a1d5d$export$976783c17ab7505a).name.firstName.ja;
const $3cdc8a61f42a3ec8$export$a5bcd7e637eba5de = (0, $89618bfaa27a1d5d$export$976783c17ab7505a).name.firstName.en[0] + "." + (0, $89618bfaa27a1d5d$export$976783c17ab7505a).name.familyName.en[0] + ".";
const $3cdc8a61f42a3ec8$export$ee24d319fa53beb6 = (value, langEn)=>{
    if (!value) return "";
    if (typeof value === "string") return value;
    const primary = langEn ? value.en : value.ja;
    const fallback = langEn ? value.ja : value.en;
    return (primary ?? fallback ?? "").trim();
};
const $3cdc8a61f42a3ec8$var$getAbbrExpansion = (abbr, langEn)=>{
    if (!abbr) return "";
    const entry = (0, $89618bfaa27a1d5d$export$6adadbb4f780deb7)?.abbr?.[abbr];
    if (!entry) return "";
    return entry;
};
const $3cdc8a61f42a3ec8$export$4fc1b509915a0374 = (item, langEn)=>{
    const book = item.book ? $3cdc8a61f42a3ec8$export$ee24d319fa53beb6(item.book, langEn) : "";
    const conf = item.conf ? $3cdc8a61f42a3ec8$export$ee24d319fa53beb6(item.conf, langEn) : "";
    return (book || conf || $3cdc8a61f42a3ec8$var$getAbbrExpansion(item.abbr, langEn)).trim();
};
const $3cdc8a61f42a3ec8$export$d05a211c0a2dda4e = (item, langEn)=>{
    const conf = $3cdc8a61f42a3ec8$export$ee24d319fa53beb6(item.conf, langEn);
    const place = $3cdc8a61f42a3ec8$export$ee24d319fa53beb6(item.place, langEn);
    const confWithAbbr = item.abbr && conf ? `${conf} (${item.abbr})` : conf;
    if (confWithAbbr && place) return `${confWithAbbr}, ${place}`;
    return (confWithAbbr || place).trim();
};
const $3cdc8a61f42a3ec8$var$sanitizeBibtexValue = (value)=>value.replace(/[{}]/g, "").replace(/\s+/g, " ").trim();
const $3cdc8a61f42a3ec8$var$wrapBibtexValue = (value)=>`{${$3cdc8a61f42a3ec8$var$sanitizeBibtexValue(value)}}`;
const $3cdc8a61f42a3ec8$var$toBibtexAuthorName = (input)=>{
    if (!input) return "";
    const parts = input.trim().replace(/\s+/g, " ").split(" ").filter(Boolean);
    if (parts.length <= 1) return parts.join("");
    const suffixSet = new Set([
        "jr",
        "sr",
        "ii",
        "iii",
        "iv",
        "v"
    ]);
    const lastLower = parts[parts.length - 1].toLowerCase().replace(/\.$/, "");
    const suffix = suffixSet.has(lastLower) ? parts.pop() : "";
    const lastName = parts.pop();
    const givenNames = parts.join(" ");
    const base = `${lastName}, ${givenNames}`.trim().replace(/,\s*$/, "");
    return suffix ? `${base}, ${suffix.replace(/\.$/, "")}.` : base;
};
const $3cdc8a61f42a3ec8$var$toBibtexAuthors = (authors)=>authors.split(",").map((name)=>name.trim()).filter(Boolean).map($3cdc8a61f42a3ec8$var$toBibtexAuthorName).join(" and ");
const $3cdc8a61f42a3ec8$var$buildBibtexKey = (item, langEn)=>{
    const authors = $3cdc8a61f42a3ec8$export$ee24d319fa53beb6(item.authors, langEn);
    const firstAuthor = authors.split(",")[0]?.trim() ?? "unknown";
    const lastName = firstAuthor.split(" ").filter(Boolean).pop() ?? "unknown";
    const year = item.year ? String(item.year) : "nd";
    const title = $3cdc8a61f42a3ec8$export$ee24d319fa53beb6(item.title, langEn);
    const firstWord = title.split(/\s+/).filter(Boolean)[0] ?? "work";
    const key = `${lastName}${year}${firstWord}`;
    return key.replace(/[^a-zA-Z0-9]+/g, "").toLowerCase();
};
const $3cdc8a61f42a3ec8$var$getBibtexType = (kind)=>{
    switch(kind){
        case "journal":
            return "article";
        case "reviewedProceeding":
        case "reviewedProceedingMinor":
        case "reviewedWorkshop":
            return "inproceedings";
        case "preprint":
            return "misc";
        case "book":
            return "book";
        case "dissertation":
            return "phdthesis";
        default:
            return "misc";
    }
};
const $3cdc8a61f42a3ec8$var$buildBibtexEntry = (item, langEn)=>{
    const fields = [];
    const title = $3cdc8a61f42a3ec8$export$ee24d319fa53beb6(item.title, langEn);
    const authors = $3cdc8a61f42a3ec8$export$ee24d319fa53beb6(item.authors, langEn);
    const book = item.book ? $3cdc8a61f42a3ec8$export$ee24d319fa53beb6(item.book, langEn) : "";
    const conf = item.conf ? $3cdc8a61f42a3ec8$export$ee24d319fa53beb6(item.conf, langEn) : "";
    const venue = (book || conf || $3cdc8a61f42a3ec8$var$getAbbrExpansion(item.abbr, langEn)).trim();
    if (title) fields.push([
        "title",
        $3cdc8a61f42a3ec8$var$wrapBibtexValue(title)
    ]);
    if (authors) fields.push([
        "author",
        $3cdc8a61f42a3ec8$var$wrapBibtexValue($3cdc8a61f42a3ec8$var$toBibtexAuthors(authors))
    ]);
    if (item.year) fields.push([
        "year",
        $3cdc8a61f42a3ec8$var$wrapBibtexValue(String(item.year))
    ]);
    if (item.month) fields.push([
        "month",
        $3cdc8a61f42a3ec8$var$wrapBibtexValue($3cdc8a61f42a3ec8$export$e7af3ee2c84591cc(item.month).toLowerCase())
    ]);
    if (item.pages) fields.push([
        "pages",
        $3cdc8a61f42a3ec8$var$wrapBibtexValue(item.pages)
    ]);
    const kind = item.kind;
    if (kind === "journal") {
        if (venue) fields.push([
            "journal",
            $3cdc8a61f42a3ec8$var$wrapBibtexValue(venue)
        ]);
    } else if (kind === "book") {
        if (venue) fields.push([
            "publisher",
            $3cdc8a61f42a3ec8$var$wrapBibtexValue(venue)
        ]);
    } else if (kind === "dissertation") {
        if (venue) fields.push([
            "school",
            $3cdc8a61f42a3ec8$var$wrapBibtexValue(venue)
        ]);
    } else if (venue) fields.push([
        "booktitle",
        $3cdc8a61f42a3ec8$var$wrapBibtexValue(venue)
    ]);
    if (item.doi) fields.push([
        "doi",
        $3cdc8a61f42a3ec8$var$wrapBibtexValue(item.doi)
    ]);
    if (item.paperUrl) fields.push([
        "url",
        $3cdc8a61f42a3ec8$var$wrapBibtexValue(item.paperUrl)
    ]);
    if (fields.length === 0) return "";
    const key = $3cdc8a61f42a3ec8$var$buildBibtexKey(item, langEn);
    const entryType = $3cdc8a61f42a3ec8$var$getBibtexType(item.kind);
    const formattedFields = fields.map(([keyName, value])=>`  ${keyName} = ${value}`).join(",\n");
    return `@${entryType}{${key},\n${formattedFields}\n}`;
};
const $3cdc8a61f42a3ec8$export$ece7058721307118 = (item, langEn)=>{
    if (typeof item.bibtex === "string" && item.bibtex.trim()) return item.bibtex.trim();
    return $3cdc8a61f42a3ec8$var$buildBibtexEntry(item, langEn);
};
const $3cdc8a61f42a3ec8$export$e7af3ee2c84591cc = (month)=>{
    switch(month){
        case 1:
            return "Jan";
        case 2:
            return "Feb";
        case 3:
            return "Mar";
        case 4:
            return "Apr";
        case 5:
            return "May";
        case 6:
            return "Jun";
        case 7:
            return "Jul";
        case 8:
            return "Aug";
        case 9:
            return "Sep";
        case 10:
            return "Oct";
        case 11:
            return "Nov";
        case 12:
            return "Dec";
        default:
            return "";
    }
};
const $3cdc8a61f42a3ec8$export$42b8cd85fd1c8271 = (month, year, langEn)=>{
    if (langEn) return $3cdc8a61f42a3ec8$export$e7af3ee2c84591cc(month) + ". " + String(year);
    else return String(year) + "\u5E74" + String(month) + "\u6708";
};
const $3cdc8a61f42a3ec8$export$90af2d5417783d04 = (authors_str, usebib = false)=>{
    const authors = authors_str.split(",");
    const authorNum = authors.length;
    return authors.map((name, j)=>{
        let seperator = ", ";
        if (j == authorNum - 1) seperator = usebib ? "" : ".";
        else if (authorNum >= 2 && j == authorNum - 2) seperator = " & ";
        return name.trim() == $3cdc8a61f42a3ec8$export$4bff874d61454b38 || name.trim() == $3cdc8a61f42a3ec8$export$12a09de97362d322 ? /*#__PURE__*/ $acw62.createElement("span", {
            key: j
        }, /*#__PURE__*/ $acw62.createElement("u", null, usebib ? $3cdc8a61f42a3ec8$export$251aabae27b9421e(name) : name), seperator) : /*#__PURE__*/ $acw62.createElement("span", {
            key: j
        }, usebib ? $3cdc8a61f42a3ec8$export$251aabae27b9421e(name) : name, seperator);
    });
};
function $3cdc8a61f42a3ec8$export$251aabae27b9421e(input) {
    if (!input) return "";
    const parts = input.trim().replace(/\s+/g, " ").split(" ").filter(Boolean);
    if (parts.length === 1) return parts[0];
    const suffixSet = new Set([
        "jr",
        "sr",
        "ii",
        "iii",
        "iv",
        "v"
    ]);
    let suffix = null;
    const lastLower = parts[parts.length - 1].toLowerCase().replace(/\.$/, "");
    if (suffixSet.has(lastLower)) suffix = parts.pop();
    const lastName = parts.pop();
    const givenNames = parts;
    const initials = givenNames.map((gn)=>gn.split("-").filter(Boolean).map((seg)=>seg[0]?.toUpperCase() ?? "").map((ch)=>`${ch}.`).join(" ")).filter(Boolean).join(" ");
    const core = `${lastName}, ${initials || ""}`.trim().replace(/,\s*$/, "");
    return suffix ? `${core}, ${suffix.replace(/\.$/, "")}.` : core;
}



var $acw62 = parcelRequire("acw62");
const $4abb03b3e6419d50$var$LangContext = /*#__PURE__*/ $acw62.createContext(undefined);
const $4abb03b3e6419d50$export$b78e4fb81d317543 = ({ children: children })=>{
    const [langEn, setLangEn] = $acw62.useState(true);
    const toggleLang = ()=>setLangEn((prev)=>!prev);
    return /*#__PURE__*/ $acw62.createElement($4abb03b3e6419d50$var$LangContext.Provider, {
        value: {
            langEn: langEn,
            setLangEn: setLangEn,
            toggleLang: toggleLang
        }
    }, children);
};
const $4abb03b3e6419d50$export$b24a004ee43dce44 = ()=>{
    const context = $acw62.useContext($4abb03b3e6419d50$var$LangContext);
    if (!context) throw new Error("useLang must be used within LangProvider");
    return context;
};


const $3e391071d873e97e$var$Menu = ({ onNavigate: onNavigate })=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    return /*#__PURE__*/ $acw62.createElement("aside", {
        id: "colorlib-aside",
        role: "complementary",
        className: "js-fullheight text-right"
    }, /*#__PURE__*/ $acw62.createElement("h1", {
        id: "colorlib-logo",
        className: "hidden-md"
    }, /*#__PURE__*/ $acw62.createElement("a", {
        href: "#top",
        onClick: onNavigate
    }, "Kei18")), /*#__PURE__*/ $acw62.createElement("nav", {
        id: "colorlib-main-menu",
        role: "navigation"
    }, /*#__PURE__*/ $acw62.createElement("ul", null, (0, $89618bfaa27a1d5d$export$6f49b4016bfc8d56).menu.map((item)=>/*#__PURE__*/ $acw62.createElement("li", {
            key: item.id,
            className: item.className
        }, /*#__PURE__*/ $acw62.createElement("a", {
            href: item.href,
            onClick: onNavigate
        }, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.label, langEn)))))), /*#__PURE__*/ $acw62.createElement("div", {
        className: "colorlib-footer"
    }, /*#__PURE__*/ $acw62.createElement("ul", null, (0, $89618bfaa27a1d5d$export$5408d51283cb8d9e).map((item, i)=>/*#__PURE__*/ $acw62.createElement("li", {
            key: i
        }, /*#__PURE__*/ $acw62.createElement("a", {
            href: item.url,
            onClick: onNavigate
        }, /*#__PURE__*/ $acw62.createElement("i", {
            className: "academic-icon ai icon " + item.name
        })))))));
};
var $3e391071d873e97e$export$2e2bcd8739ae039 = $3e391071d873e97e$var$Menu;



var $acw62 = parcelRequire("acw62");
var $02cff0d0be730940$exports = {};
var $793bb872fbb7fe9d$exports = {};
$793bb872fbb7fe9d$exports = import.meta.resolve("9BfRR");


var $36c3dc0aca0bbc88$exports = {};
$36c3dc0aca0bbc88$exports = import.meta.resolve("ip397");


var $2f7a58016c871a3a$exports = {};
$2f7a58016c871a3a$exports = import.meta.resolve("4zSGC");


var $272119eb5347bea2$exports = {};
$272119eb5347bea2$exports = import.meta.resolve("ftLUO");


var $d7c917a80b7aac3a$exports = {};
$d7c917a80b7aac3a$exports = import.meta.resolve("kmalq");


var $849c5eddd605a1d8$exports = {};
$849c5eddd605a1d8$exports = import.meta.resolve("hOaLZ");


var $09b8d64a0c3d0565$exports = {};
$09b8d64a0c3d0565$exports = import.meta.resolve("c3a0H");


var $7630c63949500626$exports = {};
$7630c63949500626$exports = import.meta.resolve("9DwJ3");


var $eb7b4def189ebe71$exports = {};
$eb7b4def189ebe71$exports = import.meta.resolve("aiVZT");


var $2c37fe8471e292b0$exports = {};
$2c37fe8471e292b0$exports = import.meta.resolve("cmbfU");


var $eda26d753a14293c$exports = {};
$eda26d753a14293c$exports = import.meta.resolve("gzu3H");


var $21d29bf8f50bff33$exports = {};
$21d29bf8f50bff33$exports = import.meta.resolve("25hCP");


$02cff0d0be730940$exports = {
    "40robots_1": $793bb872fbb7fe9d$exports,
    "8drones_led": $36c3dc0aca0bbc88$exports,
    "botio": $2f7a58016c871a3a$exports,
    "bug-generator": $272119eb5347bea2$exports,
    "colors-of-msp": $d7c917a80b7aac3a$exports,
    "cvbook2025": $849c5eddd605a1d8$exports,
    "iumapf": $09b8d64a0c3d0565$exports,
    "npj-robotics-bg": $7630c63949500626$exports,
    "profile18_compressed": $eb7b4def189ebe71$exports,
    "profile2": $2c37fe8471e292b0$exports,
    "projection-mapping": $eda26d753a14293c$exports,
    "tapf": $21d29bf8f50bff33$exports
};


var $69dcad05a0bc697a$exports = {};
var $14d3d7f9b90a6cbe$exports = {};
$14d3d7f9b90a6cbe$exports = import.meta.resolve("j5ENZ");


var $0347c482f58667d4$exports = {};
$0347c482f58667d4$exports = import.meta.resolve("78D3k");


var $67dfd66ef0c07ecf$exports = {};
$67dfd66ef0c07ecf$exports = import.meta.resolve("98yW2");


var $2ab4c553cbe6f380$exports = {};
$2ab4c553cbe6f380$exports = import.meta.resolve("bfrNa");


var $60ab12ed5b2c4d53$exports = {};
$60ab12ed5b2c4d53$exports = import.meta.resolve("hBKsr");


var $83992e59a3f744cc$exports = {};
$83992e59a3f744cc$exports = import.meta.resolve("3w3dH");


$69dcad05a0bc697a$exports = {
    "10drones": $14d3d7f9b90a6cbe$exports,
    "led-8drones-crf18": $0347c482f58667d4$exports,
    "led-8drones-mobile": $67dfd66ef0c07ecf$exports,
    "mapf": $2ab4c553cbe6f380$exports,
    "npj-robotics-paper": $60ab12ed5b2c4d53$exports,
    "reloc": $83992e59a3f744cc$exports
};



const $6a9bfe7e01a5c3e7$export$c60880f504524a89 = (value)=>{
    if (typeof value === "string") return value;
    if (value instanceof URL) return value.toString();
    if (value && typeof value === "object" && "default" in value) return String(value.default ?? "");
    if (value && typeof value === "object") {
        if ("url" in value) return String(value.url ?? "");
        if ("href" in value) return String(value.href ?? "");
        if ("src" in value) return String(value.src ?? "");
        if ("path" in value) return String(value.path ?? "");
        return String(value);
    }
    return "";
};
const $6a9bfe7e01a5c3e7$var$basename = (value)=>value.split("/").pop() || value;
const $6a9bfe7e01a5c3e7$var$withoutExtension = (value)=>value.replace(/\.[^/.]+$/, "");
const $6a9bfe7e01a5c3e7$export$552dd721d9ff2d3f = (assets)=>{
    const resolved = {};
    if (!assets || typeof assets !== "object") return resolved;
    Object.keys(assets).forEach((key)=>{
        const assetUrl = $6a9bfe7e01a5c3e7$export$c60880f504524a89(assets[key]);
        resolved[key] = assetUrl;
        const base = $6a9bfe7e01a5c3e7$var$basename(key);
        resolved[base] = assetUrl;
        resolved[$6a9bfe7e01a5c3e7$var$withoutExtension(base)] = assetUrl;
    });
    return resolved;
};
const $6a9bfe7e01a5c3e7$export$e6a7fad94b08a6ce = (...maps)=>Object.assign({}, ...maps);
const $6a9bfe7e01a5c3e7$export$c8466dd3c8c19636 = (map, key)=>{
    if (!key) return "";
    return map[key] ?? "";
};




const $a79abc605320dbc3$var$Hero = ()=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    const shellRef = $acw62.useRef(null);
    const images = (0, $6a9bfe7e01a5c3e7$export$552dd721d9ff2d3f)((0, (/*@__PURE__*/$parcel$interopDefault($02cff0d0be730940$exports))));
    const videos = (0, $6a9bfe7e01a5c3e7$export$552dd721d9ff2d3f)((0, (/*@__PURE__*/$parcel$interopDefault($69dcad05a0bc697a$exports))));
    const hero = (0, $89618bfaa27a1d5d$export$d641923eb395899e).hero || {};
    const heroVideoKey = hero.video || "";
    const heroVideoUrl = (0, $6a9bfe7e01a5c3e7$export$c8466dd3c8c19636)(videos, heroVideoKey);
    const heroImageKey = hero.image || "";
    const heroMobile = Array.isArray(hero.mobile) ? hero.mobile : [];
    const heroImageMobileTopKey = heroMobile[0] || hero.imageMobileTop || hero.imageMobile || heroImageKey;
    const heroImageMobileBottomKey = heroMobile[1] || hero.imageMobile || hero.imageMobileTop || heroImageMobileTopKey || heroImageKey;
    const heroImageUrl = (0, $6a9bfe7e01a5c3e7$export$c8466dd3c8c19636)(images, heroImageKey);
    const heroImageMobileTopUrl = (0, $6a9bfe7e01a5c3e7$export$c8466dd3c8c19636)(images, heroImageMobileTopKey) || heroImageUrl;
    const heroImageMobileBottomUrl = (0, $6a9bfe7e01a5c3e7$export$c8466dd3c8c19636)(images, heroImageMobileBottomKey) || heroImageUrl;
    const heroImageStyle = heroImageUrl ? {
        backgroundImage: `url(${heroImageUrl})`
    } : undefined;
    const heroImageMobileTopStyle = heroImageMobileTopUrl ? {
        backgroundImage: `url(${heroImageMobileTopUrl})`
    } : heroImageStyle;
    const heroImageMobileBottomStyle = heroImageMobileBottomUrl ? {
        backgroundImage: `url(${heroImageMobileBottomUrl})`
    } : heroImageStyle;
    const heroTaglineText = (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)((0, $89618bfaa27a1d5d$export$d641923eb395899e).heroTagline, langEn);
    $acw62.useEffect(()=>{
        const target = shellRef.current;
        if (!target) return;
        const observer = new IntersectionObserver(([entry])=>{
            const heroDominant = entry.intersectionRatio > 0.45;
            document.body.classList.toggle("hero-in-view", heroDominant);
        }, {
            threshold: [
                0,
                0.15,
                0.3,
                0.45,
                0.6,
                0.75,
                1
            ]
        });
        observer.observe(target);
        return ()=>{
            observer.disconnect();
            document.body.classList.remove("hero-in-view");
        };
    }, []);
    return /*#__PURE__*/ $acw62.createElement("section", {
        id: "top",
        className: "ftco-section top-hero-shell",
        ref: shellRef
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "top-hero-full"
    }, heroVideoUrl ? /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("video", {
        className: "top-hero-video",
        autoPlay: true,
        loop: true,
        muted: true,
        playsInline: true,
        preload: "metadata",
        poster: heroImageUrl || undefined
    }, /*#__PURE__*/ $acw62.createElement("source", {
        src: heroVideoUrl,
        type: "video/mp4"
    })), /*#__PURE__*/ $acw62.createElement("div", {
        className: "top-hero-mobile-split"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "top-hero-mobile-panel top-hero-mobile-top-image",
        style: heroImageMobileTopStyle
    }), /*#__PURE__*/ $acw62.createElement("div", {
        className: "top-hero-mobile-panel top-hero-mobile-bottom-image",
        style: heroImageMobileBottomStyle
    }))) : /*#__PURE__*/ $acw62.createElement("div", {
        className: "top-hero-image",
        style: heroImageStyle
    }), /*#__PURE__*/ $acw62.createElement("div", {
        className: "top-hero-overlay"
    })), /*#__PURE__*/ $acw62.createElement("div", {
        className: "top-hero-content"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "container top-hero-inner"
    }, /*#__PURE__*/ $acw62.createElement("p", {
        className: "mb-0 h2 d-none d-md-block top-hero-name"
    }, (0, $3cdc8a61f42a3ec8$export$4bff874d61454b38), /*#__PURE__*/ $acw62.createElement("span", {
        className: "ml-2"
    }, "| ", (0, $3cdc8a61f42a3ec8$export$12a09de97362d322))), heroTaglineText ? /*#__PURE__*/ $acw62.createElement("p", {
        className: "d-none d-md-block top-hero-tagline"
    }, heroTaglineText) : "", /*#__PURE__*/ $acw62.createElement("p", {
        className: "mb-0 d-sm-none h3 top-hero-name"
    }, (0, $3cdc8a61f42a3ec8$export$4bff874d61454b38)), /*#__PURE__*/ $acw62.createElement("p", {
        className: "mb-2 d-sm-none h4 top-hero-name"
    }, (0, $3cdc8a61f42a3ec8$export$12a09de97362d322)), heroTaglineText ? /*#__PURE__*/ $acw62.createElement("p", {
        className: "d-md-none top-hero-mobile-tagline"
    }, heroTaglineText) : "", /*#__PURE__*/ $acw62.createElement("div", {
        className: "h6 mb-2 top-hero-sub d-none d-md-block",
        dangerouslySetInnerHTML: {
            __html: (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)((0, $89618bfaa27a1d5d$export$d641923eb395899e).selfIntroduction, langEn)
        }
    }))));
};
var $a79abc605320dbc3$export$2e2bcd8739ae039 = $a79abc605320dbc3$var$Hero;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $b796d773b853b072$exports = {};
$b796d773b853b072$exports = import.meta.resolve("lTYrc");






const $6bea4e8b05121148$var$Top = ()=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    const images = (0, $6a9bfe7e01a5c3e7$export$552dd721d9ff2d3f)((0, (/*@__PURE__*/$parcel$interopDefault($02cff0d0be730940$exports))));
    const photoUrl = (0, $6a9bfe7e01a5c3e7$export$c8466dd3c8c19636)(images, (0, $89618bfaa27a1d5d$export$d641923eb395899e).photo);
    const topLinks = ((0, $89618bfaa27a1d5d$export$d641923eb395899e).links || []).map((link)=>({
            title: (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(link.title, langEn),
            url: (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(link.url, langEn)
        })).filter((link)=>link.title && link.url);
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: "top-profile",
        className: "ftco-section"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "container justify-content-center pt-3"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "row text-left align-items-start top-profile-row"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "col-md-3 pt-3 top-profile-photo-col"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "d-md-none top-mobile-intro",
        dangerouslySetInnerHTML: {
            __html: (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)((0, $89618bfaa27a1d5d$export$d641923eb395899e).selfIntroduction, langEn) || ""
        }
    }), photoUrl ? /*#__PURE__*/ $acw62.createElement("img", {
        src: photoUrl,
        className: "bd-placeholder-img img-fluid author-photo"
    }) : ""), /*#__PURE__*/ $acw62.createElement("div", {
        className: "col-md-9 pt-3 top-profile-body-col"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "h6 mt-3 mb-4 top-short-bio-block"
    }, /*#__PURE__*/ $acw62.createElement("a", {
        href: "",
        role: "button",
        onClick: (e)=>{
            e.preventDefault();
            setIsOpen(!isOpen);
        }
    }, isOpen ? "\xab close" : "Short Bio \xbb"), /*#__PURE__*/ $acw62.createElement("div", {
        className: `mt-2 top-bio ${isOpen ? "is-open" : ""}`,
        id: "short-bio"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "card card-body text-secondary"
    }, /*#__PURE__*/ $acw62.createElement("small", null, (0, $89618bfaa27a1d5d$export$d641923eb395899e).bio)))), /*#__PURE__*/ $acw62.createElement("p", {
        className: "h6 top-actions"
    }, /*#__PURE__*/ $acw62.createElement("a", {
        href: (0, (/*@__PURE__*/$parcel$interopDefault($b796d773b853b072$exports))),
        className: "btn btn-primary btn-sm link-arrow",
        target: "_blank",
        rel: "noreferrer"
    }, "Curriculum Vitae"), topLinks.map((link)=>/*#__PURE__*/ $acw62.createElement("a", {
            key: `${link.title}-${link.url}`,
            href: link.url,
            className: "btn btn-primary btn-sm link-arrow",
            target: "_blank",
            rel: "noreferrer"
        }, link.title)))))));
};
var $6bea4e8b05121148$export$2e2bcd8739ae039 = $6bea4e8b05121148$var$Top;



var $acw62 = parcelRequire("acw62");

var $fea50fe678f1d4ed$exports = {};


$fea50fe678f1d4ed$exports = function(e) {
    var t = {};
    function r(n) {
        if (t[n]) return t[n].exports;
        var o = t[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    return r.m = e, r.c = t, r.d = function(e, t, n) {
        r.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: n
        });
    }, r.r = function(e) {
        'undefined' != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: 'Module'
        }), Object.defineProperty(e, '__esModule', {
            value: !0
        });
    }, r.t = function(e, t) {
        if (1 & t && (e = r(e)), 8 & t) return e;
        if (4 & t && 'object' == typeof e && e && e.__esModule) return e;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, 'default', {
            enumerable: !0,
            value: e
        }), 2 & t && 'string' != typeof e) for(var o in e)r.d(n, o, (function(t) {
            return e[t];
        }).bind(null, o));
        return n;
    }, r.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return r.d(t, 'a', t), t;
    }, r.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = '', r(r.s = 8);
}([
    function(e, t) {
        e.exports = (parcelRequire("acw62"));
    },
    function(e, t, r) {
        e.exports = r(10)();
    },
    function(e, t, r) {
        'use strict';
        Object.defineProperty(t, '__esModule', {
            value: !0
        }), t.default = function() {
            return 'undefined' != typeof window && 'IntersectionObserver' in window && 'isIntersecting' in window.IntersectionObserverEntry.prototype;
        };
    },
    function(e, t, r) {
        'use strict';
        Object.defineProperty(t, '__esModule', {
            value: !0
        });
        var n = function() {
            function e(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, 'value' in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            return function(t, r, n) {
                return r && e(t.prototype, r), n && e(t, n), t;
            };
        }(), o = u(r(0)), i = r(1), a = u(r(4)), s = u(r(12)), l = u(r(2));
        function u(e) {
            return e && e.__esModule ? e : {
                default: e
            };
        }
        var c = function(e) {
            function t(e) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
                }(this, t);
                var r = function(e, t) {
                    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return !t || 'object' != typeof t && 'function' != typeof t ? e : t;
                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)), n = e.afterLoad, o = e.beforeLoad, i = e.scrollPosition, a = e.visibleByDefault;
                return r.state = {
                    visible: a
                }, a && (o(), n()), r.onVisible = r.onVisible.bind(r), r.isScrollTracked = Boolean(i && Number.isFinite(i.x) && i.x >= 0 && Number.isFinite(i.y) && i.y >= 0), r;
            }
            return function(e, t) {
                if ('function' != typeof t && null !== t) throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }(t, e), n(t, [
                {
                    key: 'componentDidUpdate',
                    value: function(e, t) {
                        t.visible !== this.state.visible && this.props.afterLoad();
                    }
                },
                {
                    key: 'onVisible',
                    value: function() {
                        this.props.beforeLoad(), this.setState({
                            visible: !0
                        });
                    }
                },
                {
                    key: 'render',
                    value: function() {
                        if (this.state.visible) return this.props.children;
                        var e = this.props, t = e.className, r = e.delayMethod, n = e.delayTime, i = e.height, u = e.placeholder, c = e.scrollPosition, f = e.style, p = e.threshold, d = e.useIntersectionObserver, y = e.width;
                        return this.isScrollTracked || d && (0, l.default)() ? o.default.createElement(a.default, {
                            className: t,
                            height: i,
                            onVisible: this.onVisible,
                            placeholder: u,
                            scrollPosition: c,
                            style: f,
                            threshold: p,
                            useIntersectionObserver: d,
                            width: y
                        }) : o.default.createElement(s.default, {
                            className: t,
                            delayMethod: r,
                            delayTime: n,
                            height: i,
                            onVisible: this.onVisible,
                            placeholder: u,
                            style: f,
                            threshold: p,
                            width: y
                        });
                    }
                }
            ]), t;
        }(o.default.Component);
        c.propTypes = {
            afterLoad: i.PropTypes.func,
            beforeLoad: i.PropTypes.func,
            useIntersectionObserver: i.PropTypes.bool,
            visibleByDefault: i.PropTypes.bool
        }, c.defaultProps = {
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            useIntersectionObserver: !0,
            visibleByDefault: !1
        }, t.default = c;
    },
    function(e, t, r) {
        'use strict';
        Object.defineProperty(t, '__esModule', {
            value: !0
        });
        var n = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
        }, o = function() {
            function e(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, 'value' in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            return function(t, r, n) {
                return r && e(t.prototype, r), n && e(t, n), t;
            };
        }(), i = u(r(0)), a = u(r(5)), s = r(1), l = u(r(2));
        function u(e) {
            return e && e.__esModule ? e : {
                default: e
            };
        }
        var c = function(e) {
            e.forEach(function(e) {
                e.isIntersecting && e.target.onVisible();
            });
        }, f = {}, p = function(e) {
            return f[e] = f[e] || new IntersectionObserver(c, {
                rootMargin: e + 'px'
            }), f[e];
        }, d = function(e) {
            function t(e) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
                }(this, t);
                var r = function(e, t) {
                    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return !t || 'object' != typeof t && 'function' != typeof t ? e : t;
                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                if (r.supportsObserver = !e.scrollPosition && e.useIntersectionObserver && (0, l.default)(), r.supportsObserver) {
                    var n = e.threshold;
                    r.observer = p(n);
                }
                return r;
            }
            return function(e, t) {
                if ('function' != typeof t && null !== t) throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }(t, e), o(t, [
                {
                    key: 'componentDidMount',
                    value: function() {
                        this.placeholder && this.observer && (this.placeholder.onVisible = this.props.onVisible, this.observer.observe(this.placeholder)), this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: 'componentWillUnmount',
                    value: function() {
                        this.observer && this.observer.unobserve(this.placeholder);
                    }
                },
                {
                    key: 'componentDidUpdate',
                    value: function() {
                        this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: 'getPlaceholderBoundingBox',
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props.scrollPosition, t = this.placeholder.getBoundingClientRect(), r = a.default.findDOMNode(this.placeholder).style, n = {
                            left: parseInt(r.getPropertyValue('margin-left'), 10) || 0,
                            top: parseInt(r.getPropertyValue('margin-top'), 10) || 0
                        };
                        return {
                            bottom: e.y + t.bottom + n.top,
                            left: e.x + t.left + n.left,
                            right: e.x + t.right + n.left,
                            top: e.y + t.top + n.top
                        };
                    }
                },
                {
                    key: 'isPlaceholderInViewport',
                    value: function() {
                        if ('undefined' == typeof window || !this.placeholder) return !1;
                        var e = this.props, t = e.scrollPosition, r = e.threshold, n = this.getPlaceholderBoundingBox(t), o = t.y + window.innerHeight, i = t.x, a = t.x + window.innerWidth, s = t.y;
                        return Boolean(s - r <= n.bottom && o + r >= n.top && i - r <= n.right && a + r >= n.left);
                    }
                },
                {
                    key: 'updateVisibility',
                    value: function() {
                        this.isPlaceholderInViewport() && this.props.onVisible();
                    }
                },
                {
                    key: 'render',
                    value: function() {
                        var e = this, t = this.props, r = t.className, o = t.height, a = t.placeholder, s = t.style, l = t.width;
                        if (a && 'function' != typeof a.type) return i.default.cloneElement(a, {
                            ref: function(t) {
                                return e.placeholder = t;
                            }
                        });
                        var u = n({
                            display: 'inline-block'
                        }, s);
                        return void 0 !== l && (u.width = l), void 0 !== o && (u.height = o), i.default.createElement('span', {
                            className: r,
                            ref: function(t) {
                                return e.placeholder = t;
                            },
                            style: u
                        }, a);
                    }
                }
            ]), t;
        }(i.default.Component);
        d.propTypes = {
            onVisible: s.PropTypes.func.isRequired,
            className: s.PropTypes.string,
            height: s.PropTypes.oneOfType([
                s.PropTypes.number,
                s.PropTypes.string
            ]),
            placeholder: s.PropTypes.element,
            threshold: s.PropTypes.number,
            useIntersectionObserver: s.PropTypes.bool,
            scrollPosition: s.PropTypes.shape({
                x: s.PropTypes.number.isRequired,
                y: s.PropTypes.number.isRequired
            }),
            width: s.PropTypes.oneOfType([
                s.PropTypes.number,
                s.PropTypes.string
            ])
        }, d.defaultProps = {
            className: '',
            placeholder: null,
            threshold: 100,
            useIntersectionObserver: !0
        }, t.default = d;
    },
    function(e, t) {
        e.exports = (parcelRequire("1u0KT"));
    },
    function(e, t, r) {
        'use strict';
        Object.defineProperty(t, '__esModule', {
            value: !0
        });
        var n = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
        }, o = function() {
            function e(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, 'value' in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            return function(t, r, n) {
                return r && e(t.prototype, r), n && e(t, n), t;
            };
        }(), i = p(r(0)), a = p(r(5)), s = r(1), l = p(r(13)), u = p(r(14)), c = p(r(2)), f = p(r(15));
        function p(e) {
            return e && e.__esModule ? e : {
                default: e
            };
        }
        function d(e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || 'object' != typeof t && 'function' != typeof t ? e : t;
        }
        var y = function() {
            return 'undefined' == typeof window ? 0 : window.scrollX || window.pageXOffset;
        }, h = function() {
            return 'undefined' == typeof window ? 0 : window.scrollY || window.pageYOffset;
        };
        t.default = function(e) {
            var t = function(t) {
                function r(e) {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
                    }(this, r);
                    var t = d(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, e));
                    if (t.useIntersectionObserver = e.useIntersectionObserver && (0, c.default)(), t.useIntersectionObserver) return d(t);
                    var n = t.onChangeScroll.bind(t);
                    return 'debounce' === e.delayMethod ? t.delayedScroll = (0, l.default)(n, e.delayTime) : 'throttle' === e.delayMethod && (t.delayedScroll = (0, u.default)(n, e.delayTime)), t.state = {
                        scrollPosition: {
                            x: y(),
                            y: h()
                        }
                    }, t.baseComponentRef = i.default.createRef(), t;
                }
                return function(e, t) {
                    if ('function' != typeof t && null !== t) throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
                }(r, t), o(r, [
                    {
                        key: 'componentDidMount',
                        value: function() {
                            this.addListeners();
                        }
                    },
                    {
                        key: 'componentWillUnmount',
                        value: function() {
                            this.removeListeners();
                        }
                    },
                    {
                        key: 'componentDidUpdate',
                        value: function() {
                            'undefined' == typeof window || this.useIntersectionObserver || (0, f.default)(a.default.findDOMNode(this.baseComponentRef.current)) !== this.scrollElement && (this.removeListeners(), this.addListeners());
                        }
                    },
                    {
                        key: 'addListeners',
                        value: function() {
                            'undefined' == typeof window || this.useIntersectionObserver || (this.scrollElement = (0, f.default)(a.default.findDOMNode(this.baseComponentRef.current)), this.scrollElement.addEventListener('scroll', this.delayedScroll, {
                                passive: !0
                            }), window.addEventListener('resize', this.delayedScroll, {
                                passive: !0
                            }), this.scrollElement !== window && window.addEventListener('scroll', this.delayedScroll, {
                                passive: !0
                            }));
                        }
                    },
                    {
                        key: 'removeListeners',
                        value: function() {
                            'undefined' == typeof window || this.useIntersectionObserver || (this.scrollElement.removeEventListener('scroll', this.delayedScroll), window.removeEventListener('resize', this.delayedScroll), this.scrollElement !== window && window.removeEventListener('scroll', this.delayedScroll));
                        }
                    },
                    {
                        key: 'onChangeScroll',
                        value: function() {
                            this.useIntersectionObserver || this.setState({
                                scrollPosition: {
                                    x: y(),
                                    y: h()
                                }
                            });
                        }
                    },
                    {
                        key: 'render',
                        value: function() {
                            var t = this.props, r = (t.delayMethod, t.delayTime, function(e, t) {
                                var r = {};
                                for(var n in e)t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
                                return r;
                            }(t, [
                                'delayMethod',
                                'delayTime'
                            ])), o = this.useIntersectionObserver ? null : this.state.scrollPosition;
                            return i.default.createElement(e, n({
                                ref: this.baseComponentRef,
                                scrollPosition: o
                            }, r));
                        }
                    }
                ]), r;
            }(i.default.Component);
            return t.propTypes = {
                delayMethod: s.PropTypes.oneOf([
                    'debounce',
                    'throttle'
                ]),
                delayTime: s.PropTypes.number,
                useIntersectionObserver: s.PropTypes.bool
            }, t.defaultProps = {
                delayMethod: 'throttle',
                delayTime: 300,
                useIntersectionObserver: !0
            }, t;
        };
    },
    function(e, t) {
        var r;
        r = function() {
            return this;
        }();
        try {
            r = r || new Function('return this')();
        } catch (e) {
            'object' == typeof window && (r = window);
        }
        e.exports = r;
    },
    function(e, t, r) {
        'use strict';
        Object.defineProperty(t, '__esModule', {
            value: !0
        }), t.trackWindowScroll = t.LazyLoadComponent = t.LazyLoadImage = void 0;
        var n = a(r(9)), o = a(r(3)), i = a(r(6));
        function a(e) {
            return e && e.__esModule ? e : {
                default: e
            };
        }
        t.LazyLoadImage = n.default, t.LazyLoadComponent = o.default, t.trackWindowScroll = i.default;
    },
    function(e, t, r) {
        'use strict';
        Object.defineProperty(t, '__esModule', {
            value: !0
        });
        var n = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
        }, o = function() {
            function e(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, 'value' in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            return function(t, r, n) {
                return r && e(t.prototype, r), n && e(t, n), t;
            };
        }(), i = l(r(0)), a = r(1), s = l(r(3));
        function l(e) {
            return e && e.__esModule ? e : {
                default: e
            };
        }
        var u = function(e) {
            function t(e) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
                }(this, t);
                var r = function(e, t) {
                    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return !t || 'object' != typeof t && 'function' != typeof t ? e : t;
                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                return r.state = {
                    loaded: !1
                }, r;
            }
            return function(e, t) {
                if ('function' != typeof t && null !== t) throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }(t, e), o(t, [
                {
                    key: 'onImageLoad',
                    value: function() {
                        var e = this;
                        return this.state.loaded ? null : function() {
                            e.props.afterLoad(), e.setState({
                                loaded: !0
                            });
                        };
                    }
                },
                {
                    key: 'getImg',
                    value: function() {
                        var e = this.props, t = (e.afterLoad, e.beforeLoad, e.delayMethod, e.delayTime, e.effect, e.placeholder, e.placeholderSrc, e.scrollPosition, e.threshold, e.useIntersectionObserver, e.visibleByDefault, e.wrapperClassName, e.wrapperProps, function(e, t) {
                            var r = {};
                            for(var n in e)t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
                            return r;
                        }(e, [
                            'afterLoad',
                            'beforeLoad',
                            'delayMethod',
                            'delayTime',
                            'effect',
                            'placeholder',
                            'placeholderSrc',
                            'scrollPosition',
                            'threshold',
                            'useIntersectionObserver',
                            'visibleByDefault',
                            'wrapperClassName',
                            'wrapperProps'
                        ]));
                        return i.default.createElement('img', n({
                            onLoad: this.onImageLoad()
                        }, t));
                    }
                },
                {
                    key: 'getLazyLoadImage',
                    value: function() {
                        var e = this.props, t = e.beforeLoad, r = e.className, n = e.delayMethod, o = e.delayTime, a = e.height, l = e.placeholder, u = e.scrollPosition, c = e.style, f = e.threshold, p = e.useIntersectionObserver, d = e.visibleByDefault, y = e.width;
                        return i.default.createElement(s.default, {
                            beforeLoad: t,
                            className: r,
                            delayMethod: n,
                            delayTime: o,
                            height: a,
                            placeholder: l,
                            scrollPosition: u,
                            style: c,
                            threshold: f,
                            useIntersectionObserver: p,
                            visibleByDefault: d,
                            width: y
                        }, this.getImg());
                    }
                },
                {
                    key: 'getWrappedLazyLoadImage',
                    value: function(e) {
                        var t = this.props, r = t.effect, o = t.height, a = t.placeholderSrc, s = t.width, l = t.wrapperClassName, u = t.wrapperProps, c = this.state.loaded, f = c ? ' lazy-load-image-loaded' : '';
                        return i.default.createElement('span', n({
                            className: l + ' lazy-load-image-background ' + r + f,
                            style: {
                                backgroundImage: c || !a ? '' : 'url(' + a + ')',
                                backgroundSize: c || !a ? '' : '100% 100%',
                                display: 'inline-block',
                                height: o,
                                width: s
                            }
                        }, u), e);
                    }
                },
                {
                    key: 'render',
                    value: function() {
                        var e = this.props, t = e.effect, r = e.placeholderSrc, n = e.visibleByDefault, o = e.wrapperClassName, i = e.wrapperProps, a = this.getLazyLoadImage();
                        return (t || r) && !n || o || i ? this.getWrappedLazyLoadImage(a) : a;
                    }
                }
            ]), t;
        }(i.default.Component);
        u.propTypes = {
            afterLoad: a.PropTypes.func,
            beforeLoad: a.PropTypes.func,
            delayMethod: a.PropTypes.string,
            delayTime: a.PropTypes.number,
            effect: a.PropTypes.string,
            placeholderSrc: a.PropTypes.string,
            threshold: a.PropTypes.number,
            useIntersectionObserver: a.PropTypes.bool,
            visibleByDefault: a.PropTypes.bool,
            wrapperClassName: a.PropTypes.string,
            wrapperProps: a.PropTypes.object
        }, u.defaultProps = {
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            delayMethod: 'throttle',
            delayTime: 300,
            effect: '',
            placeholderSrc: null,
            threshold: 100,
            useIntersectionObserver: !0,
            visibleByDefault: !1,
            wrapperClassName: ''
        }, t.default = u;
    },
    function(e, t, r) {
        'use strict';
        var n = r(11);
        function o() {}
        function i() {}
        i.resetWarningCache = o, e.exports = function() {
            function e(e, t, r, o, i, a) {
                if (a !== n) {
                    var s = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types');
                    throw s.name = 'Invariant Violation', s;
                }
            }
            function t() {
                return e;
            }
            e.isRequired = e;
            var r = {
                array: e,
                bool: e,
                func: e,
                number: e,
                object: e,
                string: e,
                symbol: e,
                any: e,
                arrayOf: t,
                element: e,
                elementType: e,
                instanceOf: t,
                node: e,
                objectOf: t,
                oneOf: t,
                oneOfType: t,
                shape: t,
                exact: t,
                checkPropTypes: i,
                resetWarningCache: o
            };
            return r.PropTypes = r, r;
        };
    },
    function(e, t, r) {
        'use strict';
        e.exports = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
    },
    function(e, t, r) {
        'use strict';
        Object.defineProperty(t, '__esModule', {
            value: !0
        });
        var n = function() {
            function e(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, 'value' in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            return function(t, r, n) {
                return r && e(t.prototype, r), n && e(t, n), t;
            };
        }(), o = s(r(0)), i = s(r(4)), a = s(r(6));
        function s(e) {
            return e && e.__esModule ? e : {
                default: e
            };
        }
        var l = function(e) {
            function t(e) {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
                }(this, t), function(e, t) {
                    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return !t || 'object' != typeof t && 'function' != typeof t ? e : t;
                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
            }
            return function(e, t) {
                if ('function' != typeof t && null !== t) throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }(t, e), n(t, [
                {
                    key: 'render',
                    value: function() {
                        return o.default.createElement(i.default, this.props);
                    }
                }
            ]), t;
        }(o.default.Component);
        t.default = (0, a.default)(l);
    },
    function(e, t, r) {
        (function(t) {
            var r = 'Expected a function', n = NaN, o = '[object Symbol]', i = /^\s+|\s+$/g, a = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, l = /^0o[0-7]+$/i, u = parseInt, c = 'object' == typeof t && t && t.Object === Object && t, f = 'object' == typeof self && self && self.Object === Object && self, p = c || f || Function('return this')(), d = Object.prototype.toString, y = Math.max, h = Math.min, b = function() {
                return p.Date.now();
            };
            function v(e) {
                var t = typeof e;
                return !!e && ('object' == t || 'function' == t);
            }
            function m(e) {
                if ('number' == typeof e) return e;
                if (function(e) {
                    return 'symbol' == typeof e || function(e) {
                        return !!e && 'object' == typeof e;
                    }(e) && d.call(e) == o;
                }(e)) return n;
                if (v(e)) {
                    var t = 'function' == typeof e.valueOf ? e.valueOf() : e;
                    e = v(t) ? t + '' : t;
                }
                if ('string' != typeof e) return 0 === e ? e : +e;
                e = e.replace(i, '');
                var r = s.test(e);
                return r || l.test(e) ? u(e.slice(2), r ? 2 : 8) : a.test(e) ? n : +e;
            }
            e.exports = function(e, t, n) {
                var o, i, a, s, l, u, c = 0, f = !1, p = !1, d = !0;
                if ('function' != typeof e) throw new TypeError(r);
                function w(t) {
                    var r = o, n = i;
                    return o = i = void 0, c = t, s = e.apply(n, r);
                }
                function O(e) {
                    var r = e - u;
                    return void 0 === u || r >= t || r < 0 || p && e - c >= a;
                }
                function g() {
                    var e = b();
                    if (O(e)) return P(e);
                    l = setTimeout(g, function(e) {
                        var r = t - (e - u);
                        return p ? h(r, a - (e - c)) : r;
                    }(e));
                }
                function P(e) {
                    return l = void 0, d && o ? w(e) : (o = i = void 0, s);
                }
                function T() {
                    var e = b(), r = O(e);
                    if (o = arguments, i = this, u = e, r) {
                        if (void 0 === l) return function(e) {
                            return c = e, l = setTimeout(g, t), f ? w(e) : s;
                        }(u);
                        if (p) return l = setTimeout(g, t), w(u);
                    }
                    return void 0 === l && (l = setTimeout(g, t)), s;
                }
                return t = m(t) || 0, v(n) && (f = !!n.leading, a = (p = 'maxWait' in n) ? y(m(n.maxWait) || 0, t) : a, d = 'trailing' in n ? !!n.trailing : d), T.cancel = function() {
                    void 0 !== l && clearTimeout(l), c = 0, o = u = i = l = void 0;
                }, T.flush = function() {
                    return void 0 === l ? s : P(b());
                }, T;
            };
        }).call(this, r(7));
    },
    function(e, t, r) {
        (function(t) {
            var r = 'Expected a function', n = NaN, o = '[object Symbol]', i = /^\s+|\s+$/g, a = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, l = /^0o[0-7]+$/i, u = parseInt, c = 'object' == typeof t && t && t.Object === Object && t, f = 'object' == typeof self && self && self.Object === Object && self, p = c || f || Function('return this')(), d = Object.prototype.toString, y = Math.max, h = Math.min, b = function() {
                return p.Date.now();
            };
            function v(e, t, n) {
                var o, i, a, s, l, u, c = 0, f = !1, p = !1, d = !0;
                if ('function' != typeof e) throw new TypeError(r);
                function v(t) {
                    var r = o, n = i;
                    return o = i = void 0, c = t, s = e.apply(n, r);
                }
                function O(e) {
                    var r = e - u;
                    return void 0 === u || r >= t || r < 0 || p && e - c >= a;
                }
                function g() {
                    var e = b();
                    if (O(e)) return P(e);
                    l = setTimeout(g, function(e) {
                        var r = t - (e - u);
                        return p ? h(r, a - (e - c)) : r;
                    }(e));
                }
                function P(e) {
                    return l = void 0, d && o ? v(e) : (o = i = void 0, s);
                }
                function T() {
                    var e = b(), r = O(e);
                    if (o = arguments, i = this, u = e, r) {
                        if (void 0 === l) return function(e) {
                            return c = e, l = setTimeout(g, t), f ? v(e) : s;
                        }(u);
                        if (p) return l = setTimeout(g, t), v(u);
                    }
                    return void 0 === l && (l = setTimeout(g, t)), s;
                }
                return t = w(t) || 0, m(n) && (f = !!n.leading, a = (p = 'maxWait' in n) ? y(w(n.maxWait) || 0, t) : a, d = 'trailing' in n ? !!n.trailing : d), T.cancel = function() {
                    void 0 !== l && clearTimeout(l), c = 0, o = u = i = l = void 0;
                }, T.flush = function() {
                    return void 0 === l ? s : P(b());
                }, T;
            }
            function m(e) {
                var t = typeof e;
                return !!e && ('object' == t || 'function' == t);
            }
            function w(e) {
                if ('number' == typeof e) return e;
                if (function(e) {
                    return 'symbol' == typeof e || function(e) {
                        return !!e && 'object' == typeof e;
                    }(e) && d.call(e) == o;
                }(e)) return n;
                if (m(e)) {
                    var t = 'function' == typeof e.valueOf ? e.valueOf() : e;
                    e = m(t) ? t + '' : t;
                }
                if ('string' != typeof e) return 0 === e ? e : +e;
                e = e.replace(i, '');
                var r = s.test(e);
                return r || l.test(e) ? u(e.slice(2), r ? 2 : 8) : a.test(e) ? n : +e;
            }
            e.exports = function(e, t, n) {
                var o = !0, i = !0;
                if ('function' != typeof e) throw new TypeError(r);
                return m(n) && (o = 'leading' in n ? !!n.leading : o, i = 'trailing' in n ? !!n.trailing : i), v(e, t, {
                    leading: o,
                    maxWait: t,
                    trailing: i
                });
            };
        }).call(this, r(7));
    },
    function(e, t, r) {
        'use strict';
        Object.defineProperty(t, '__esModule', {
            value: !0
        });
        var n = function(e, t) {
            return 'undefined' == typeof getComputedStyle ? e.style[t] : getComputedStyle(e, null).getPropertyValue(t);
        }, o = function(e) {
            return n(e, 'overflow') + n(e, 'overflow-y') + n(e, 'overflow-x');
        };
        t.default = function(e) {
            if (!(e instanceof HTMLElement)) return window;
            for(var t = e; t && t !== document.body && t !== document.documentElement && t.parentNode;){
                if (/(scroll|auto)/.test(o(t))) return t;
                t = t.parentNode;
            }
            return window;
        };
    }
]);



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $d87c4557919c9bca$export$bae1c404c9a98ef6 = (limit)=>{
    const [expanded, setExpanded] = $acw62.useState(false);
    const toggle = ()=>setExpanded((prev)=>!prev);
    const isVisible = (index)=>limit ? expanded || index < limit : true;
    const showToggle = Boolean(limit);
    return {
        expanded: expanded,
        toggle: toggle,
        isVisible: isVisible,
        showToggle: showToggle
    };
};


const $a065582236961aef$var$Listup = ({ items: items, title_en: title_en, title_ja: title_ja, item_nums: item_nums })=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    const { expanded: expanded, toggle: toggle, isVisible: isVisible, showToggle: showToggle } = (0, $d87c4557919c9bca$export$bae1c404c9a98ef6)(item_nums);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: "col-md-12 mb-2"
    }, /*#__PURE__*/ $acw62.createElement("p", {
        className: "sub-title"
    }, langEn ? title_en : title_ja), /*#__PURE__*/ $acw62.createElement("ul", {
        className: "mb-0"
    }, items.filter((item, i)=>isVisible(i)).map((item, i)=>/*#__PURE__*/ $acw62.createElement("li", {
            key: i
        }, item.month ? /*#__PURE__*/ $acw62.createElement("span", {
            className: "date"
        }, " ", (0, $3cdc8a61f42a3ec8$export$42b8cd85fd1c8271)(item.month, item.year, langEn), ":") : "", (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.name, langEn), item.url ? /*#__PURE__*/ $acw62.createElement("a", {
            href: (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.url, langEn),
            className: "ml-2 icon-link"
        }) : "")), showToggle && !expanded ? /*#__PURE__*/ $acw62.createElement("a", {
        href: "",
        className: "",
        onClick: (e)=>{
            e.preventDefault();
            toggle();
        }
    }, "more \xbb") : "", showToggle && expanded ? /*#__PURE__*/ $acw62.createElement("a", {
        href: "",
        onClick: (e)=>{
            e.preventDefault();
            toggle();
        }
    }, "\xab close") : ""));
};
var $a065582236961aef$export$2e2bcd8739ae039 = $a065582236961aef$var$Listup;




var $d104cb01362b2ae4$exports = {};
var $269404d20e0ad54d$exports = {};
$269404d20e0ad54d$exports = import.meta.resolve("liLHE");


var $92c98c0e3fc60f23$exports = {};
$92c98c0e3fc60f23$exports = import.meta.resolve("0AaaF");


var $0f18a83ac24a4a45$exports = {};
$0f18a83ac24a4a45$exports = import.meta.resolve("5NHTm");


var $54fa9759eefe72a0$exports = {};
$54fa9759eefe72a0$exports = import.meta.resolve("1WXxF");


var $97178d92e0cc8065$exports = {};
$97178d92e0cc8065$exports = import.meta.resolve("1RJxp");


var $9adbe6319fff61d4$exports = {};
$9adbe6319fff61d4$exports = import.meta.resolve("jZ7Dr");


var $d4957d772180ceba$exports = {};
$d4957d772180ceba$exports = import.meta.resolve("c651b");


var $99606b0161271e9a$exports = {};
$99606b0161271e9a$exports = import.meta.resolve("fE0Vi");


var $4ab149ea3776a563$exports = {};
$4ab149ea3776a563$exports = import.meta.resolve("iCZyd");


var $affff524a6796547$exports = {};
$affff524a6796547$exports = import.meta.resolve("3bXBg");


var $d1b899f78a6c33de$exports = {};
$d1b899f78a6c33de$exports = import.meta.resolve("l6rjW");


var $fad1ae2f929098a7$exports = {};
$fad1ae2f929098a7$exports = import.meta.resolve("abhBz");


var $300fa52ad299c8b3$exports = {};
$300fa52ad299c8b3$exports = import.meta.resolve("fBG0p");


var $03ee83c8cf7556cc$exports = {};
$03ee83c8cf7556cc$exports = import.meta.resolve("ijHRr");


var $4bdab4c34efbadf9$exports = {};
$4bdab4c34efbadf9$exports = import.meta.resolve("8l5tp");


var $d112ff1f860e3051$exports = {};
$d112ff1f860e3051$exports = import.meta.resolve("03ptp");


var $fdaa4bc79c42aa1a$exports = {};
$fdaa4bc79c42aa1a$exports = import.meta.resolve("2PRDS");


var $6bd1bf64ed5180a4$exports = {};
$6bd1bf64ed5180a4$exports = import.meta.resolve("75Gko");


var $03f45c8a7753efd9$exports = {};
$03f45c8a7753efd9$exports = import.meta.resolve("1XuV1");


var $2020c32526df55d0$exports = {};
$2020c32526df55d0$exports = import.meta.resolve("dOnIL");


var $088d9b1c71ef431d$exports = {};
$088d9b1c71ef431d$exports = import.meta.resolve("ao8kN");


var $f6a58adeb80bbf1c$exports = {};
$f6a58adeb80bbf1c$exports = import.meta.resolve("2hFYb");


var $911a5e07f4ed2e16$exports = {};
$911a5e07f4ed2e16$exports = import.meta.resolve("4t3Ev");


var $e55ba6006de7d316$exports = {};
$e55ba6006de7d316$exports = import.meta.resolve("aWB9s");


var $6811a694f3b68406$exports = {};
$6811a694f3b68406$exports = import.meta.resolve("8Manb");


var $75a6edb691cd84ed$exports = {};
$75a6edb691cd84ed$exports = import.meta.resolve("irxNS");


var $03a0ab8c57a458bf$exports = {};
$03a0ab8c57a458bf$exports = import.meta.resolve("aNIEC");


var $44c8a8f4a88667fc$exports = {};
$44c8a8f4a88667fc$exports = import.meta.resolve("6xdbe");


var $15996ee08d12e6bd$exports = {};
$15996ee08d12e6bd$exports = import.meta.resolve("fSQzG");


var $6d3c4a0cf39d0fdf$exports = {};
$6d3c4a0cf39d0fdf$exports = import.meta.resolve("9zALN");


var $87a79cf2de90f498$exports = {};
$87a79cf2de90f498$exports = import.meta.resolve("9W1ua");


var $740f873de2483409$exports = {};
$740f873de2483409$exports = import.meta.resolve("9XpfZ");


var $176d11aceccf8c81$exports = {};
$176d11aceccf8c81$exports = import.meta.resolve("gavNm");


var $773ebf4f4679427f$exports = {};
$773ebf4f4679427f$exports = import.meta.resolve("bzUEh");


var $34a9e376ee102d40$exports = {};
$34a9e376ee102d40$exports = import.meta.resolve("5RHJ7");


var $8d7695977b6fd540$exports = {};
$8d7695977b6fd540$exports = import.meta.resolve("2cFCX");


var $0777ec888f3c9bf4$exports = {};
$0777ec888f3c9bf4$exports = import.meta.resolve("cbQfI");


var $7158f42ed17b8c7a$exports = {};
$7158f42ed17b8c7a$exports = import.meta.resolve("5W39m");


var $b7ffe125d782adb8$exports = {};
$b7ffe125d782adb8$exports = import.meta.resolve("7YhPy");


var $1db00ce67c619d58$exports = {};
$1db00ce67c619d58$exports = import.meta.resolve("l1jZt");


var $8e31b101ec49a6ca$exports = {};
$8e31b101ec49a6ca$exports = import.meta.resolve("b2bvM");


$d104cb01362b2ae4$exports = {
    "100mouse": $269404d20e0ad54d$exports,
    "OHI": $92c98c0e3fc60f23$exports,
    "afada": $0f18a83ac24a4a45$exports,
    "agile-mapf": $54fa9759eefe72a0$exports,
    "amoeba": $97178d92e0cc8065$exports,
    "awesome-cs-ja-phd-life": $9adbe6319fff61d4$exports,
    "box-pushing": $d4957d772180ceba$exports,
    "champlify": $99606b0161271e9a$exports,
    "cmpp": $4ab149ea3776a563$exports,
    "conveyor": $affff524a6796547$exports,
    "coordinated_path": $d1b899f78a6c33de$exports,
    "ctrm": $fad1ae2f929098a7$exports,
    "cumapf": $300fa52ad299c8b3$exports,
    "d4orm": $03ee83c8cf7556cc$exports,
    "db-lacam": $4bdab4c34efbadf9$exports,
    "denoising": $d112ff1f860e3051$exports,
    "dense-pibt": $fdaa4bc79c42aa1a$exports,
    "gambit": $6bd1bf64ed5180a4$exports,
    "holochat": $03f45c8a7753efd9$exports,
    "iterative-refinement": $2020c32526df55d0$exports,
    "lacam": $088d9b1c71ef431d$exports,
    "lacam3": $f6a58adeb80bbf1c$exports,
    "lacas": $911a5e07f4ed2e16$exports,
    "lf": $e55ba6006de7d316$exports,
    "lllg": $6811a694f3b68406$exports,
    "mappcf": $75a6edb691cd84ed$exports,
    "mawpf": $03a0ab8c57a458bf$exports,
    "mrmp": $44c8a8f4a88667fc$exports,
    "otimapp": $15996ee08d12e6bd$exports,
    "pathfinding-10k": $6d3c4a0cf39d0fdf$exports,
    "pibt": $87a79cf2de90f498$exports,
    "pibt2": $740f873de2483409$exports,
    "recode": $176d11aceccf8c81$exports,
    "sanity": $773ebf4f4679427f$exports,
    "sharing-vision": $34a9e376ee102d40$exports,
    "sokoban": $8d7695977b6fd540$exports,
    "time-independent-planning": $0777ec888f3c9bf4$exports,
    "tswap2": $7158f42ed17b8c7a$exports,
    "unlabeled": $b7ffe125d782adb8$exports,
    "walky": $1db00ce67c619d58$exports,
    "winpibt": $8e31b101ec49a6ca$exports
};





const $e9c8f6c781bc0d61$var$News = ()=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    const imageMap = (0, $6a9bfe7e01a5c3e7$export$e6a7fad94b08a6ce)((0, $6a9bfe7e01a5c3e7$export$552dd721d9ff2d3f)((0, (/*@__PURE__*/$parcel$interopDefault($02cff0d0be730940$exports)))), (0, $6a9bfe7e01a5c3e7$export$552dd721d9ff2d3f)((0, (/*@__PURE__*/$parcel$interopDefault($d104cb01362b2ae4$exports)))));
    const videoMap = (0, $6a9bfe7e01a5c3e7$export$552dd721d9ff2d3f)((0, (/*@__PURE__*/$parcel$interopDefault($69dcad05a0bc697a$exports))));
    const getImageUrl = (imageKey)=>imageKey?.startsWith("http") ? imageKey : (0, $6a9bfe7e01a5c3e7$export$c8466dd3c8c19636)(imageMap, imageKey);
    const renderImage = (imageKey, alt)=>{
        const imageUrl = getImageUrl(imageKey);
        return imageUrl ? /*#__PURE__*/ $acw62.createElement((0, $fea50fe678f1d4ed$exports.LazyLoadImage), {
            src: imageUrl,
            alt: alt ?? "",
            effect: "opacity",
            className: "bd-placeholder-img img-fluid w-100",
            style: {
                aspectRatio: "16 / 9",
                objectFit: "cover"
            }
        }) : "";
    };
    const renderVideo = (videoKey)=>{
        const videoUrl = (0, $6a9bfe7e01a5c3e7$export$c8466dd3c8c19636)(videoMap, videoKey);
        return videoUrl ? /*#__PURE__*/ $acw62.createElement("video", {
            src: videoUrl,
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true,
            className: "bd-placeholder-img img-fluid w-100",
            style: {
                aspectRatio: "16 / 9",
                objectFit: "cover"
            }
        }) : "";
    };
    const renderHighlightCards = (items)=>items.map((item, i)=>/*#__PURE__*/ $acw62.createElement("div", {
                className: "card mb-2 paper",
                key: i
            }, item.bgImage ? /*#__PURE__*/ $acw62.createElement("div", {
                className: "card-body pt-2 pb-1",
                style: {
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.42), rgba(0, 0, 0, 0.42)), url(${getImageUrl(item.bgImage)})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "0.25rem",
                    minHeight: "280px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                    color: "#fff"
                }
            }, /*#__PURE__*/ $acw62.createElement("p", {
                className: "card-title mb-1 h6"
            }, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.title, langEn)), /*#__PURE__*/ $acw62.createElement("p", {
                className: "card-text mb-1 small"
            }, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.description, langEn)), /*#__PURE__*/ $acw62.createElement("p", {
                className: "card-text mb-1"
            }, item.projectPage ? /*#__PURE__*/ $acw62.createElement("a", {
                className: "academic-icon fas fa-home",
                "data-toggle": "tooltip",
                "data-placement": "top",
                title: "project page",
                href: item.projectPage,
                style: {
                    color: "#fff"
                }
            }) : "", item.paperUrl ? /*#__PURE__*/ $acw62.createElement("a", {
                className: "academic-icon fas fa-sticky-note",
                "data-toggle": "tooltip",
                "data-placement": "top",
                title: "paper",
                href: item.paperUrl,
                style: {
                    color: "#fff"
                }
            }) : "")) : /*#__PURE__*/ $acw62.createElement("div", {
                className: "row no-gutters"
            }, /*#__PURE__*/ $acw62.createElement("div", {
                className: "col-md-3"
            }, item.video ? renderVideo(item.video) : renderImage(item.img, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.title, langEn))), /*#__PURE__*/ $acw62.createElement("div", {
                className: "col-md-9"
            }, /*#__PURE__*/ $acw62.createElement("div", {
                className: "card-body pt-2 pb-1"
            }, /*#__PURE__*/ $acw62.createElement("p", {
                className: "card-title mb-1 h6"
            }, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.title, langEn)), /*#__PURE__*/ $acw62.createElement("p", {
                className: "card-text mb-1 small"
            }, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.description, langEn)), /*#__PURE__*/ $acw62.createElement("p", {
                className: "card-text mb-1"
            }, item.projectPage ? /*#__PURE__*/ $acw62.createElement("a", {
                className: "academic-icon fas fa-home",
                "data-toggle": "tooltip",
                "data-placement": "top",
                title: "project page",
                href: item.projectPage
            }) : "", item.paperUrl ? /*#__PURE__*/ $acw62.createElement("a", {
                className: "academic-icon fas fa-sticky-note",
                "data-toggle": "tooltip",
                "data-placement": "top",
                title: "paper",
                href: item.paperUrl
            }) : "", item.youtube ? /*#__PURE__*/ $acw62.createElement("a", {
                className: "academic-icon fab fa-youtube",
                "data-toggle": "tooltip",
                "data-placement": "top",
                title: "YouTube",
                href: item.youtube
            }) : "", item.speakerdeck ? /*#__PURE__*/ $acw62.createElement("a", {
                className: "academic-icon fab fa-speaker-deck",
                "data-toggle": "tooltip",
                "data-placement": "top",
                title: "slide",
                href: item.speakerdeck
            }) : "", item.recording ? /*#__PURE__*/ $acw62.createElement("a", {
                className: "academic-icon fas fa-video",
                "data-toggle": "tooltip",
                "data-placement": "top",
                title: "recording",
                href: item.recording
            }) : ""))))));
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: "news",
        className: "container justify-content-center"
    }, /*#__PURE__*/ $acw62.createElement("p", {
        className: "title"
    }, langEn ? "News" : "\u30CB\u30E5\u30FC\u30B9"), /*#__PURE__*/ $acw62.createElement("div", {
        className: "row text-left"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "col-md-12 mb-2 mt-2"
    }, /*#__PURE__*/ $acw62.createElement("p", {
        className: "sub-title"
    }, langEn ? "Highlights" : "\u30CF\u30A4\u30E9\u30A4\u30C8"), renderHighlightCards((0, $89618bfaa27a1d5d$export$1eef222eb1d1cc64).highlights), (0, $89618bfaa27a1d5d$export$1eef222eb1d1cc64).introTalks && (0, $89618bfaa27a1d5d$export$1eef222eb1d1cc64).introTalks.length > 0 ? /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("p", {
        className: "sub-title mt-3"
    }, langEn ? "Featured Talks" : "Featured Talks"), renderHighlightCards((0, $89618bfaa27a1d5d$export$1eef222eb1d1cc64).introTalks)) : ""), (0, $89618bfaa27a1d5d$export$1eef222eb1d1cc64).recruit && (0, $89618bfaa27a1d5d$export$1eef222eb1d1cc64).recruit.length > 0 ? /*#__PURE__*/ $acw62.createElement((0, $a065582236961aef$export$2e2bcd8739ae039), {
        items: (0, $89618bfaa27a1d5d$export$1eef222eb1d1cc64).recruit,
        title_en: "Recruitment, Advertisement",
        title_ja: "\u52DF\u96C6\u30FB\u5BA3\u4F1D"
    }) : "", (0, $89618bfaa27a1d5d$export$1eef222eb1d1cc64).future && (0, $89618bfaa27a1d5d$export$1eef222eb1d1cc64).future.length > 0 ? /*#__PURE__*/ $acw62.createElement((0, $a065582236961aef$export$2e2bcd8739ae039), {
        items: (0, $89618bfaa27a1d5d$export$1eef222eb1d1cc64).future,
        title_en: "Upcoming Events",
        title_ja: "\u4ECA\u5F8C\u306E\u30A4\u30D9\u30F3\u30C8"
    }) : "", /*#__PURE__*/ $acw62.createElement((0, $a065582236961aef$export$2e2bcd8739ae039), {
        items: (0, $89618bfaa27a1d5d$export$1eef222eb1d1cc64).activities,
        item_nums: 5,
        title_en: "Research Activities",
        title_ja: "\u7814\u7A76\u6D3B\u52D5"
    })));
};
var $e9c8f6c781bc0d61$export$2e2bcd8739ae039 = $e9c8f6c781bc0d61$var$News;



var $acw62 = parcelRequire("acw62");



const $06c35a9ee357c23f$var$Education = ()=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: "education",
        className: "container justify-content-center mb-4"
    }, /*#__PURE__*/ $acw62.createElement("p", {
        className: "title"
    }, langEn ? "Education" : "\u5B66\u6B74"), /*#__PURE__*/ $acw62.createElement("div", {
        className: "row"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "col-md-12 mb-2"
    }, /*#__PURE__*/ $acw62.createElement("ul", {
        className: "mb-0"
    }, (0, $89618bfaa27a1d5d$export$6e4408f1372a0887).map((item, i)=>/*#__PURE__*/ $acw62.createElement("li", {
            key: i
        }, /*#__PURE__*/ $acw62.createElement("span", {
            className: "degree"
        }, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.degree, langEn)), ":", /*#__PURE__*/ $acw62.createElement("span", {
            className: "ml-1"
        }, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.affiliation, langEn)), /*#__PURE__*/ $acw62.createElement("span", {
            className: "ml-1"
        }, "(", (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.term, langEn), ")")))))));
};
var $06c35a9ee357c23f$export$2e2bcd8739ae039 = $06c35a9ee357c23f$var$Education;



var $acw62 = parcelRequire("acw62");



const $c93a2b46b62c23c7$var$Career = ()=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: "career",
        className: "container justify-content-center mb-2"
    }, /*#__PURE__*/ $acw62.createElement("p", {
        className: "title"
    }, langEn ? "Career" : "\u7D4C\u6B74"), /*#__PURE__*/ $acw62.createElement("div", {
        className: "row"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "col-md-12 mb-2"
    }, /*#__PURE__*/ $acw62.createElement("ul", {
        className: "mb-0"
    }, (0, $89618bfaa27a1d5d$export$62efb6f08db5a542).map((item, i)=>/*#__PURE__*/ $acw62.createElement("li", {
            key: i,
            className: "mb-1"
        }, /*#__PURE__*/ $acw62.createElement("span", {
            className: "job"
        }, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.affiliation, langEn)), ":", /*#__PURE__*/ $acw62.createElement("span", {
            className: "ml-1"
        }, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.role, langEn)), /*#__PURE__*/ $acw62.createElement("span", {
            className: "ml-1"
        }, "(", (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.term, langEn), ")"), /*#__PURE__*/ $acw62.createElement("a", {
            href: (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.link, langEn),
            className: "ml-2 icon-link"
        }), /*#__PURE__*/ $acw62.createElement("br", null), /*#__PURE__*/ $acw62.createElement("span", null, /*#__PURE__*/ $acw62.createElement("small", null, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.topics, langEn))), item.others ? /*#__PURE__*/ $acw62.createElement("span", null, /*#__PURE__*/ $acw62.createElement("small", null, ", ", (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.others, langEn))) : ""))))));
};
var $c93a2b46b62c23c7$export$2e2bcd8739ae039 = $c93a2b46b62c23c7$var$Career;



var $acw62 = parcelRequire("acw62");






const $22964412bf4b74bb$var$Research = ()=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    const videoMap = (0, $6a9bfe7e01a5c3e7$export$552dd721d9ff2d3f)((0, (/*@__PURE__*/$parcel$interopDefault($69dcad05a0bc697a$exports))));
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: "research",
        className: "container justify-content-center mb-4"
    }, /*#__PURE__*/ $acw62.createElement("p", {
        className: "title"
    }, langEn ? "Research Questions" : "\u30EA\u30B5\u30FC\u30C1\u30FB\u30AF\u30A8\u30B9\u30C1\u30E7\u30F3"), /*#__PURE__*/ $acw62.createElement("div", {
        className: "row text-left"
    }, (0, $89618bfaa27a1d5d$export$c4a8527386f7d00f).map((study, i)=>/*#__PURE__*/ $acw62.createElement("div", {
            key: i,
            className: "col-md-12 panel-group"
        }, /*#__PURE__*/ $acw62.createElement("p", {
            className: "sub-title panel-heading"
        }, study.past ? /*#__PURE__*/ $acw62.createElement("a", {
            "data-toggle": "collapse",
            href: "#study-" + i
        }, "\xbb", " ", langEn ? (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(study.title, true) + " (past)" : (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(study.title, false) + " (\u904E\u53BB)") : langEn ? (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(study.title, true) : (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(study.title, false)), /*#__PURE__*/ $acw62.createElement("div", {
            className: "panel-collapse" + (study.past ? " collapse" : ""),
            id: "study-" + i
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: "pl-10 pr-10 mb-3"
        }, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(study.description, langEn)), /*#__PURE__*/ $acw62.createElement("div", {
            className: "row"
        }, (study.gif ?? []).map((item, j)=>/*#__PURE__*/ $acw62.createElement("div", {
                className: "col-md-4 mb-1 text-center",
                key: j
            }, (()=>{
                const videoUrl = (0, $6a9bfe7e01a5c3e7$export$c8466dd3c8c19636)(videoMap, item.src);
                return videoUrl ? /*#__PURE__*/ $acw62.createElement("video", {
                    src: videoUrl,
                    autoPlay: true,
                    loop: true,
                    muted: true
                }) : "";
            })(), /*#__PURE__*/ $acw62.createElement("p", {
                className: "text-center"
            }, /*#__PURE__*/ $acw62.createElement("small", null, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.title, langEn)))))))))));
};
var $22964412bf4b74bb$export$2e2bcd8739ae039 = $22964412bf4b74bb$var$Research;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $d301d12ebf50a072$exports = {};
var $3689c31c8521190f$exports = {};
$3689c31c8521190f$exports = import.meta.resolve("ioxF1");


var $3ad4a19e0653eb17$exports = {};
$3ad4a19e0653eb17$exports = import.meta.resolve("kJuFz");


var $5fa745b6b2ef2bd9$exports = {};
$5fa745b6b2ef2bd9$exports = import.meta.resolve("2cC4I");


var $214d8a0162dbdd58$exports = {};
$214d8a0162dbdd58$exports = import.meta.resolve("2vIKg");


var $02fa95a2af12b52f$exports = {};
$02fa95a2af12b52f$exports = import.meta.resolve("3vdLg");


var $6603cde3cb884f48$exports = {};
$6603cde3cb884f48$exports = import.meta.resolve("dFafo");


var $8dcb014fe634a9c4$exports = {};
$8dcb014fe634a9c4$exports = import.meta.resolve("9y9j7");


var $addad7e1c35849d5$exports = {};
$addad7e1c35849d5$exports = import.meta.resolve("cV9tx");


$d301d12ebf50a072$exports = {
    "hmagat": $3689c31c8521190f$exports,
    "lacam2": $3ad4a19e0653eb17$exports,
    "lagat": $5fa745b6b2ef2bd9$exports,
    "lg": $214d8a0162dbdd58$exports,
    "mapf-ml-review": $02fa95a2af12b52f$exports,
    "moe": $6603cde3cb884f48$exports,
    "otimapp2": $8dcb014fe634a9c4$exports,
    "phd": $addad7e1c35849d5$exports
};








const $8ae5ba1dd1f7f89a$var$images = (0, $6a9bfe7e01a5c3e7$export$e6a7fad94b08a6ce)((0, $6a9bfe7e01a5c3e7$export$552dd721d9ff2d3f)((0, (/*@__PURE__*/$parcel$interopDefault($d104cb01362b2ae4$exports)))), (0, $6a9bfe7e01a5c3e7$export$552dd721d9ff2d3f)((0, (/*@__PURE__*/$parcel$interopDefault($d301d12ebf50a072$exports)))), (0, $6a9bfe7e01a5c3e7$export$552dd721d9ff2d3f)((0, (/*@__PURE__*/$parcel$interopDefault($02cff0d0be730940$exports)))));
const $8ae5ba1dd1f7f89a$var$copyText = async (e, text)=>{
    if (navigator.clipboard && window.isSecureContext) try {
        await navigator.clipboard.writeText(text);
        return;
    } catch  {
    // Fall back to execCommand-based copy for older browsers/non-secure contexts.
    }
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
};
const $8ae5ba1dd1f7f89a$var$canGenerateBibtex = (item)=>Boolean(typeof item.bibtex === "string" && item.bibtex.trim() || item.title || item.authors || item.year);
const $8ae5ba1dd1f7f89a$var$Papers = ({ items: items, title_en: title_en, title_ja: title_ja, show_num: show_num, comment: comment })=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    const [usebib, setUsebib] = $acw62.useState(false);
    const renderImage = (imageKey)=>{
        const imageUrl = (0, $6a9bfe7e01a5c3e7$export$c8466dd3c8c19636)($8ae5ba1dd1f7f89a$var$images, imageKey);
        return imageUrl ? /*#__PURE__*/ $acw62.createElement((0, $fea50fe678f1d4ed$exports.LazyLoadImage), {
            className: "bd-placeholder-img lazyload",
            width: "100%",
            effect: "opacity",
            src: imageUrl
        }) : "";
    };
    const abbrCount = {};
    const excludeList = new Set((0, $89618bfaa27a1d5d$export$8102da2f15f4fe90).excludeList ?? []);
    const journalList = new Set(items.filter((entry)=>entry.kind === "journal").map((entry)=>entry.abbr ? entry.abbr : entry.book ? (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(entry.book, langEn) : "").filter(Boolean).map((name)=>name.replace(/-/g, "--")));
    for (const entry of items)if (!excludeList.has(entry.abbr)) {
        if (entry.abbr) {
            const abbrKey = entry.abbr.replace(/-/g, "--");
            abbrCount[abbrKey] = (abbrCount[abbrKey] || 0) + 1;
        } else if (entry.book) {
            const bookName = (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(entry.book, langEn);
            if (!bookName) continue;
            if ([
                "arXiv",
                "Technical",
                "Frontiers",
                "Ph.D.",
                "Spring"
            ].some((key)=>bookName.includes(key))) continue;
            const abbrKey = bookName.replace(/-/g, "--");
            abbrCount[abbrKey] = (abbrCount[abbrKey] || 0) + 1;
        }
    }
    const sortedAbbr = Object.entries(abbrCount).sort((a, b)=>{
        if (b[1] == a[1]) return a[0] < b[0] ? -1 : 1;
        return b[1] - a[1];
    });
    const getSubtitle = (item)=>{
        if (item.subtitle) return (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.subtitle, langEn);
        if (item.kind === "book" || item.kind === "dissertation") return item.book ? (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.book, langEn) : "";
        return "";
    };
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: "w-100"
    }, items.length == 0 ? "" : /*#__PURE__*/ $acw62.createElement("div", {
        className: "col-md-12 mb-4"
    }, /*#__PURE__*/ $acw62.createElement("p", {
        className: "sub-title mb-2"
    }, langEn ? title_en : title_ja), sortedAbbr.length > 0 ? /*#__PURE__*/ $acw62.createElement("div", {
        className: "mt-2 mb-2"
    }, sortedAbbr.map((ele, k)=>{
        const badgeColor = journalList.has(ele[0]) ? "green" : "blue";
        const badgeUrl = "https://img.shields.io/badge/" + ele[0] + "-" + ele[1] + "-" + badgeColor;
        return /*#__PURE__*/ $acw62.createElement("img", {
            key: k,
            src: badgeUrl,
            className: "mr-1 mb-1"
        });
    })) : "", comment ? /*#__PURE__*/ $acw62.createElement("p", null, /*#__PURE__*/ $acw62.createElement("small", null, /*#__PURE__*/ $acw62.createElement("a", {
        href: "",
        className: "mr-2",
        onClick: (e)=>{
            e.preventDefault();
            setUsebib(!usebib);
        }
    }, "switch name style:", usebib ? " [First Last]" : " [Last, F]"), /*#__PURE__*/ $acw62.createElement("span", {
        className: "mr-2"
    }, "|"), comment)) : "", items.map((item, i)=>{
        const subtitle = getSubtitle(item);
        const venue = (0, $3cdc8a61f42a3ec8$export$4fc1b509915a0374)(item, langEn);
        const hideVenue = Boolean(subtitle && (item.kind === "book" || item.kind === "dissertation"));
        const metaPrefix = !hideVenue && venue;
        return /*#__PURE__*/ $acw62.createElement("div", {
            className: "card mb-2 paper " + item.kind,
            key: i
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: "row no-gutters"
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: "col-md-3"
        }, renderImage(item.image)), /*#__PURE__*/ $acw62.createElement("div", {
            className: "col-md-9"
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: "card-body pt-2 pb-1"
        }, /*#__PURE__*/ $acw62.createElement("p", {
            className: "card-title mb-0 h6"
        }, show_num ? items.length - i + ". " : "", (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.title, langEn)), subtitle ? /*#__PURE__*/ $acw62.createElement("p", {
            className: "card-text mb-0 small"
        }, subtitle) : "", /*#__PURE__*/ $acw62.createElement("p", {
            className: "card-text mb-0 small"
        }, (0, $3cdc8a61f42a3ec8$export$90af2d5417783d04)((0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.authors, langEn), usebib)), /*#__PURE__*/ $acw62.createElement("p", {
            className: "card-text mb-0 small"
        }, metaPrefix ? /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, metaPrefix, item.abbr ? /*#__PURE__*/ $acw62.createElement("span", {
            className: "font-weight-bold"
        }, " (", item.abbr, ")") : "", ".") : "", /*#__PURE__*/ $acw62.createElement("span", {
            className: metaPrefix ? "ml-1" : ""
        }, (0, $3cdc8a61f42a3ec8$export$42b8cd85fd1c8271)(item.month, item.year, langEn), "."), item.pages ? /*#__PURE__*/ $acw62.createElement("span", {
            className: "ml-1"
        }, "pp. ", item.pages, ".") : ""), /*#__PURE__*/ $acw62.createElement("p", {
            className: "card-text mb-1"
        }, item.projectPage ? /*#__PURE__*/ $acw62.createElement("a", {
            className: "academic-icon fas fa-home",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "project page",
            href: item.projectPage
        }) : "", item.doi ? /*#__PURE__*/ $acw62.createElement("a", {
            className: "academic-icon ai ai-doi-square",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: item.doi,
            href: item.doi
        }) : "", item.paperUrl ? /*#__PURE__*/ $acw62.createElement("a", {
            href: item.paperUrl,
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "paper",
            className: "academic-icon fas fa-sticky-note"
        }) : "", item.github ? /*#__PURE__*/ $acw62.createElement("a", {
            className: "academic-icon fab fa-github",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "code",
            href: item.github
        }) : "", item.speakerdeck ? /*#__PURE__*/ $acw62.createElement("a", {
            className: "academic-icon fab fa-speaker-deck",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "slide",
            href: item.speakerdeck
        }) : "", item.vimeo ? /*#__PURE__*/ $acw62.createElement("a", {
            className: "academic-icon fab fa-vimeo",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "demo movie",
            href: item.vimeo
        }) : "", item.youtube ? /*#__PURE__*/ $acw62.createElement("a", {
            className: "academic-icon fab fa-youtube",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "YouTube",
            href: item.youtube
        }) : "", item.blog ? /*#__PURE__*/ $acw62.createElement("a", {
            className: "academic-icon icon-newspaper-o",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "blog",
            href: (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.blog, langEn)
        }) : "", $8ae5ba1dd1f7f89a$var$canGenerateBibtex(item) ? /*#__PURE__*/ $acw62.createElement("a", {
            className: "academic-icon fas fa-quote-right",
            onClick: (e)=>{
                e.preventDefault();
                const bibtex = (0, $3cdc8a61f42a3ec8$export$ece7058721307118)(item, langEn);
                if (!bibtex) return;
                $8ae5ba1dd1f7f89a$var$copyText(e, bibtex);
            },
            href: "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "copy bibtex"
        }) : ""), /*#__PURE__*/ $acw62.createElement("p", {
            className: "card-text mb-0"
        }, item.others ? /*#__PURE__*/ $acw62.createElement("small", null, /*#__PURE__*/ $acw62.createElement("em", null, /*#__PURE__*/ $acw62.createElement("span", {
            dangerouslySetInnerHTML: {
                __html: (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.others, langEn)
            }
        }))) : "")))));
    })));
};
var $8ae5ba1dd1f7f89a$export$2e2bcd8739ae039 = $8ae5ba1dd1f7f89a$var$Papers;




const $532644a64a992abb$var$Publication = ()=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    const publications = (0, $89618bfaa27a1d5d$export$c379b13c1521865e).publications ?? [];
    const papers = publications.filter((item)=>item.kind !== "patent" && item.kind !== "book" && item.kind !== "dissertation").sort((a, b)=>{
        const ap = a.priority ?? 0;
        const bp = b.priority ?? 0;
        if (ap !== bp) return bp - ap;
        if (a.year !== b.year) return (b.year ?? 0) - (a.year ?? 0);
        if (a.month !== b.month) return (b.month ?? 0) - (a.month ?? 0);
        return 0;
    });
    const books = publications.filter((item)=>item.kind === "book");
    const dissertations = publications.filter((item)=>item.kind === "dissertation");
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: "publication",
        className: "container justify-content-center"
    }, /*#__PURE__*/ $acw62.createElement("p", {
        className: "title mb-2"
    }, /*#__PURE__*/ $acw62.createElement("span", {
        className: "mr-2"
    }, langEn ? "Publication" : "\u696D\u7E3E"), /*#__PURE__*/ $acw62.createElement("br", {
        className: "d-block d-sm-none"
    }), (0, $89618bfaa27a1d5d$export$623b44a0e7f71454).map((item, i)=>/*#__PURE__*/ $acw62.createElement("a", {
            key: "academic-link" + i,
            href: item.url,
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: item.name,
            className: "academic-icon ai ai-" + item.icon + "-square"
        }))), /*#__PURE__*/ $acw62.createElement("div", {
        className: "row"
    }, /*#__PURE__*/ $acw62.createElement((0, $8ae5ba1dd1f7f89a$export$2e2bcd8739ae039), {
        items: papers,
        title_en: "",
        title_ja: "",
        show_num: true,
        comment: "journal: \u2605"
    }), /*#__PURE__*/ $acw62.createElement((0, $8ae5ba1dd1f7f89a$export$2e2bcd8739ae039), {
        items: dissertations,
        title_en: "Ph.D. Dissertation",
        title_ja: "\u535A\u58EB\u8AD6\u6587"
    }), /*#__PURE__*/ $acw62.createElement((0, $8ae5ba1dd1f7f89a$export$2e2bcd8739ae039), {
        items: books,
        title_en: "Book",
        title_ja: "\u672C"
    })));
};
var $532644a64a992abb$export$2e2bcd8739ae039 = $532644a64a992abb$var$Publication;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


const $8df0733567a4ce87$var$Talks = ({ items: items, title_en: title_en, title_ja: title_ja, item_nums: item_nums })=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    const [expanded, setExpanded] = $acw62.useState(false);
    const title = langEn ? title_en : title_ja;
    const sortByPriorityYearMonthDesc = $acw62.useCallback((a, b)=>{
        const ap = a.priority ?? 0;
        const bp = b.priority ?? 0;
        if (ap !== bp) return bp - ap;
        if (a.year !== b.year) return (b.year ?? 0) - (a.year ?? 0);
        if (a.month !== b.month) return (b.month ?? 0) - (a.month ?? 0);
        return 0;
    }, []);
    const yearSortedItems = $acw62.useMemo(()=>items.slice().sort((a, b)=>{
            if (a.year !== b.year) return (b.year ?? 0) - (a.year ?? 0);
            if (a.month !== b.month) return (b.month ?? 0) - (a.month ?? 0);
            return 0;
        }), [
        items
    ]);
    const selectedItems = $acw62.useMemo(()=>items.filter((item)=>item.selected).sort(sortByPriorityYearMonthDesc), [
        items,
        sortByPriorityYearMonthDesc
    ]);
    const collapsedItems = $acw62.useMemo(()=>{
        if (selectedItems.length > 0) return selectedItems;
        if (!item_nums) return yearSortedItems;
        const highlighted = items.filter((item)=>(item.priority ?? 0) > 0).sort(sortByPriorityYearMonthDesc);
        const merged = [
            ...highlighted
        ];
        for (const item of yearSortedItems){
            if (merged.includes(item)) continue;
            merged.push(item);
        }
        return merged.slice(0, item_nums);
    }, [
        item_nums,
        items,
        selectedItems,
        sortByPriorityYearMonthDesc,
        yearSortedItems
    ]);
    const displayItems = expanded ? yearSortedItems : collapsedItems;
    const showToggle = yearSortedItems.length > collapsedItems.length;
    const toggle = ()=>setExpanded((prev)=>!prev);
    const isSelectedMode = !expanded && selectedItems.length > 0;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: "col-md-12 mb-2"
    }, title ? /*#__PURE__*/ $acw62.createElement("p", {
        className: "sub-title"
    }, title) : "", isSelectedMode ? /*#__PURE__*/ $acw62.createElement("p", {
        className: "h5 mb-1"
    }, langEn ? "Selected" : "Selected") : "", /*#__PURE__*/ $acw62.createElement("ul", {
        className: "mb-0"
    }, displayItems.map((item, i)=>/*#__PURE__*/ $acw62.createElement("li", {
            className: "mb-1",
            key: i
        }, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.title, langEn), item.month ? /*#__PURE__*/ $acw62.createElement("span", {
            className: "mr-2"
        }, " (", (0, $3cdc8a61f42a3ec8$export$42b8cd85fd1c8271)(item.month, item.year, langEn), ")") : "", item.url ? /*#__PURE__*/ $acw62.createElement("a", {
            href: (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.url, langEn),
            className: "academic-icon fas fa-home",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "website"
        }) : "", item.speakerdeck ? /*#__PURE__*/ $acw62.createElement("a", {
            className: "academic-icon fab fa-speaker-deck",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "slide",
            href: item.speakerdeck
        }) : "", item.talk ? /*#__PURE__*/ $acw62.createElement("a", {
            href: item.talk,
            className: "academic-icon fas fa-video",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "recording"
        }) : "", /*#__PURE__*/ $acw62.createElement("br", null), /*#__PURE__*/ $acw62.createElement("small", null, (0, $3cdc8a61f42a3ec8$export$d05a211c0a2dda4e)(item, langEn)), item.others ? /*#__PURE__*/ $acw62.createElement("small", null, /*#__PURE__*/ $acw62.createElement("br", null), /*#__PURE__*/ $acw62.createElement("em", null, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.others, langEn))) : "")), showToggle && !expanded ? /*#__PURE__*/ $acw62.createElement("a", {
        href: "",
        onClick: (e)=>{
            e.preventDefault();
            toggle();
        }
    }, langEn ? "all \xbb" : "\u5168\u4EF6 \xbb") : "", showToggle && expanded ? /*#__PURE__*/ $acw62.createElement("a", {
        href: "",
        onClick: (e)=>{
            e.preventDefault();
            toggle();
        }
    }, langEn ? "\xab close" : "\xab \u9589\u3058\u308B") : ""));
};
var $8df0733567a4ce87$export$2e2bcd8739ae039 = $8df0733567a4ce87$var$Talks;




const $340a532e8fc3b6a3$var$TalksSection = ()=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: "talks",
        className: "container justify-content-center"
    }, /*#__PURE__*/ $acw62.createElement("p", {
        className: "title mb-2"
    }, langEn ? "Invited Talks and Seminars" : "\u62DB\u5F85\u8B1B\u6F14\u30FB\u30BB\u30DF\u30CA\u30FC"), /*#__PURE__*/ $acw62.createElement("div", {
        className: "row"
    }, /*#__PURE__*/ $acw62.createElement((0, $8df0733567a4ce87$export$2e2bcd8739ae039), {
        items: (0, $89618bfaa27a1d5d$export$9624c2b57a2e6db)
    })));
};
var $340a532e8fc3b6a3$export$2e2bcd8739ae039 = $340a532e8fc3b6a3$var$TalksSection;



var $acw62 = parcelRequire("acw62");









const $07fb4c39979d368b$var$Creation = ()=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    const { expanded: expanded, toggle: toggle, isVisible: isVisible } = (0, $d87c4557919c9bca$export$bae1c404c9a98ef6)(5);
    const imageMap = (0, $6a9bfe7e01a5c3e7$export$e6a7fad94b08a6ce)((0, $6a9bfe7e01a5c3e7$export$552dd721d9ff2d3f)((0, (/*@__PURE__*/$parcel$interopDefault($02cff0d0be730940$exports)))), (0, $6a9bfe7e01a5c3e7$export$552dd721d9ff2d3f)((0, (/*@__PURE__*/$parcel$interopDefault($d104cb01362b2ae4$exports)))));
    const renderImage = (imageKey, alt)=>{
        const imageUrl = (0, $6a9bfe7e01a5c3e7$export$c8466dd3c8c19636)(imageMap, imageKey);
        return imageUrl ? /*#__PURE__*/ $acw62.createElement((0, $fea50fe678f1d4ed$exports.LazyLoadImage), {
            src: imageUrl,
            alt: alt ?? "",
            effect: "opacity",
            className: "bd-placeholder-img img-fluid w-100"
        }) : "";
    };
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: "creation",
        className: "container justify-content-center"
    }, /*#__PURE__*/ $acw62.createElement("p", {
        className: "title"
    }, langEn ? "Non Research Projects" : "\u7814\u7A76\u5916\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8"), /*#__PURE__*/ $acw62.createElement("div", {
        className: "row mt-3"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "col-md-12 mb-4"
    }, (0, $89618bfaa27a1d5d$export$2d6e27136d82d944).filter((item, i)=>isVisible(i)).map((item, i)=>/*#__PURE__*/ $acw62.createElement("div", {
            className: "card mb-2 paper",
            key: i
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: "row no-gutters"
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: "col-md-3"
        }, renderImage(item.img, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.title, langEn))), /*#__PURE__*/ $acw62.createElement("div", {
            className: "col-md-9"
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: "card-body pt-2 pb-1"
        }, /*#__PURE__*/ $acw62.createElement("p", {
            className: "card-title mb-1 h6"
        }, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.title, langEn), /*#__PURE__*/ $acw62.createElement("small", {
            className: "ml-2"
        }, "(", (0, $3cdc8a61f42a3ec8$export$42b8cd85fd1c8271)(item.month, item.year, langEn), ")")), /*#__PURE__*/ $acw62.createElement("p", {
            className: "card-text mb-1 small"
        }, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.description, langEn)), /*#__PURE__*/ $acw62.createElement("ul", {
            className: "links mt-0 small"
        }, (item.links ?? []).map((link, i)=>/*#__PURE__*/ $acw62.createElement("li", {
                key: i
            }, /*#__PURE__*/ $acw62.createElement("span", null, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(link.title, langEn)), /*#__PURE__*/ $acw62.createElement("a", {
                href: (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(link.url, langEn),
                className: "ml-1 icon-link",
                "aria-label": (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(link.title, langEn)
            }))))))))), !expanded ? /*#__PURE__*/ $acw62.createElement("a", {
        href: "",
        className: "",
        onClick: (e)=>{
            e.preventDefault();
            toggle();
        }
    }, "more \xbb") : "", expanded ? /*#__PURE__*/ $acw62.createElement("a", {
        href: "",
        onClick: (e)=>{
            e.preventDefault();
            toggle();
        }
    }, "\xab close") : "")));
};
var $07fb4c39979d368b$export$2e2bcd8739ae039 = $07fb4c39979d368b$var$Creation;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


const $833122537340c86c$var$Grants = ({ title_en: title_en, title_ja: title_ja, items: items })=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: "col-md-12"
    }, /*#__PURE__*/ $acw62.createElement("p", {
        className: "sub-title"
    }, langEn ? title_en : title_ja), /*#__PURE__*/ $acw62.createElement("ul", null, items.map((item, i)=>/*#__PURE__*/ $acw62.createElement("li", {
            key: i
        }, /*#__PURE__*/ $acw62.createElement("p", {
            className: "mb-1"
        }, (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.term, langEn), /*#__PURE__*/ $acw62.createElement("span", null, " : "), (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.name, langEn), item.url ? /*#__PURE__*/ $acw62.createElement("a", {
            href: (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.url, langEn),
            className: "ml-2 icon-link"
        }) : "", /*#__PURE__*/ $acw62.createElement("br", null), (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.description, langEn))))));
};
var $833122537340c86c$export$2e2bcd8739ae039 = $833122537340c86c$var$Grants;




const $cd5b9679acd24d88$var$Award = ()=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: "award",
        className: "container justify-content-center"
    }, /*#__PURE__*/ $acw62.createElement("p", {
        className: "title"
    }, langEn ? "Awards and Honors" : "\u53D7\u8CDE / \u7AF6\u4E89\u7684\u8CC7\u91D1"), /*#__PURE__*/ $acw62.createElement("div", {
        className: "row text-left"
    }, /*#__PURE__*/ $acw62.createElement((0, $a065582236961aef$export$2e2bcd8739ae039), {
        items: (0, $89618bfaa27a1d5d$export$2f1a9429a30437b6).academicAwards,
        title_en: "Academic Awards",
        title_ja: "\u53D7\u8CDE"
    }), /*#__PURE__*/ $acw62.createElement((0, $833122537340c86c$export$2e2bcd8739ae039), {
        items: (0, $89618bfaa27a1d5d$export$2f1a9429a30437b6).grant,
        title_en: "Grants / Fellowship / Scholarship",
        title_ja: "\u7AF6\u4E89\u7684\u8CC7\u91D1 / \u30D5\u30A7\u30ED\u30FC\u30B7\u30C3\u30D7 / \u5968\u5B66\u91D1"
    })));
};
var $cd5b9679acd24d88$export$2e2bcd8739ae039 = $cd5b9679acd24d88$var$Award;



var $acw62 = parcelRequire("acw62");




const $4b43b25578d17310$var$Others = ()=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: "others",
        className: "container justify-content-center mb-3"
    }, /*#__PURE__*/ $acw62.createElement("p", {
        className: "title"
    }, langEn ? "Others" : "\u305D\u306E\u4ED6"), /*#__PURE__*/ $acw62.createElement("div", {
        className: "row text-left"
    }, (0, $89618bfaa27a1d5d$export$a69ae8fa9a769acd).map((item, i)=>/*#__PURE__*/ $acw62.createElement((0, $a065582236961aef$export$2e2bcd8739ae039), {
            key: i,
            items: item.contents,
            title_en: (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.title, true),
            title_ja: (0, $3cdc8a61f42a3ec8$export$ee24d319fa53beb6)(item.title, false)
        }))));
};
var $4b43b25578d17310$export$2e2bcd8739ae039 = $4b43b25578d17310$var$Others;


const $ee826a9071a1fbce$var$Main = ()=>{
    return /*#__PURE__*/ $acw62.createElement("div", null, /*#__PURE__*/ $acw62.createElement((0, $6bea4e8b05121148$export$2e2bcd8739ae039), null), /*#__PURE__*/ $acw62.createElement("section", {
        className: "ftco-section"
    }, /*#__PURE__*/ $acw62.createElement((0, $e9c8f6c781bc0d61$export$2e2bcd8739ae039), null), /*#__PURE__*/ $acw62.createElement((0, $22964412bf4b74bb$export$2e2bcd8739ae039), null), /*#__PURE__*/ $acw62.createElement((0, $c93a2b46b62c23c7$export$2e2bcd8739ae039), null), /*#__PURE__*/ $acw62.createElement((0, $06c35a9ee357c23f$export$2e2bcd8739ae039), null), /*#__PURE__*/ $acw62.createElement((0, $532644a64a992abb$export$2e2bcd8739ae039), null), /*#__PURE__*/ $acw62.createElement((0, $340a532e8fc3b6a3$export$2e2bcd8739ae039), null), /*#__PURE__*/ $acw62.createElement((0, $cd5b9679acd24d88$export$2e2bcd8739ae039), null), /*#__PURE__*/ $acw62.createElement((0, $07fb4c39979d368b$export$2e2bcd8739ae039), null), /*#__PURE__*/ $acw62.createElement((0, $4b43b25578d17310$export$2e2bcd8739ae039), null)));
};
var $ee826a9071a1fbce$export$2e2bcd8739ae039 = $ee826a9071a1fbce$var$Main;



var $acw62 = parcelRequire("acw62");



const $ad41e4cd42be2640$var$Footer = ()=>{
    const { langEn: langEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    const year = new Date().getFullYear();
    return /*#__PURE__*/ $acw62.createElement("footer", {
        className: "ftco-footer ftco-bg-dark footer"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "container pl-5"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "row",
        id: "contact"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "col-md"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "ftco-footer-widget"
    }, /*#__PURE__*/ $acw62.createElement("h2", {
        className: "ftco-heading-2 mb-2"
    }, langEn ? "Contact" : "\u9023\u7D61\u5148"), /*#__PURE__*/ $acw62.createElement("div", {
        className: "block-23 mb-3"
    }, /*#__PURE__*/ $acw62.createElement("ul", null, /*#__PURE__*/ $acw62.createElement("li", null, /*#__PURE__*/ $acw62.createElement("span", {
        className: "icon icon-envelope"
    }), /*#__PURE__*/ $acw62.createElement("span", {
        className: "text email"
    }, (0, $89618bfaa27a1d5d$export$976783c17ab7505a).email))))))), /*#__PURE__*/ $acw62.createElement("div", {
        className: "row"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "col-md-12"
    }, /*#__PURE__*/ $acw62.createElement("p", null, "\xa9", year, " ", (0, $3cdc8a61f42a3ec8$export$4bff874d61454b38), " | This template is made with", " ", /*#__PURE__*/ $acw62.createElement("i", {
        className: "icon-heart",
        "aria-hidden": "true"
    }), " by", " ", /*#__PURE__*/ $acw62.createElement("a", {
        href: "https://colorlib.com",
        target: "_blank",
        rel: "noreferrer"
    }, "Colorlib"))))));
};
var $ad41e4cd42be2640$export$2e2bcd8739ae039 = $ad41e4cd42be2640$var$Footer;



var $acw62 = parcelRequire("acw62");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


var $2a96cca22bca25a2$exports = {};
'use strict';
function $2a96cca22bca25a2$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $acw62 = parcelRequire("acw62");
var $2a96cca22bca25a2$var$React__default = $2a96cca22bca25a2$var$_interopDefault($acw62);
function $2a96cca22bca25a2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2a96cca22bca25a2$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $2a96cca22bca25a2$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $2a96cca22bca25a2$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $2a96cca22bca25a2$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ $2a96cca22bca25a2$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($acw62.PureComponent);
        $2a96cca22bca25a2$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $2a96cca22bca25a2$var$_defineProperty(SideEffect, "canUseDOM", $2a96cca22bca25a2$var$canUseDOM);
        return SideEffect;
    };
}
$2a96cca22bca25a2$exports = $2a96cca22bca25a2$var$withSideEffect;


var $77ddc6be16b1d7de$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== 'undefined';
var $77ddc6be16b1d7de$var$hasMap = typeof Map === 'function';
var $77ddc6be16b1d7de$var$hasSet = typeof Set === 'function';
var $77ddc6be16b1d7de$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $77ddc6be16b1d7de$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($77ddc6be16b1d7de$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$77ddc6be16b1d7de$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($77ddc6be16b1d7de$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($77ddc6be16b1d7de$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$77ddc6be16b1d7de$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$77ddc6be16b1d7de$exports = function isEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");
var $837d879502e60b4b$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $837d879502e60b4b$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $837d879502e60b4b$var$VALID_TAG_NAMES = Object.keys($837d879502e60b4b$var$TAG_NAMES).map(function(name) {
    return $837d879502e60b4b$var$TAG_NAMES[name];
});
var $837d879502e60b4b$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $837d879502e60b4b$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $837d879502e60b4b$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $837d879502e60b4b$var$HTML_TAG_MAP = Object.keys($837d879502e60b4b$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$837d879502e60b4b$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $837d879502e60b4b$var$SELF_CLOSING_TAGS = [
    $837d879502e60b4b$var$TAG_NAMES.NOSCRIPT,
    $837d879502e60b4b$var$TAG_NAMES.SCRIPT,
    $837d879502e60b4b$var$TAG_NAMES.STYLE
];
var $837d879502e60b4b$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $837d879502e60b4b$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $837d879502e60b4b$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $837d879502e60b4b$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $837d879502e60b4b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $837d879502e60b4b$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $837d879502e60b4b$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $837d879502e60b4b$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $837d879502e60b4b$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $837d879502e60b4b$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$TAG_NAMES.TITLE);
    var innermostTemplate = $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $837d879502e60b4b$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $837d879502e60b4b$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $837d879502e60b4b$var$_extends({}, tagAttrs, current);
    }, {});
};
var $837d879502e60b4b$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$837d879502e60b4b$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$837d879502e60b4b$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $837d879502e60b4b$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $837d879502e60b4b$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $837d879502e60b4b$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $837d879502e60b4b$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $837d879502e60b4b$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $837d879502e60b4b$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $837d879502e60b4b$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $837d879502e60b4b$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $837d879502e60b4b$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $837d879502e60b4b$var$getBaseTagFromPropsList([
            $837d879502e60b4b$var$TAG_PROPERTIES.HREF,
            $837d879502e60b4b$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $837d879502e60b4b$var$getAttributesFromPropsList($837d879502e60b4b$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$HELMET_PROPS.DEFER),
        encode: $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $837d879502e60b4b$var$getAttributesFromPropsList($837d879502e60b4b$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $837d879502e60b4b$var$getTagsFromPropsList($837d879502e60b4b$var$TAG_NAMES.LINK, [
            $837d879502e60b4b$var$TAG_PROPERTIES.REL,
            $837d879502e60b4b$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $837d879502e60b4b$var$getTagsFromPropsList($837d879502e60b4b$var$TAG_NAMES.META, [
            $837d879502e60b4b$var$TAG_PROPERTIES.NAME,
            $837d879502e60b4b$var$TAG_PROPERTIES.CHARSET,
            $837d879502e60b4b$var$TAG_PROPERTIES.HTTPEQUIV,
            $837d879502e60b4b$var$TAG_PROPERTIES.PROPERTY,
            $837d879502e60b4b$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $837d879502e60b4b$var$getTagsFromPropsList($837d879502e60b4b$var$TAG_NAMES.NOSCRIPT, [
            $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $837d879502e60b4b$var$getOnChangeClientState(propsList),
        scriptTags: $837d879502e60b4b$var$getTagsFromPropsList($837d879502e60b4b$var$TAG_NAMES.SCRIPT, [
            $837d879502e60b4b$var$TAG_PROPERTIES.SRC,
            $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $837d879502e60b4b$var$getTagsFromPropsList($837d879502e60b4b$var$TAG_NAMES.STYLE, [
            $837d879502e60b4b$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $837d879502e60b4b$var$getTitleFromPropsList(propsList),
        titleAttributes: $837d879502e60b4b$var$getAttributesFromPropsList($837d879502e60b4b$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $837d879502e60b4b$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $837d879502e60b4b$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $837d879502e60b4b$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $837d879502e60b4b$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $837d879502e60b4b$var$rafPolyfill : $parcel$global.requestAnimationFrame || $837d879502e60b4b$var$rafPolyfill;
var $837d879502e60b4b$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $837d879502e60b4b$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $837d879502e60b4b$var$cafPolyfill;
var $837d879502e60b4b$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $837d879502e60b4b$var$_helmetCallback = null;
var $837d879502e60b4b$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($837d879502e60b4b$var$_helmetCallback) $837d879502e60b4b$var$cancelAnimationFrame($837d879502e60b4b$var$_helmetCallback);
    if (newState.defer) $837d879502e60b4b$var$_helmetCallback = $837d879502e60b4b$var$requestAnimationFrame(function() {
        $837d879502e60b4b$var$commitTagChanges(newState, function() {
            $837d879502e60b4b$var$_helmetCallback = null;
        });
    });
    else {
        $837d879502e60b4b$var$commitTagChanges(newState);
        $837d879502e60b4b$var$_helmetCallback = null;
    }
};
var $837d879502e60b4b$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $837d879502e60b4b$var$updateAttributes($837d879502e60b4b$var$TAG_NAMES.BODY, bodyAttributes);
    $837d879502e60b4b$var$updateAttributes($837d879502e60b4b$var$TAG_NAMES.HTML, htmlAttributes);
    $837d879502e60b4b$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.BASE, baseTag),
        linkTags: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.LINK, linkTags),
        metaTags: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.META, metaTags),
        noscriptTags: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $837d879502e60b4b$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $837d879502e60b4b$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $837d879502e60b4b$var$flattenArray(title);
    $837d879502e60b4b$var$updateAttributes($837d879502e60b4b$var$TAG_NAMES.TITLE, attributes);
};
var $837d879502e60b4b$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($837d879502e60b4b$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($837d879502e60b4b$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($837d879502e60b4b$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($837d879502e60b4b$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $837d879502e60b4b$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($837d879502e60b4b$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $837d879502e60b4b$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $837d879502e60b4b$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($837d879502e60b4b$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $837d879502e60b4b$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $837d879502e60b4b$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $837d879502e60b4b$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $837d879502e60b4b$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $837d879502e60b4b$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $837d879502e60b4b$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $837d879502e60b4b$var$HELMET_ATTRIBUTE + "=\"true\">" + $837d879502e60b4b$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $837d879502e60b4b$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML || attribute === $837d879502e60b4b$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $837d879502e60b4b$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $837d879502e60b4b$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $837d879502e60b4b$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $837d879502e60b4b$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$837d879502e60b4b$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $837d879502e60b4b$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$837d879502e60b4b$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $837d879502e60b4b$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$837d879502e60b4b$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $837d879502e60b4b$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($837d879502e60b4b$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $837d879502e60b4b$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$837d879502e60b4b$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $837d879502e60b4b$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $837d879502e60b4b$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, mappedTag);
    });
};
var $837d879502e60b4b$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $837d879502e60b4b$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $837d879502e60b4b$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $837d879502e60b4b$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $837d879502e60b4b$var$ATTRIBUTE_NAMES.BODY:
        case $837d879502e60b4b$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $837d879502e60b4b$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $837d879502e60b4b$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $837d879502e60b4b$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $837d879502e60b4b$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $837d879502e60b4b$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.META, metaTags, encode),
        noscript: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $837d879502e60b4b$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $837d879502e60b4b$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $837d879502e60b4b$var$classCallCheck(this, HelmetWrapper);
            return $837d879502e60b4b$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($77ddc6be16b1d7de$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $837d879502e60b4b$var$TAG_NAMES.SCRIPT:
                case $837d879502e60b4b$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $837d879502e60b4b$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $837d879502e60b4b$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $837d879502e60b4b$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $837d879502e60b4b$var$TAG_NAMES.TITLE:
                    return $837d879502e60b4b$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $837d879502e60b4b$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $837d879502e60b4b$var$TAG_NAMES.BODY:
                    return $837d879502e60b4b$var$_extends({}, newProps, {
                        bodyAttributes: $837d879502e60b4b$var$_extends({}, newChildProps)
                    });
                case $837d879502e60b4b$var$TAG_NAMES.HTML:
                    return $837d879502e60b4b$var$_extends({}, newProps, {
                        htmlAttributes: $837d879502e60b4b$var$_extends({}, newChildProps)
                    });
            }
            return $837d879502e60b4b$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $837d879502e60b4b$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $837d879502e60b4b$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $837d879502e60b4b$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $837d879502e60b4b$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $837d879502e60b4b$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $837d879502e60b4b$var$TAG_NAMES.LINK:
                    case $837d879502e60b4b$var$TAG_NAMES.META:
                    case $837d879502e60b4b$var$TAG_NAMES.NOSCRIPT:
                    case $837d879502e60b4b$var$TAG_NAMES.SCRIPT:
                    case $837d879502e60b4b$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $837d879502e60b4b$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $837d879502e60b4b$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, newProps);
        };
        $837d879502e60b4b$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $837d879502e60b4b$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $837d879502e60b4b$var$NullComponent = function NullComponent() {
    return null;
};
var $837d879502e60b4b$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($2a96cca22bca25a2$exports)))($837d879502e60b4b$var$reducePropsToState, $837d879502e60b4b$var$handleClientStateChange, $837d879502e60b4b$var$mapStateOnServer)($837d879502e60b4b$var$NullComponent);
var $837d879502e60b4b$export$dcef8f9bb9a41431 = $837d879502e60b4b$var$Helmet($837d879502e60b4b$var$HelmetSideEffects);
$837d879502e60b4b$export$dcef8f9bb9a41431.renderStatic = $837d879502e60b4b$export$dcef8f9bb9a41431.rewind;
var $837d879502e60b4b$export$2e2bcd8739ae039 = $837d879502e60b4b$export$dcef8f9bb9a41431;


var $b760fb000afc0121$exports = {};
var $e940b4139095ad05$exports = {};
$e940b4139095ad05$exports = import.meta.resolve("6oCGS");


var $986fddf2aea90a58$exports = {};
$986fddf2aea90a58$exports = import.meta.resolve("hFbyu");


var $cbf2166643f8d984$exports = {};
$cbf2166643f8d984$exports = import.meta.resolve("6Otb9");


var $5cd9e3bfffa377ea$exports = {};
$5cd9e3bfffa377ea$exports = import.meta.resolve("bYKnA");


var $fa2827f891a5ec13$exports = {};
$fa2827f891a5ec13$exports = import.meta.resolve("1Ct5o");


var $7ee80c70c803149f$exports = {};
$7ee80c70c803149f$exports = import.meta.resolve("dA17k");


var $9f2c2f96c8dbeb37$exports = {};
$9f2c2f96c8dbeb37$exports = import.meta.resolve("5aVzq");


var $b9174fa5eadd0a45$exports = {};
$b9174fa5eadd0a45$exports = import.meta.resolve("vcKAl");


var $b94e640061107ae1$exports = {};
$b94e640061107ae1$exports = import.meta.resolve("gBsZd");


var $6170c1069ea67647$exports = {};
$6170c1069ea67647$exports = import.meta.resolve("11wmq");


var $e975f3a20bba22f5$exports = {};
$e975f3a20bba22f5$exports = import.meta.resolve("jVu1g");


var $c796b9f642a8c2ec$exports = {};
$c796b9f642a8c2ec$exports = import.meta.resolve("6JgMt");


var $b71ac18244f6dc6b$exports = {};
$b71ac18244f6dc6b$exports = import.meta.resolve("adLpX");


var $e01ad0b72c6a8e0b$exports = {};
$e01ad0b72c6a8e0b$exports = import.meta.resolve("6vdkl");


$b760fb000afc0121$exports = {
    "android-icon-192x192": $e940b4139095ad05$exports,
    "apple-icon-114x114": $986fddf2aea90a58$exports,
    "apple-icon-120x120": $cbf2166643f8d984$exports,
    "apple-icon-144x144": $5cd9e3bfffa377ea$exports,
    "apple-icon-152x152": $fa2827f891a5ec13$exports,
    "apple-icon-180x180": $7ee80c70c803149f$exports,
    "apple-icon-57x57": $9f2c2f96c8dbeb37$exports,
    "apple-icon-60x60": $b9174fa5eadd0a45$exports,
    "apple-icon-72x72": $b94e640061107ae1$exports,
    "apple-icon-76x76": $6170c1069ea67647$exports,
    "favicon-16x16": $e975f3a20bba22f5$exports,
    "favicon-32x32": $c796b9f642a8c2ec$exports,
    "favicon-96x96": $b71ac18244f6dc6b$exports,
    "ms-icon-144x144": $e01ad0b72c6a8e0b$exports
};



const $0939b9f1d3ed1264$var$Favicon = ()=>{
    return /*#__PURE__*/ $acw62.createElement((0, $837d879502e60b4b$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $acw62.createElement("link", {
        rel: "apple-touch-icon",
        sizes: "57x57",
        href: (0, $6a9bfe7e01a5c3e7$export$c60880f504524a89)((0, (/*@__PURE__*/$parcel$interopDefault($b760fb000afc0121$exports)))["apple-icon-57x57"])
    }), /*#__PURE__*/ $acw62.createElement("link", {
        rel: "apple-touch-icon",
        sizes: "60x60",
        href: (0, $6a9bfe7e01a5c3e7$export$c60880f504524a89)((0, (/*@__PURE__*/$parcel$interopDefault($b760fb000afc0121$exports)))["apple-icon-60x60"])
    }), /*#__PURE__*/ $acw62.createElement("link", {
        rel: "apple-touch-icon",
        sizes: "72x72",
        href: (0, $6a9bfe7e01a5c3e7$export$c60880f504524a89)((0, (/*@__PURE__*/$parcel$interopDefault($b760fb000afc0121$exports)))["apple-icon-72x72"])
    }), /*#__PURE__*/ $acw62.createElement("link", {
        rel: "apple-touch-icon",
        sizes: "76x76",
        href: (0, $6a9bfe7e01a5c3e7$export$c60880f504524a89)((0, (/*@__PURE__*/$parcel$interopDefault($b760fb000afc0121$exports)))["apple-icon-76x76"])
    }), /*#__PURE__*/ $acw62.createElement("link", {
        rel: "apple-touch-icon",
        sizes: "114x114",
        href: (0, $6a9bfe7e01a5c3e7$export$c60880f504524a89)((0, (/*@__PURE__*/$parcel$interopDefault($b760fb000afc0121$exports)))["apple-icon-114x114"])
    }), /*#__PURE__*/ $acw62.createElement("link", {
        rel: "apple-touch-icon",
        sizes: "120x120",
        href: (0, $6a9bfe7e01a5c3e7$export$c60880f504524a89)((0, (/*@__PURE__*/$parcel$interopDefault($b760fb000afc0121$exports)))["apple-icon-120x120"])
    }), /*#__PURE__*/ $acw62.createElement("link", {
        rel: "apple-touch-icon",
        sizes: "144x144",
        href: (0, $6a9bfe7e01a5c3e7$export$c60880f504524a89)((0, (/*@__PURE__*/$parcel$interopDefault($b760fb000afc0121$exports)))["apple-icon-144x144"])
    }), /*#__PURE__*/ $acw62.createElement("link", {
        rel: "apple-touch-icon",
        sizes: "152x152",
        href: (0, $6a9bfe7e01a5c3e7$export$c60880f504524a89)((0, (/*@__PURE__*/$parcel$interopDefault($b760fb000afc0121$exports)))["apple-icon-152x152"])
    }), /*#__PURE__*/ $acw62.createElement("link", {
        rel: "apple-touch-icon",
        sizes: "180x180",
        href: (0, $6a9bfe7e01a5c3e7$export$c60880f504524a89)((0, (/*@__PURE__*/$parcel$interopDefault($b760fb000afc0121$exports)))["apple-icon-180x180"])
    }), /*#__PURE__*/ $acw62.createElement("link", {
        rel: "icon",
        type: "image/png",
        sizes: "192x192",
        href: (0, $6a9bfe7e01a5c3e7$export$c60880f504524a89)((0, (/*@__PURE__*/$parcel$interopDefault($b760fb000afc0121$exports)))["android-icon-192x192"])
    }), /*#__PURE__*/ $acw62.createElement("link", {
        rel: "icon",
        type: "image/png",
        sizes: "32x32",
        href: (0, $6a9bfe7e01a5c3e7$export$c60880f504524a89)((0, (/*@__PURE__*/$parcel$interopDefault($b760fb000afc0121$exports)))["favicon-32x32"])
    }), /*#__PURE__*/ $acw62.createElement("link", {
        rel: "icon",
        type: "image/png",
        sizes: "96x96",
        href: (0, $6a9bfe7e01a5c3e7$export$c60880f504524a89)((0, (/*@__PURE__*/$parcel$interopDefault($b760fb000afc0121$exports)))["favicon-96x96"])
    }), /*#__PURE__*/ $acw62.createElement("link", {
        rel: "icon",
        type: "image/png",
        sizes: "16x16",
        href: (0, $6a9bfe7e01a5c3e7$export$c60880f504524a89)((0, (/*@__PURE__*/$parcel$interopDefault($b760fb000afc0121$exports)))["favicon-16x16"])
    }), /*#__PURE__*/ $acw62.createElement("meta", {
        name: "msapplication-TileColor",
        content: "#ffffff"
    }), /*#__PURE__*/ $acw62.createElement("meta", {
        name: "msapplication-TileImage",
        content: (0, $6a9bfe7e01a5c3e7$export$c60880f504524a89)((0, (/*@__PURE__*/$parcel$interopDefault($b760fb000afc0121$exports)))["ms-icon-144x144"])
    }), /*#__PURE__*/ $acw62.createElement("meta", {
        name: "theme-color",
        content: "#ffffff"
    }));
};
var $0939b9f1d3ed1264$export$2e2bcd8739ae039 = $0939b9f1d3ed1264$var$Favicon;






const $d6a1ae4bf4370ca8$var$App = ()=>{
    const { langEn: langEn, setLangEn: setLangEn } = (0, $4abb03b3e6419d50$export$b24a004ee43dce44)();
    const [isLoading, setIsLoading] = $acw62.useState(true);
    const [isNavOpen, setIsNavOpen] = $acw62.useState(false);
    const handleLangSwitchClick = ()=>{
        setLangEn((prev)=>!prev);
    };
    const closeNav = ()=>{
        setIsNavOpen(false);
    };
    $acw62.useEffect(()=>{
        const finishLoading = ()=>{
            window.setTimeout(()=>setIsLoading(false), 300);
        };
        if (document.readyState === "complete") {
            finishLoading();
            return;
        }
        window.addEventListener("load", finishLoading, {
            once: true
        });
        return ()=>{
            window.removeEventListener("load", finishLoading);
        };
    }, []);
    $acw62.useEffect(()=>{
        document.body.classList.toggle("offcanvas", isNavOpen);
        return ()=>{
            document.body.classList.remove("offcanvas");
        };
    }, [
        isNavOpen
    ]);
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: "colorlib-page"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        id: "app-loading",
        className: isLoading ? "is-active" : "",
        "aria-hidden": !isLoading
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "spinner"
    })), /*#__PURE__*/ $acw62.createElement((0, $0939b9f1d3ed1264$export$2e2bcd8739ae039), null), /*#__PURE__*/ $acw62.createElement((0, $837d879502e60b4b$export$dcef8f9bb9a41431), null, /*#__PURE__*/ $acw62.createElement("title", null, (0, $3cdc8a61f42a3ec8$export$4bff874d61454b38) + " | " + (0, $3cdc8a61f42a3ec8$export$12a09de97362d322)), /*#__PURE__*/ $acw62.createElement("meta", {
        content: (0, $89618bfaa27a1d5d$export$976783c17ab7505a).pageDescription,
        name: "description"
    }), /*#__PURE__*/ $acw62.createElement("meta", {
        content: (0, $89618bfaa27a1d5d$export$976783c17ab7505a).pageKeywords,
        name: "keywords"
    })), /*#__PURE__*/ $acw62.createElement("a", {
        href: "#",
        className: `js-colorlib-nav-toggle colorlib-nav-toggle${isNavOpen ? " active" : ""}`,
        "aria-controls": "colorlib-aside",
        "aria-expanded": isNavOpen,
        onClick: (e)=>{
            e.preventDefault();
            setIsNavOpen((prev)=>!prev);
        }
    }, /*#__PURE__*/ $acw62.createElement("i", null)), /*#__PURE__*/ $acw62.createElement((0, $3e391071d873e97e$export$2e2bcd8739ae039), {
        onNavigate: closeNav
    }), /*#__PURE__*/ $acw62.createElement((0, $a79abc605320dbc3$export$2e2bcd8739ae039), null), /*#__PURE__*/ $acw62.createElement("div", {
        id: "colorlib-main"
    }, /*#__PURE__*/ $acw62.createElement((0, $ee826a9071a1fbce$export$2e2bcd8739ae039), null), /*#__PURE__*/ $acw62.createElement((0, $ad41e4cd42be2640$export$2e2bcd8739ae039), null)), /*#__PURE__*/ $acw62.createElement("div", {
        id: "lang-switch-btn",
        role: "group",
        "aria-label": "Language switch",
        onClick: handleLangSwitchClick
    }, /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        className: `lang-option${langEn ? " selected" : ""}`,
        "aria-pressed": langEn
    }, "EN"), /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        className: `lang-option${langEn ? "" : " selected"}`,
        "aria-pressed": !langEn
    }, "JP")));
};
var $d6a1ae4bf4370ca8$export$2e2bcd8739ae039 = $d6a1ae4bf4370ca8$var$App;



// rendering
(0, $1u0KT.render)(/*#__PURE__*/ $acw62.createElement((0, $4abb03b3e6419d50$export$b78e4fb81d317543), null, /*#__PURE__*/ $acw62.createElement((0, $d6a1ae4bf4370ca8$export$2e2bcd8739ae039), null)), document.querySelector("#root"));


//# sourceMappingURL=Kei18.github.io.58453eb3.js.map
